export const Typedevision = [
    { value: '', label: '' },
    { value: 'VL', label: 'VL' },
    { value: 'VP', label: 'VP' },
    { value: 'Progressif', label: 'Progressif' },
    { value: 'Degressif', label: 'Degressif' },
    { value: 'ZenView', label: 'ZenView' },
    { value: 'Bifocal', label: 'Bifocal' },
];
export const Typedepanier = [
    { value: '', label: '' },
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
    { value: 'Mixte Monture A', label: 'Mixte Monture A' },
    { value: 'Mixte Verre A', label: 'Mixte Verre A' },
    { value: 'Sans Panier', label: 'Sans Panier' },
];
export const TiersPayant = [
    { value: '', label: '' },
    { value: 'TP', label: 'TP' },
    { value: 'Sans TP', label: 'Sans TP' },
    { value: 'Sans Mutuelle', label: 'Sans Mutuelle' },
];
export const Typeofpayment = [
    { value: '', label: '' },
    { value: 'Alma', label: 'Alma' },
    { value: 'CB', label: 'CB' },
    { value: 'Cheque', label: 'Cheque' },
    { value: 'ESP', label: 'ESP' },
    { value: 'Envoi Sum up', label: 'Envoi Sum up' },
];
/////////////////////////////Colour////////////////////////
export const colorA1 = [
    { value: '', label: '' },
    {
        value: 'Teinte Unie Grey 85% - 0.00 €',
        label: 'Teinte Unie Grey 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Grey 75% - 0.00 €',
        label: 'Teinte Unie Grey 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Grey 50% - 0.00 €',
        label: 'Teinte Unie Grey 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Grey 25% - 0.00 €',
        label: 'Teinte Unie Grey 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Grey 10% - 0.00 €',
        label: 'Teinte Unie Grey 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Brown 85% - 0.00 €',
        label: 'Teinte Unie Brown 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Brown 75% - 0.00 €',
        label: 'Teinte Unie Brown 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Brown 50% - 0.00 €',
        label: 'Teinte Unie Brown 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Brown 25% - 0.00 €',
        label: 'Teinte Unie Brown 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Brown 10% - 0.00 €',
        label: 'Teinte Unie Brown 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie G15 85% - 0.00 €',
        label: 'Teinte Unie G15 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie G15 75% - 0.00 €',
        label: 'Teinte Unie G15 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie G15 50% - 0.00 €',
        label: 'Teinte Unie G15 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie G15 25% - 0.00 €',
        label: 'Teinte Unie G15 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie G15 10% - 0.00 €',
        label: 'Teinte Unie G15 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Blue 85% - 0.00 €',
        label: 'Teinte Unie Blue 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Blue 75% - 0.00 €',
        label: 'Teinte Unie Blue 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Blue 50% - 0.00 €',
        label: 'Teinte Unie Blue 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Blue 25% - 0.00 €',
        label: 'Teinte Unie Blue 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Blue 10% - 0.00 €',
        label: 'Teinte Unie Blue 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Yellow 85% - 0.00 €',
        label: 'Teinte Unie Yellow 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Yellow 75% - 0.00 €',
        label: 'Teinte Unie Yellow 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Yellow 50% - 0.00 €',
        label: 'Teinte Unie Yellow 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Yellow 25% - 0.00 €',
        label: 'Teinte Unie Yellow 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Yellow 10% - 0.00 €',
        label: 'Teinte Unie Yellow 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Pink 85% - 0.00 €',
        label: 'Teinte Unie Pink 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Pink 75% - 0.00 €',
        label: 'Teinte Unie Pink 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Pink 50% - 0.00 €',
        label: 'Teinte Unie Pink 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Pink 25% - 0.00 €',
        label: 'Teinte Unie Pink 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Pink 10% - 0.00 €',
        label: 'Teinte Unie Pink 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Purple 85% - 0.00 €',
        label: 'Teinte Unie Purple 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Purple 75% - 0.00 €',
        label: 'Teinte Unie Purple 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Purple 50% - 0.00 €',
        label: 'Teinte Unie Purple 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Purple 25% - 0.00 €',
        label: 'Teinte Unie Purple 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Purple 10% - 0.00 €',
        label: 'Teinte Unie Purple 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Black 85% - 0.00 €',
        label: 'Teinte Unie Black 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Black 75% - 0.00 €',
        label: 'Teinte Unie Black 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Black 50% - 0.00 €',
        label: 'Teinte Unie Black 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Black 25% - 0.00 €',
        label: 'Teinte Unie Black 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Black 10% - 0.00 €',
        label: 'Teinte Unie Black 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Amber 85% - 0.00 €',
        label: 'Teinte Unie Amber 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Amber 75% - 0.00 €',
        label: 'Teinte Unie Amber 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Amber 50% - 0.00 €',
        label: 'Teinte Unie Amber 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Amber 25% - 0.00 €',
        label: 'Teinte Unie Amber 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Amber 10% - 0.00 €',
        label: 'Teinte Unie Amber 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Rose 85% - 0.00 €',
        label: 'Teinte Unie Rose 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Rose 75% - 0.00 €',
        label: 'Teinte Unie Rose 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Rose 50% - 0.00 €',
        label: 'Teinte Unie Rose 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Rose 25% - 0.00 €',
        label: 'Teinte Unie Rose 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Rose 10% - 0.00 €',
        label: 'Teinte Unie Rose 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Champagne 85% - 0.00 €',
        label: 'Teinte Unie Champagne 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Champagne 75% - 0.00 €',
        label: 'Teinte Unie Champagne 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Champagne 50% - 0.00 €',
        label: 'Teinte Unie Champagne 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Champagne 25% - 0.00 €',
        label: 'Teinte Unie Champagne 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Champagne 10% - 0.00 €',
        label: 'Teinte Unie Champagne 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Orange 85% - 0.00 €',
        label: 'Teinte Unie Orange 85% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Orange 75% - 0.00 €',
        label: 'Teinte Unie Orange 75% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Orange 50% - 0.00 €',
        label: 'Teinte Unie Orange 50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Orange 25% - 0.00 €',
        label: 'Teinte Unie Orange 25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Unie Orange 10% - 0.00 €',
        label: 'Teinte Unie Orange 10% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 85%-0% - 0.00 €',
        label: 'Teinte Deg Grey 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 50%-0% - 0.00 €',
        label: 'Teinte Deg Grey 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 25%-0% - 0.00 €',
        label: 'Teinte Deg Grey 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 85%-25% - 0.00 €',
        label: 'Teinte Deg Grey 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 50%-25% - 0.00 €',
        label: 'Teinte Deg Grey 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Grey 85%-50% - 0.00 €',
        label: 'Teinte Deg Grey 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 85%-0% - 0.00 €',
        label: 'Teinte Deg Brown 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 50%-0% - 0.00 €',
        label: 'Teinte Deg Brown 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 25%-0% - 0.00 €',
        label: 'Teinte Deg Brown 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 85%-25% - 0.00 €',
        label: 'Teinte Deg Brown 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 50%-25% - 0.00 €',
        label: 'Teinte Deg Brown 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Brown 85%-50% - 0.00 €',
        label: 'Teinte Deg Brown 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 85%-0% - 0.00 €',
        label: 'Teinte Deg G15 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 50%-0% - 0.00 €',
        label: 'Teinte Deg G15 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 25%-0% - 0.00 €',
        label: 'Teinte Deg G15 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 85%-25% - 0.00 €',
        label: 'Teinte Deg G15 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 50%-25% - 0.00 €',
        label: 'Teinte Deg G15 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg G15 85%-50% - 0.00 €',
        label: 'Teinte Deg G15 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 85%-0% - 0.00 €',
        label: 'Teinte Deg Blue 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 50%-0% - 0.00 €',
        label: 'Teinte Deg Blue 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 25%-0% - 0.00 €',
        label: 'Teinte Deg Blue 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 85%-25% - 0.00 €',
        label: 'Teinte Deg Blue 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 50%-25% - 0.00 €',
        label: 'Teinte Deg Blue 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Blue 85%-50% - 0.00 €',
        label: 'Teinte Deg Blue 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 85%-0% - 0.00 €',
        label: 'Teinte Deg Yellow 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 50%-0% - 0.00 €',
        label: 'Teinte Deg Yellow 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 25%-0% - 0.00 €',
        label: 'Teinte Deg Yellow 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 85%-25% - 0.00 €',
        label: 'Teinte Deg Yellow 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 50%-25% - 0.00 €',
        label: 'Teinte Deg Yellow 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Yellow 85%-50% - 0.00 €',
        label: 'Teinte Deg Yellow 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 85%-0% - 0.00 €',
        label: 'Teinte Deg Pink 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 50%-0% - 0.00 €',
        label: 'Teinte Deg Pink 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 25%-0% - 0.00 €',
        label: 'Teinte Deg Pink 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 85%-25% - 0.00 €',
        label: 'Teinte Deg Pink 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 50%-25% - 0.00 €',
        label: 'Teinte Deg Pink 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Pink 85%-50% - 0.00 €',
        label: 'Teinte Deg Pink 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 85%-0% - 0.00 €',
        label: 'Teinte Deg Purple 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 50%-0% - 0.00 €',
        label: 'Teinte Deg Purple 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 25%-0% - 0.00 €',
        label: 'Teinte Deg Purple 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 85%-25% - 0.00 €',
        label: 'Teinte Deg Purple 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 50%-25% - 0.00 €',
        label: 'Teinte Deg Purple 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Purple 85%-50% - 0.00 €',
        label: 'Teinte Deg Purple 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 85%-0% - 0.00 €',
        label: 'Teinte Deg Black 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 50%-0% - 0.00 €',
        label: 'Teinte Deg Black 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 25%-0% - 0.00 €',
        label: 'Teinte Deg Black 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 85%-25% - 0.00 €',
        label: 'Teinte Deg Black 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 50%-25% - 0.00 €',
        label: 'Teinte Deg Black 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Black 85%-50% - 0.00 €',
        label: 'Teinte Deg Black 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 85%-0% - 0.00 €',
        label: 'Teinte Deg Amber 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 50%-0% - 0.00 €',
        label: 'Teinte Deg Amber 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 25%-0% - 0.00 €',
        label: 'Teinte Deg Amber 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 85%-25% - 0.00 €',
        label: 'Teinte Deg Amber 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 50%-25% - 0.00 €',
        label: 'Teinte Deg Amber 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Amber 85%-50% - 0.00 €',
        label: 'Teinte Deg Amber 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 85%-0% - 0.00 €',
        label: 'Teinte Deg Rose 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 50%-0% - 0.00 €',
        label: 'Teinte Deg Rose 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 25%-0% - 0.00 €',
        label: 'Teinte Deg Rose 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 85%-25% - 0.00 €',
        label: 'Teinte Deg Rose 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 50%-25% - 0.00 €',
        label: 'Teinte Deg Rose 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Rose 85%-50% - 0.00 €',
        label: 'Teinte Deg Rose 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 85%-0% - 0.00 €',
        label: 'Teinte Deg Champagne 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 50%-0% - 0.00 €',
        label: 'Teinte Deg Champagne 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 25%-0% - 0.00 €',
        label: 'Teinte Deg Champagne 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 85%-25% - 0.00 €',
        label: 'Teinte Deg Champagne 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 50%-25% - 0.00 €',
        label: 'Teinte Deg Champagne 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Champagne 85%-50% - 0.00 €',
        label: 'Teinte Deg Champagne 85%-50% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 85%-0% - 0.00 €',
        label: 'Teinte Deg Orange 85%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 50%-0% - 0.00 €',
        label: 'Teinte Deg Orange 50%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 25%-0% - 0.00 €',
        label: 'Teinte Deg Orange 25%-0% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 85%-25% - 0.00 €',
        label: 'Teinte Deg Orange 85%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 50%-25% - 0.00 €',
        label: 'Teinte Deg Orange 50%-25% - N/A',
        isDisabled: true,
    },
    {
        value: 'Teinte Deg Orange 85%-50% - 0.00 €',
        label: 'Teinte Deg Orange 85%-50% - N/A',
        isDisabled: true,
    },
];
export const colorA2 = [
    { value: '', label: '' },
    {
        value: 'Teinte Unie Grey 85% - 15.00 €',
        label: 'Teinte Unie Grey 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Grey 75% - 15.00 €',
        label: 'Teinte Unie Grey 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Grey 50% - 15.00 €',
        label: 'Teinte Unie Grey 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Grey 25% - 15.00 €',
        label: 'Teinte Unie Grey 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Grey 10% - 15.00 €',
        label: 'Teinte Unie Grey 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Brown 85% - 15.00 €',
        label: 'Teinte Unie Brown 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Brown 75% - 15.00 €',
        label: 'Teinte Unie Brown 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Brown 50% - 15.00 €',
        label: 'Teinte Unie Brown 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Brown 25% - 15.00 €',
        label: 'Teinte Unie Brown 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Brown 10% - 15.00 €',
        label: 'Teinte Unie Brown 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie G15 85% - 15.00 €',
        label: 'Teinte Unie G15 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie G15 75% - 15.00 €',
        label: 'Teinte Unie G15 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie G15 50% - 15.00 €',
        label: 'Teinte Unie G15 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie G15 25% - 15.00 €',
        label: 'Teinte Unie G15 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie G15 10% - 15.00 €',
        label: 'Teinte Unie G15 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Blue 85% - 15.00 €',
        label: 'Teinte Unie Blue 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Blue 75% - 15.00 €',
        label: 'Teinte Unie Blue 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Blue 50% - 15.00 €',
        label: 'Teinte Unie Blue 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Blue 25% - 15.00 €',
        label: 'Teinte Unie Blue 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Blue 10% - 15.00 €',
        label: 'Teinte Unie Blue 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Yellow 85% - 15.00 €',
        label: 'Teinte Unie Yellow 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Yellow 75% - 15.00 €',
        label: 'Teinte Unie Yellow 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Yellow 50% - 15.00 €',
        label: 'Teinte Unie Yellow 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Yellow 25% - 15.00 €',
        label: 'Teinte Unie Yellow 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Yellow 10% - 15.00 €',
        label: 'Teinte Unie Yellow 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Pink 85% - 15.00 €',
        label: 'Teinte Unie Pink 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Pink 75% - 15.00 €',
        label: 'Teinte Unie Pink 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Pink 50% - 15.00 €',
        label: 'Teinte Unie Pink 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Pink 25% - 15.00 €',
        label: 'Teinte Unie Pink 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Pink 10% - 15.00 €',
        label: 'Teinte Unie Pink 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Purple 85% - 15.00 €',
        label: 'Teinte Unie Purple 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Purple 75% - 15.00 €',
        label: 'Teinte Unie Purple 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Purple 50% - 15.00 €',
        label: 'Teinte Unie Purple 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Purple 25% - 15.00 €',
        label: 'Teinte Unie Purple 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Purple 10% - 15.00 €',
        label: 'Teinte Unie Purple 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Black 85% - 15.00 €',
        label: 'Teinte Unie Black 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Black 75% - 15.00 €',
        label: 'Teinte Unie Black 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Black 50% - 15.00 €',
        label: 'Teinte Unie Black 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Black 25% - 15.00 €',
        label: 'Teinte Unie Black 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Black 10% - 15.00 €',
        label: 'Teinte Unie Black 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Amber 85% - 15.00 €',
        label: 'Teinte Unie Amber 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Amber 75% - 15.00 €',
        label: 'Teinte Unie Amber 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Amber 50% - 15.00 €',
        label: 'Teinte Unie Amber 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Amber 25% - 15.00 €',
        label: 'Teinte Unie Amber 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Amber 10% - 15.00 €',
        label: 'Teinte Unie Amber 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Rose 85% - 15.00 €',
        label: 'Teinte Unie Rose 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Rose 75% - 15.00 €',
        label: 'Teinte Unie Rose 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Rose 50% - 15.00 €',
        label: 'Teinte Unie Rose 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Rose 25% - 15.00 €',
        label: 'Teinte Unie Rose 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Rose 10% - 15.00 €',
        label: 'Teinte Unie Rose 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Champagne 85% - 15.00 €',
        label: 'Teinte Unie Champagne 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Champagne 75% - 15.00 €',
        label: 'Teinte Unie Champagne 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Champagne 50% - 15.00 €',
        label: 'Teinte Unie Champagne 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Champagne 25% - 15.00 €',
        label: 'Teinte Unie Champagne 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Champagne 10% - 15.00 €',
        label: 'Teinte Unie Champagne 10% - 15.00 €',
    },
    {
        value: 'Teinte Unie Orange 85% - 15.00 €',
        label: 'Teinte Unie Orange 85% - 15.00 €',
    },
    {
        value: 'Teinte Unie Orange 75% - 15.00 €',
        label: 'Teinte Unie Orange 75% - 15.00 €',
    },
    {
        value: 'Teinte Unie Orange 50% - 15.00 €',
        label: 'Teinte Unie Orange 50% - 15.00 €',
    },
    {
        value: 'Teinte Unie Orange 25% - 15.00 €',
        label: 'Teinte Unie Orange 25% - 15.00 €',
    },
    {
        value: 'Teinte Unie Orange 10% - 15.00 €',
        label: 'Teinte Unie Orange 10% - 15.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-0% - 50.00 €',
        label: 'Teinte Deg Grey 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 50%-0% - 50.00 €',
        label: 'Teinte Deg Grey 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 25%-0% - 50.00 €',
        label: 'Teinte Deg Grey 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-25% - 50.00 €',
        label: 'Teinte Deg Grey 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 50%-25% - 50.00 €',
        label: 'Teinte Deg Grey 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-50% - 50.00 €',
        label: 'Teinte Deg Grey 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-0% - 50.00 €',
        label: 'Teinte Deg Brown 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 50%-0% - 50.00 €',
        label: 'Teinte Deg Brown 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 25%-0% - 50.00 €',
        label: 'Teinte Deg Brown 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-25% - 50.00 €',
        label: 'Teinte Deg Brown 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 50%-25% - 50.00 €',
        label: 'Teinte Deg Brown 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-50% - 50.00 €',
        label: 'Teinte Deg Brown 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-0% - 50.00 €',
        label: 'Teinte Deg G15 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 50%-0% - 50.00 €',
        label: 'Teinte Deg G15 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 25%-0% - 50.00 €',
        label: 'Teinte Deg G15 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-25% - 50.00 €',
        label: 'Teinte Deg G15 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 50%-25% - 50.00 €',
        label: 'Teinte Deg G15 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-50% - 50.00 €',
        label: 'Teinte Deg G15 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-0% - 50.00 €',
        label: 'Teinte Deg Blue 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 50%-0% - 50.00 €',
        label: 'Teinte Deg Blue 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 25%-0% - 50.00 €',
        label: 'Teinte Deg Blue 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-25% - 50.00 €',
        label: 'Teinte Deg Blue 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 50%-25% - 50.00 €',
        label: 'Teinte Deg Blue 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-50% - 50.00 €',
        label: 'Teinte Deg Blue 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 50%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 25%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-25% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 50%-25% - 50.00 €',
        label: 'Teinte Deg Yellow 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-50% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-0% - 50.00 €',
        label: 'Teinte Deg Pink 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 50%-0% - 50.00 €',
        label: 'Teinte Deg Pink 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 25%-0% - 50.00 €',
        label: 'Teinte Deg Pink 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-25% - 50.00 €',
        label: 'Teinte Deg Pink 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 50%-25% - 50.00 €',
        label: 'Teinte Deg Pink 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-50% - 50.00 €',
        label: 'Teinte Deg Pink 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-0% - 50.00 €',
        label: 'Teinte Deg Purple 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 50%-0% - 50.00 €',
        label: 'Teinte Deg Purple 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 25%-0% - 50.00 €',
        label: 'Teinte Deg Purple 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-25% - 50.00 €',
        label: 'Teinte Deg Purple 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 50%-25% - 50.00 €',
        label: 'Teinte Deg Purple 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-50% - 50.00 €',
        label: 'Teinte Deg Purple 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-0% - 50.00 €',
        label: 'Teinte Deg Black 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 50%-0% - 50.00 €',
        label: 'Teinte Deg Black 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 25%-0% - 50.00 €',
        label: 'Teinte Deg Black 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-25% - 50.00 €',
        label: 'Teinte Deg Black 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 50%-25% - 50.00 €',
        label: 'Teinte Deg Black 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-50% - 50.00 €',
        label: 'Teinte Deg Black 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-0% - 50.00 €',
        label: 'Teinte Deg Amber 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 50%-0% - 50.00 €',
        label: 'Teinte Deg Amber 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 25%-0% - 50.00 €',
        label: 'Teinte Deg Amber 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-25% - 50.00 €',
        label: 'Teinte Deg Amber 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 50%-25% - 50.00 €',
        label: 'Teinte Deg Amber 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-50% - 50.00 €',
        label: 'Teinte Deg Amber 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-0% - 50.00 €',
        label: 'Teinte Deg Rose 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 50%-0% - 50.00 €',
        label: 'Teinte Deg Rose 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 25%-0% - 50.00 €',
        label: 'Teinte Deg Rose 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-25% - 50.00 €',
        label: 'Teinte Deg Rose 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 50%-25% - 50.00 €',
        label: 'Teinte Deg Rose 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-50% - 50.00 €',
        label: 'Teinte Deg Rose 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 50%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 25%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-25% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 50%-25% - 50.00 €',
        label: 'Teinte Deg Champagne 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-50% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-0% - 50.00 €',
        label: 'Teinte Deg Orange 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 50%-0% - 50.00 €',
        label: 'Teinte Deg Orange 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 25%-0% - 50.00 €',
        label: 'Teinte Deg Orange 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-25% - 50.00 €',
        label: 'Teinte Deg Orange 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 50%-25% - 50.00 €',
        label: 'Teinte Deg Orange 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-50% - 50.00 €',
        label: 'Teinte Deg Orange 85%-50% - 50.00 €',
    },
];
export const colorA34 = [
    { value: '', label: '' },
    {
        value: 'Teinte Unie Grey 85% - 30.00 €',
        label: 'Teinte Unie Grey 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Grey 75% - 30.00 €',
        label: 'Teinte Unie Grey 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Grey 50% - 30.00 €',
        label: 'Teinte Unie Grey 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Grey 25% - 30.00 €',
        label: 'Teinte Unie Grey 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Grey 10% - 30.00 €',
        label: 'Teinte Unie Grey 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Brown 85% - 30.00 €',
        label: 'Teinte Unie Brown 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Brown 75% - 30.00 €',
        label: 'Teinte Unie Brown 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Brown 50% - 30.00 €',
        label: 'Teinte Unie Brown 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Brown 25% - 30.00 €',
        label: 'Teinte Unie Brown 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Brown 10% - 30.00 €',
        label: 'Teinte Unie Brown 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie G15 85% - 30.00 €',
        label: 'Teinte Unie G15 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie G15 75% - 30.00 €',
        label: 'Teinte Unie G15 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie G15 50% - 30.00 €',
        label: 'Teinte Unie G15 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie G15 25% - 30.00 €',
        label: 'Teinte Unie G15 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie G15 10% - 30.00 €',
        label: 'Teinte Unie G15 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Blue 85% - 30.00 €',
        label: 'Teinte Unie Blue 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Blue 75% - 30.00 €',
        label: 'Teinte Unie Blue 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Blue 50% - 30.00 €',
        label: 'Teinte Unie Blue 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Blue 25% - 30.00 €',
        label: 'Teinte Unie Blue 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Blue 10% - 30.00 €',
        label: 'Teinte Unie Blue 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Yellow 85% - 30.00 €',
        label: 'Teinte Unie Yellow 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Yellow 75% - 30.00 €',
        label: 'Teinte Unie Yellow 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Yellow 50% - 30.00 €',
        label: 'Teinte Unie Yellow 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Yellow 25% - 30.00 €',
        label: 'Teinte Unie Yellow 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Yellow 10% - 30.00 €',
        label: 'Teinte Unie Yellow 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Pink 85% - 30.00 €',
        label: 'Teinte Unie Pink 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Pink 75% - 30.00 €',
        label: 'Teinte Unie Pink 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Pink 50% - 30.00 €',
        label: 'Teinte Unie Pink 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Pink 25% - 30.00 €',
        label: 'Teinte Unie Pink 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Pink 10% - 30.00 €',
        label: 'Teinte Unie Pink 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Purple 85% - 30.00 €',
        label: 'Teinte Unie Purple 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Purple 75% - 30.00 €',
        label: 'Teinte Unie Purple 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Purple 50% - 30.00 €',
        label: 'Teinte Unie Purple 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Purple 25% - 30.00 €',
        label: 'Teinte Unie Purple 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Purple 10% - 30.00 €',
        label: 'Teinte Unie Purple 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Black 85% - 30.00 €',
        label: 'Teinte Unie Black 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Black 75% - 30.00 €',
        label: 'Teinte Unie Black 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Black 50% - 30.00 €',
        label: 'Teinte Unie Black 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Black 25% - 30.00 €',
        label: 'Teinte Unie Black 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Black 10% - 30.00 €',
        label: 'Teinte Unie Black 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Amber 85% - 30.00 €',
        label: 'Teinte Unie Amber 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Amber 75% - 30.00 €',
        label: 'Teinte Unie Amber 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Amber 50% - 30.00 €',
        label: 'Teinte Unie Amber 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Amber 25% - 30.00 €',
        label: 'Teinte Unie Amber 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Amber 10% - 30.00 €',
        label: 'Teinte Unie Amber 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Rose 85% - 30.00 €',
        label: 'Teinte Unie Rose 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Rose 75% - 30.00 €',
        label: 'Teinte Unie Rose 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Rose 50% - 30.00 €',
        label: 'Teinte Unie Rose 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Rose 25% - 30.00 €',
        label: 'Teinte Unie Rose 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Rose 10% - 30.00 €',
        label: 'Teinte Unie Rose 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Champagne 85% - 30.00 €',
        label: 'Teinte Unie Champagne 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Champagne 75% - 30.00 €',
        label: 'Teinte Unie Champagne 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Champagne 50% - 30.00 €',
        label: 'Teinte Unie Champagne 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Champagne 25% - 30.00 €',
        label: 'Teinte Unie Champagne 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Champagne 10% - 30.00 €',
        label: 'Teinte Unie Champagne 10% - 30.00 €',
    },
    {
        value: 'Teinte Unie Orange 85% - 30.00 €',
        label: 'Teinte Unie Orange 85% - 30.00 €',
    },
    {
        value: 'Teinte Unie Orange 75% - 30.00 €',
        label: 'Teinte Unie Orange 75% - 30.00 €',
    },
    {
        value: 'Teinte Unie Orange 50% - 30.00 €',
        label: 'Teinte Unie Orange 50% - 30.00 €',
    },
    {
        value: 'Teinte Unie Orange 25% - 30.00 €',
        label: 'Teinte Unie Orange 25% - 30.00 €',
    },
    {
        value: 'Teinte Unie Orange 10% - 30.00 €',
        label: 'Teinte Unie Orange 10% - 30.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-0% - 50.00 €',
        label: 'Teinte Deg Grey 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 50%-0% - 50.00 €',
        label: 'Teinte Deg Grey 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 25%-0% - 50.00 €',
        label: 'Teinte Deg Grey 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-25% - 50.00 €',
        label: 'Teinte Deg Grey 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 50%-25% - 50.00 €',
        label: 'Teinte Deg Grey 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Grey 85%-50% - 50.00 €',
        label: 'Teinte Deg Grey 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-0% - 50.00 €',
        label: 'Teinte Deg Brown 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 50%-0% - 50.00 €',
        label: 'Teinte Deg Brown 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 25%-0% - 50.00 €',
        label: 'Teinte Deg Brown 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-25% - 50.00 €',
        label: 'Teinte Deg Brown 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 50%-25% - 50.00 €',
        label: 'Teinte Deg Brown 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Brown 85%-50% - 50.00 €',
        label: 'Teinte Deg Brown 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-0% - 50.00 €',
        label: 'Teinte Deg G15 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 50%-0% - 50.00 €',
        label: 'Teinte Deg G15 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 25%-0% - 50.00 €',
        label: 'Teinte Deg G15 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-25% - 50.00 €',
        label: 'Teinte Deg G15 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 50%-25% - 50.00 €',
        label: 'Teinte Deg G15 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg G15 85%-50% - 50.00 €',
        label: 'Teinte Deg G15 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-0% - 50.00 €',
        label: 'Teinte Deg Blue 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 50%-0% - 50.00 €',
        label: 'Teinte Deg Blue 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 25%-0% - 50.00 €',
        label: 'Teinte Deg Blue 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-25% - 50.00 €',
        label: 'Teinte Deg Blue 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 50%-25% - 50.00 €',
        label: 'Teinte Deg Blue 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Blue 85%-50% - 50.00 €',
        label: 'Teinte Deg Blue 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 50%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 25%-0% - 50.00 €',
        label: 'Teinte Deg Yellow 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-25% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 50%-25% - 50.00 €',
        label: 'Teinte Deg Yellow 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Yellow 85%-50% - 50.00 €',
        label: 'Teinte Deg Yellow 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-0% - 50.00 €',
        label: 'Teinte Deg Pink 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 50%-0% - 50.00 €',
        label: 'Teinte Deg Pink 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 25%-0% - 50.00 €',
        label: 'Teinte Deg Pink 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-25% - 50.00 €',
        label: 'Teinte Deg Pink 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 50%-25% - 50.00 €',
        label: 'Teinte Deg Pink 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Pink 85%-50% - 50.00 €',
        label: 'Teinte Deg Pink 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-0% - 50.00 €',
        label: 'Teinte Deg Purple 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 50%-0% - 50.00 €',
        label: 'Teinte Deg Purple 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 25%-0% - 50.00 €',
        label: 'Teinte Deg Purple 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-25% - 50.00 €',
        label: 'Teinte Deg Purple 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 50%-25% - 50.00 €',
        label: 'Teinte Deg Purple 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Purple 85%-50% - 50.00 €',
        label: 'Teinte Deg Purple 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-0% - 50.00 €',
        label: 'Teinte Deg Black 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 50%-0% - 50.00 €',
        label: 'Teinte Deg Black 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 25%-0% - 50.00 €',
        label: 'Teinte Deg Black 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-25% - 50.00 €',
        label: 'Teinte Deg Black 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 50%-25% - 50.00 €',
        label: 'Teinte Deg Black 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Black 85%-50% - 50.00 €',
        label: 'Teinte Deg Black 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-0% - 50.00 €',
        label: 'Teinte Deg Amber 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 50%-0% - 50.00 €',
        label: 'Teinte Deg Amber 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 25%-0% - 50.00 €',
        label: 'Teinte Deg Amber 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-25% - 50.00 €',
        label: 'Teinte Deg Amber 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 50%-25% - 50.00 €',
        label: 'Teinte Deg Amber 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Amber 85%-50% - 50.00 €',
        label: 'Teinte Deg Amber 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-0% - 50.00 €',
        label: 'Teinte Deg Rose 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 50%-0% - 50.00 €',
        label: 'Teinte Deg Rose 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 25%-0% - 50.00 €',
        label: 'Teinte Deg Rose 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-25% - 50.00 €',
        label: 'Teinte Deg Rose 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 50%-25% - 50.00 €',
        label: 'Teinte Deg Rose 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Rose 85%-50% - 50.00 €',
        label: 'Teinte Deg Rose 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 50%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 25%-0% - 50.00 €',
        label: 'Teinte Deg Champagne 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-25% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 50%-25% - 50.00 €',
        label: 'Teinte Deg Champagne 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Champagne 85%-50% - 50.00 €',
        label: 'Teinte Deg Champagne 85%-50% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-0% - 50.00 €',
        label: 'Teinte Deg Orange 85%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 50%-0% - 50.00 €',
        label: 'Teinte Deg Orange 50%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 25%-0% - 50.00 €',
        label: 'Teinte Deg Orange 25%-0% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-25% - 50.00 €',
        label: 'Teinte Deg Orange 85%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 50%-25% - 50.00 €',
        label: 'Teinte Deg Orange 50%-25% - 50.00 €',
    },
    {
        value: 'Teinte Deg Orange 85%-50% - 50.00 €',
        label: 'Teinte Deg Orange 85%-50% - 50.00 €',
    },
];
/////////////////////////////////////////////////

////////////////////////Treatment///////////////////////////////////
export const TreatmentA1 = [
    { value: '', label: '' },
    { value: 'HC - 0.00 €', label: 'HC - N/A', isDisabled: true },
    { value: 'HMC - 0.00 €', label: 'HMC - 0.00 €' },
    { value: 'Super HMC - 0.00 €', label: 'Super HMC - N/A', isDisabled: true },
    { value: 'Back HMC - 0.00 €', label: 'Back HMC - N/A', isDisabled: true },
    // {
    //     value: 'Mirror Back HMC Red - 0.00 €',
    //     label: 'Mirror Back HMC Red - N/A',
    //     isDisabled: true,
    // },
    {
        value: 'Premium Super HMC - 0.00 €',
        label: 'Premium Super HMC - N/A',
        isDisabled: true,
    },
    // {
    //     value: 'Mirror Back HMC Green - 0.00 €',
    //     label: 'Mirror Back HMC Green - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Blue - 0.00 €',
    //     label: 'Mirror Back HMC Blue - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Pink - 0.00 €',
    //     label: 'Mirror Back HMC Pink - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Gold - 0.00 €',
    //     label: 'Mirror Back HMC Gold - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Silver - 0.00 €',
    //     label: 'Mirror Back HMC Silver - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Purple - 0.00 €',
    //     label: 'Mirror Back HMC Purple - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Champagne - 0.00 €',
    //     label: 'Mirror Back HMC Champagne - N/A',
    //     isDisabled: true,
    // },
];
export const Treatment234 = [
    { value: '', label: '' },
    { value: 'HC - 0.00 €', label: 'HC - 0.00 €' },
    { value: 'HMC - 0.00 €', label: 'HMC - 0.00 €' },
    { value: 'Super HMC - 75.00 €', label: 'Super HMC - 75.00 €' },
    { value: 'Back HMC - 0.00 €', label: 'Back HMC - 0.00 €' },
    // {
    //     value: 'Mirror Back HMC Red - 50.00 €',
    //     label: 'Mirror Back HMC Red - 50.00 €',
    // },
    {
        value: 'Premium Super HMC - 100.00 €',
        label: 'Premium Super HMC - 100.00 €',
    },
    // {
    //     value: 'Mirror Back HMC Green - 50.00 €',
    //     label: 'Mirror Back HMC Green - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Blue - 50.00 €',
    //     label: 'Mirror Back HMC Blue - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Pink - 50.00 €',
    //     label: 'Mirror Back HMC Pink - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Gold - 50.00 €',
    //     label: 'Mirror Back HMC Gold - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Silver - 50.00 €',
    //     label: 'Mirror Back HMC Silver - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Purple - 50.00 €',
    //     label: 'Mirror Back HMC Purple - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Champagne - 50.00 €',
    //     label: 'Mirror Back HMC Champagne - 50.00 €',
    // },
];
export const TreatmentSP3 = [
    { value: '', label: '' },
    { value: 'HC - 0.00 €', label: 'HC - 0.00 €' },
    { value: 'HMC - 0.00 €', label: 'HMC - 0.00 €' },
    { value: 'Super HMC - 0.00 €', label: 'Super HMC - 0.00 €' },
    { value: 'Back HMC - 0.00 €', label: 'Back HMC - 0.00 €' },
    // {
    //     value: 'Mirror Back HMC Red - 50.00 €',
    //     label: 'Mirror Back HMC Red - 50.00 €',
    // },
    {
        value: 'Premium Super HMC - 100.00 €',
        label: 'Premium Super HMC - 100.00 €',
    },
    // {
    //     value: 'Mirror Back HMC Green - 50.00 €',
    //     label: 'Mirror Back HMC Green - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Blue - 50.00 €',
    //     label: 'Mirror Back HMC Blue - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Pink - 50.00 €',
    //     label: 'Mirror Back HMC Pink - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Gold - 50.00 €',
    //     label: 'Mirror Back HMC Gold - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Silver - 50.00 €',
    //     label: 'Mirror Back HMC Silver - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Purple - 50.00 €',
    //     label: 'Mirror Back HMC Purple - 50.00 €',
    // },
    // {
    //     value: 'Mirror Back HMC Champagne - 50.00 €',
    //     label: 'Mirror Back HMC Champagne - 50.00 €',
    // },
];
export const Treatmentmva1 = [
    { value: '', label: '' },
    { value: 'HC - 0.00 €', label: 'HC - 0.00 €' },
    { value: 'HMC - 0.00 €', label: 'HMC - 0.00 €' },
    { value: 'Super HMC - 0.00 €', label: 'Super HMC - N/A', isDisabled: true },
    { value: 'Back HMC - 0.00 €', label: 'Back HMC - N/A', isDisabled: true },
    // {
    //     value: 'Mirror Back HMC Red - 0.00 €',
    //     label: 'Mirror Back HMC Red - N/A',
    //     isDisabled: true,
    // },
    {
        value: 'Premium Super HMC - 0.00 €',
        label: 'Premium Super HMC - N/A',
        isDisabled: true,
    },
    // {
    //     value: 'Mirror Back HMC Green - 0.00 €',
    //     label: 'Mirror Back HMC Green - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Blue - 0.00 €',
    //     label: 'Mirror Back HMC Blue - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Pink - 0.00 €',
    //     label: 'Mirror Back HMC Pink - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Gold - 0.00 €',
    //     label: 'Mirror Back HMC Gold - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Silver - 0.00 €',
    //     label: 'Mirror Back HMC Silver - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Purple - 0.00 €',
    //     label: 'Mirror Back HMC Purple - N/A',
    //     isDisabled: true,
    // },
    // {
    //     value: 'Mirror Back HMC Champagne - 0.00 €',
    //     label: 'Mirror Back HMC Champagne - N/A',
    //     isDisabled: true,
    // },
];
//////////////////////////////////////////////////////////////////////////

////////////////////Indice//////////////////////////
export const IndiceA1 = [
    { value: '', label: '' },
    { value: '1.5 - 0.00 €', label: '1.5 - 0.00 €' },
    { value: '1.6 - 0.00 €', label: '1.6 - 0.00 €' },
    { value: '1.67 - 0.00 €', label: '1.67 - 0.00 €' },
    { value: '1.74 - 0.00 €', label: '1.74 - 0.00 €' },
];
export const Indiceothers = [
    { value: '', label: '' },
    { value: '1.5 - 0.00 €', label: '1.5 - 0.00 €' },
    { value: '1.6 - 30.00 €', label: '1.6 - 30.00 €' },
    { value: '1.67 - 70.00 €', label: '1.67 - 70.00 €' },
    { value: '1.74 - 120.00 €', label: '1.74 - 120.00 €' },
];
///////////////////////////////////////////////////////////////

/////////////////Typedeverre///////////////////
export const TypedeverreA1 = [
    { value: '', label: '' },
    { value: 'SYM HD SV A - 0.00 €', label: 'SYM HD SV A - 0.00 €' },
    { value: 'SYM RX HD SV A - 0.00 €', label: 'SYM RX HD SV A - 0.00 €' },
    { value: 'SYM HD PREMIUM SV - 0.00 €', label: 'SYM HD PREMIUM SV - N/A', isDisabled: true },
    { value: 'SYM RX HD PREMIUM SV - 0.00 €', label: 'SYM RX HD PREMIUM SV - N/A', isDisabled: true },
    { value: 'SYM RX HD PROG A 11 - 0.00 €', label: 'SYM RX HD PROG A 11 - 0.00 €' },
    { value: 'SYM RX HD PROG A 9 - 0.00 €', label: 'SYM RX HD PROG A 9 - 0.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 11 - 0.00 €', label: 'SYM RX HD PREMIUM PROG 11 - N/A', isDisabled: true },
    { value: 'SYM RX HD PREMIUM PROG 9 - 0.00 €', label: 'SYM RX HD PREMIUM PROG 9 - N/A', isDisabled: true },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 0.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - N/A', isDisabled: true },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 0.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - N/A', isDisabled: true },
    { value: 'SYM RX HD DEG 1M - 0.00 €', label: 'SYM RX HD DEG 1M - 0.00 €' },
    { value: 'SYM RX HD DEG 2M - 0.00 €', label: 'SYM RX HD DEG 2M - 0.00 €' },
    { value: 'SYM RX HD DEG 3M - 0.00 €', label: 'SYM RX HD DEG 3M - 0.00 €' },
    // { value: 'SYM RX HD DEG 4M - 0.00 €', label: 'SYM RX HD DEG 4M - 0.00 €' },
    // { value: 'SYM RX HD DEG 5M - 0.00 €', label: 'SYM RX HD DEG 5M - 0.00 €' },
    // { value: 'SYM RX HD DEG 6M - 0.00 €', label: 'SYM RX HD DEG 6M - 0.00 €' },
    { value: 'SYM RX DOUBLE FOYER 28 - 0.00 €', label: 'SYM RX DOUBLE FOYER 28 - 0.00 €' },
    { value: 'SYM HD ZenView Add 0.50 - 0.00 €', label: 'SYM HD ZenView Add 0.50 - N/A', isDisabled: true },
    { value: 'SYM HD ZenView Add 0.75 - 0.00 €', label: 'SYM HD ZenView Add 0.75 - N/A', isDisabled: true },
    { value: 'SYM RX HD SV A Aspheric - 0.00 €', label: 'SYM RX HD SV A Aspheric - 0.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 0.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - N/A', isDisabled: true },
    { value: 'SYM RX HD SV A Myopie - 0.00 €', label: 'SYM RX HD SV A Myopie - N/A', isDisabled: true },
    { value: 'Sym RX HD Premium SV Myopie - 0.00 €', label: 'Sym RX HD Premium SV Myopie - N/A', isDisabled: true },
];
export const TypedeverreA2 = [
    { value: '', label: '' },

    { value: 'SYM HD SV A - 34.00 €', label: 'SYM HD SV A - 34.00 €' },
    { value: 'SYM RX HD SV A - 74.00 €', label: 'SYM RX HD SV A - 74.00 €' },
    { value: 'SYM HD PREMIUM SV - 134.00 €', label: 'SYM HD PREMIUM SV - 134.00 €' },
    { value: 'SYM RX HD PREMIUM SV - 174.00 €', label: 'SYM RX HD PREMIUM SV - 174.00 €' },

    { value: 'SYM RX HD PROG A 11 - 44.00 €', label: 'SYM RX HD PROG A 11 - 44.00 €' },
    { value: 'SYM RX HD PROG A 9 - 44.00 €', label: 'SYM RX HD PROG A 9 - 44.00 €' },

    { value: 'SYM RX HD PREMIUM PROG 11 - 244.00 €', label: 'SYM RX HD PREMIUM PROG 11 - 244.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 9 - 244.00 €', label: 'SYM RX HD PREMIUM PROG 9 - 244.00 €' },

    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 244.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 244.00 €' },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 244.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 244.00 €' },

    { value: 'SYM RX HD DEG 1M - 44.00 €', label: 'SYM RX HD DEG 1M - 44.00 €' },
    { value: 'SYM RX HD DEG 2M - 44.00 €', label: 'SYM RX HD DEG 2M - 44.00 €' },
    { value: 'SYM RX HD DEG 3M - 44.00 €', label: 'SYM RX HD DEG 3M - 44.00 €' },
    // { value: 'SYM RX HD DEG 4M - 44.00 €', label: 'SYM RX HD DEG 4M - 44.00 €' },
    // { value: 'SYM RX HD DEG 5M - 44.00 €', label: 'SYM RX HD DEG 5M - 44.00 €' },
    // { value: 'SYM RX HD DEG 6M - 44.00 €', label: 'SYM RX HD DEG 6M - 44.00 €' },

    { value: 'SYM RX DOUBLE FOYER 28 - 44.00 €', label: 'SYM RX DOUBLE FOYER 28 - 44.00 €' },

    { value: 'SYM HD ZenView Add 0.50 - 63.00 €', label: 'SYM HD ZenView Add 0.50 - 63.00 €' },
    { value: 'SYM HD ZenView Add 0.75 - 63.00 €', label: 'SYM HD ZenView Add 0.75 - 63.00 €' },

    { value: 'SYM RX HD SV A Aspheric - 74.00 €', label: 'SYM RX HD SV A Aspheric - 74.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 174.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - 174.00 €' },

    { value: 'SYM RX HD SV A Myopie - 223.00 €', label: 'SYM RX HD SV A Myopie - 223.00 €' },
    { value: 'Sym RX HD Premium SV Myopie - 323.00 €', label: 'Sym RX HD Premium SV Myopie - 323.00 €' },
];
export const TypedeverreSP3 = [
    { value: '', label: '' },

    { value: 'SYM HD SV A - 54.00 €', label: 'SYM HD SV A - 54.00 €' },
    { value: 'SYM RX HD SV A - 94.00 €', label: 'SYM RX HD SV A - 94.00 €' },
    { value: 'SYM HD PREMIUM SV - 154.00 €', label: 'SYM HD PREMIUM SV - 154.00 €' },
    { value: 'SYM RX HD PREMIUM SV - 194.00 €', label: 'SYM RX HD PREMIUM SV - 194.00 €' },

    { value: 'SYM RX HD PROG A 11 - 114.00 €', label: 'SYM RX HD PROG A 11 - 114.00 €' },
    { value: 'SYM RX HD PROG A 9 - 114.00 €', label: 'SYM RX HD PROG A 9 - 114.00 €' },

    { value: 'SYM RX HD PREMIUM PROG 11 - 314.00 €', label: 'SYM RX HD PREMIUM PROG 11 - 314.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 9 - 314.00 €', label: 'SYM RX HD PREMIUM PROG 9 - 314.00 €' },

    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 314.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 314.00 €' },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 314.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 314.00 €' },

    { value: 'SYM RX HD DEG 1M - 114.00 €', label: 'SYM RX HD DEG 1M - 114.00 €' },
    { value: 'SYM RX HD DEG 2M - 114.00 €', label: 'SYM RX HD DEG 2M - 114.00 €' },
    { value: 'SYM RX HD DEG 3M - 114.00 €', label: 'SYM RX HD DEG 3M - 114.00 €' },
    // { value: 'SYM RX HD DEG 4M - 114.00 €', label: 'SYM RX HD DEG 4M - 114.00 €' },
    // { value: 'SYM RX HD DEG 5M - 114.00 €', label: 'SYM RX HD DEG 5M - 114.00 €' },
    // { value: 'SYM RX HD DEG 6M - 114.00 €', label: 'SYM RX HD DEG 6M - 114.00 €' },

    { value: 'SYM RX DOUBLE FOYER 28 - 114.00 €', label: 'SYM RX DOUBLE FOYER 28 - 114.00 €' },

    { value: 'SYM HD ZenView Add 0.50 - 133.00 €', label: 'SYM HD ZenView Add 0.50 - 133.00 €' },
    { value: 'SYM HD ZenView Add 0.75 - 133.00 €', label: 'SYM HD ZenView Add 0.75 - 133.00 €' },

    { value: 'SYM RX HD SV A Aspheric - 94.00 €', label: 'SYM RX HD SV A Aspheric - 94.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 194.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - 194.00 €' },

    { value: 'SYM RX HD SV A Myopie - 293.00 €', label: 'SYM RX HD SV A Myopie - 293.00 €' },
    { value: 'Sym RX HD Premium SV Myopie - 393.00 €', label: 'Sym RX HD Premium SV Myopie - 393.00 €' },
];
export const TypedeverreB1 = [
    { value: '', label: '' },

    { value: 'SYM HD SV A - 0.00 €', label: 'SYM HD SV A - N/A', isDisabled: true },
    { value: 'SYM RX HD SV A - 0.00 €', label: 'SYM RX HD SV A - N/A', isDisabled: true },
    { value: 'SYM HD PREMIUM SV - 219.00 €', label: 'SYM HD PREMIUM SV - 219.00 €' },
    { value: 'SYM RX HD PREMIUM SV - 259.00 €', label: 'SYM RX HD PREMIUM SV - 259.00 €' },

    { value: 'SYM RX HD PROG A 11 - 0.00 €', label: 'SYM RX HD PROG A 11 - N/A', isDisabled: true },
    { value: 'SYM RX HD PROG A 9 - 0.00 €', label: 'SYM RX HD PROG A 9 - N/A', isDisabled: true },

    { value: 'SYM RX HD PREMIUM PROG 11 - 419.00 €', label: 'SYM RX HD PREMIUM PROG 11 - 419.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 9 - 419.00 €', label: 'SYM RX HD PREMIUM PROG 9 - 419.00 €' },

    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 619.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 619.00 €' },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 619.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 619.00 €' },

    { value: 'SYM RX HD DEG 1M - 419.00 €', label: 'SYM RX HD DEG 1M - 419.00 €' },
    { value: 'SYM RX HD DEG 2M - 419.00 €', label: 'SYM RX HD DEG 2M - 419.00 €' },
    { value: 'SYM RX HD DEG 3M - 419.00 €', label: 'SYM RX HD DEG 3M - 419.00 €' },
    // { value: 'SYM RX HD DEG 4M - 419.00 €', label: 'SYM RX HD DEG 4M - 419.00 €' },
    // { value: 'SYM RX HD DEG 5M - 419.00 €', label: 'SYM RX HD DEG 5M - 419.00 €' },
    // { value: 'SYM RX HD DEG 6M - 419.00 €', label: 'SYM RX HD DEG 6M - 419.00 €' },

    { value: 'SYM RX DOUBLE FOYER 28 - 419.00 €', label: 'SYM RX DOUBLE FOYER 28 - 419.00 €' },

    { value: 'SYM HD ZenView Add 0.50 - 438.00 €', label: 'SYM HD ZenView Add 0.50 - 438.00 €' },
    { value: 'SYM HD ZenView Add 0.75 - 438.00 €', label: 'SYM HD ZenView Add 0.75 - 438.00 €' },

    { value: 'SYM RX HD SV A Aspheric - 259.00 €', label: 'SYM RX HD SV A Aspheric - 259.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 259.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - 259.00 €' },

    { value: 'SYM RX HD SV A Myopie - 598.00 €', label: 'SYM RX HD SV A Myopie - 598.00 €' },
    { value: 'Sym RX HD Premium SV Myopie - 698.00 €', label: 'Sym RX HD Premium SV Myopie - 698.00 €' },
];
export const TypedeverreB2 = [
    { value: '', label: '' },

    { value: 'SYM HD SV A - 0.00 €', label: 'SYM HD SV A - 0.00 €' },
    { value: 'SYM RX HD SV A - 40.00 €', label: 'SYM RX HD SV A - 40.00 €' },
    { value: 'SYM HD PREMIUM SV - 100.00 €', label: 'SYM HD PREMIUM SV - 100.00 €' },
    { value: 'SYM RX HD PREMIUM SV - 140.00 €', label: 'SYM RX HD PREMIUM SV - 140.00 €' },

    { value: 'SYM RX HD PROG A 11 - 0.00 €', label: 'SYM RX HD PROG A 11 - 0.00 €' },
    { value: 'SYM RX HD PROG A 9 - 0.00 €', label: 'SYM RX HD PROG A 9 - 0.00 €' },

    { value: 'SYM RX HD PREMIUM PROG 11 - 200.00 €', label: 'SYM RX HD PREMIUM PROG 11 - 200.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 9 - 200.00 €', label: 'SYM RX HD PREMIUM PROG 9 - 200.00 €' },

    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 200.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 200.00 €' },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 200.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 200.00 €' },

    { value: 'SYM RX HD DEG 1M - 0.00 €', label: 'SYM RX HD DEG 1M - 0.00 €' },
    { value: 'SYM RX HD DEG 2M - 0.00 €', label: 'SYM RX HD DEG 2M - 0.00 €' },
    { value: 'SYM RX HD DEG 3M - 0.00 €', label: 'SYM RX HD DEG 3M - 0.00 €' },
    // { value: 'SYM RX HD DEG 4M - 0.00 €', label: 'SYM RX HD DEG 4M - 0.00 €' },
    // { value: 'SYM RX HD DEG 5M - 0.00 €', label: 'SYM RX HD DEG 5M - 0.00 €' },
    // { value: 'SYM RX HD DEG 6M - 0.00 €', label: 'SYM RX HD DEG 6M - 0.00 €' },

    { value: 'SYM RX DOUBLE FOYER 28 - 0.00 €', label: 'SYM RX DOUBLE FOYER 28 - 0.00 €' },

    { value: 'SYM HD ZenView Add 0.50 - 19.00 €', label: 'SYM HD ZenView Add 0.50 - 19.00 €' },
    { value: 'SYM HD ZenView Add 0.75 - 19.00 €', label: 'SYM HD ZenView Add 0.75 - 19.00 €' },

    { value: 'SYM RX HD SV A Aspheric - 40.00 €', label: 'SYM RX HD SV A Aspheric - 40.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 140.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - 140.00 €' },

    { value: 'SYM RX HD SV A Myopie - 179.00 €', label: 'SYM RX HD SV A Myopie - 179.00 €' },
    { value: 'Sym RX HD Premium SV Myopie - 279.00 €', label: 'Sym RX HD Premium SV Myopie - 279.00 €' },
];
export const TypedeverreB34 = [
    { value: '', label: '' },

    { value: 'SYM HD SV A - 54.00 €', label: 'SYM HD SV A - 54.00 €' },
    { value: 'SYM RX HD SV A - 94.00 €', label: 'SYM RX HD SV A - 94.00 €' },
    { value: 'SYM HD PREMIUM SV - 154.00 €', label: 'SYM HD PREMIUM SV - 154.00 €' },
    { value: 'SYM RX HD PREMIUM SV - 194.00 €', label: 'SYM RX HD PREMIUM SV - 194.00 €' },

    { value: 'SYM RX HD PROG A 11 - 114.00 €', label: 'SYM RX HD PROG A 11 - 114.00 €' },
    { value: 'SYM RX HD PROG A 9 - 114.00 €', label: 'SYM RX HD PROG A 9 - 114.00 €' },

    { value: 'SYM RX HD PREMIUM PROG 11 - 314.00 €', label: 'SYM RX HD PREMIUM PROG 11 - 314.00 €' },
    { value: 'SYM RX HD PREMIUM PROG 9 - 314.00 €', label: 'SYM RX HD PREMIUM PROG 9 - 314.00 €' },

    { value: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 314.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH20 - 314.00 €' },
    { value: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 314.00 €', label: 'SYM RX HD ULTRA PREMIUM PROG FH16 - 314.00 €' },

    { value: 'SYM RX HD DEG 1M - 114.00 €', label: 'SYM RX HD DEG 1M - 114.00 €' },
    { value: 'SYM RX HD DEG 2M - 114.00 €', label: 'SYM RX HD DEG 2M - 114.00 €' },
    { value: 'SYM RX HD DEG 3M - 114.00 €', label: 'SYM RX HD DEG 3M - 114.00 €' },
    // { value: 'SYM RX HD DEG 4M - 114.00 €', label: 'SYM RX HD DEG 4M - 114.00 €' },
    // { value: 'SYM RX HD DEG 5M - 114.00 €', label: 'SYM RX HD DEG 5M - 114.00 €' },
    // { value: 'SYM RX HD DEG 6M - 114.00 €', label: 'SYM RX HD DEG 6M - 114.00 €' },

    { value: 'SYM RX DOUBLE FOYER 28 - 114.00 €', label: 'SYM RX DOUBLE FOYER 28 - 114.00 €' },

    { value: 'SYM HD ZenView Add 0.50 - 133.00 €', label: 'SYM HD ZenView Add 0.50 - 133.00 €' },
    { value: 'SYM HD ZenView Add 0.75 - 133.00 €', label: 'SYM HD ZenView Add 0.75 - 133.00 €' },

    { value: 'SYM RX HD SV A Aspheric - 94.00 €', label: 'SYM RX HD SV A Aspheric - 94.00 €' },
    { value: 'SYM RX HD PREMIUM SV Aspheric - 194.00 €', label: 'SYM RX HD PREMIUM SV Aspheric - 194.00 €' },

    { value: 'SYM RX HD SV A Myopie - 293.00 €', label: 'SYM RX HD SV A Myopie - 293.00 €' },
    { value: 'Sym RX HD Premium SV Myopie - 393.00 €', label: 'Sym RX HD Premium SV Myopie - 393.00 €' },
];
////////////////////////////////////////////////

////////////////Option de verre//////////////////////
export const LensTypeDetailsA1 = [
    { value: '', label: '' },
    // { value: "Night Drive - 0.00 €", label: "Night Drive - N/A" },
    {
        value: 'Photochromic Grey - 0.00 €',
        label: 'Photochromic Grey - N/A',
        isDisabled: true,
    },
    {
        value: 'Photochromic Brown - 0.00 €',
        label: 'Photochromic Brown - N/A',
        isDisabled: true,
    },
    {
        value: 'Photochromic G15 - 0.00 €',
        label: 'Photochromic G15 - N/A',
        isDisabled: true,
    },
    {
        value: 'Nupolar Grey - 0.00 €',
        label: 'Nupolar Grey - N/A',
        isDisabled: true,
    },
    {
        value: 'Nupolar Brown - 0.00 €',
        label: 'Nupolar Brown - N/A',
        isDisabled: true,
    },
    {
        value: 'Nupolar G15 - 0.00 €',
        label: 'Nupolar G15 - N/A',
        isDisabled: true,
    },
    {
        value: 'Nupolar Y30 - 0.00 €',
        label: 'Nupolar Y30 - N/A',
        isDisabled: true,
    },
    // { value: "Transition 7 Brown - 0.00 €", label: "Transition 7 Brown - N/A",isDisabled: true },
    {
        value: 'Transition 8 Grey - 0.00 €',
        label: 'Transition 8 Grey - N/A',
        isDisabled: true,
    },
    {
        value: 'Transition 8 Brown - 0.00 €',
        label: 'Transition 8 Brown - N/A',
        isDisabled: true,
    },
    {
        value: 'Transition 8 Green - 0.00 €',
        label: 'Transition 8 Green - N/A',
        isDisabled: true,
    },
    {
        value: 'Transition Vantage Grey - 0.00 €',
        label: 'Transition Vantage Grey - N/A',
        isDisabled: true,
    },
    {
        value: 'Transition XTRA Grey - 0.00 €',
        label: 'Transition XTRA Grey - N/A',
        isDisabled: true,
    },
    { value: 'Blue Mass - 0.00 €', label: 'Blue Mass - N/A', isDisabled: true },
    {
        value: 'Photochromic Grey Blue Mass - 0.00 €',
        label: 'Photochromic Grey Blue Mass - N/A',
        isDisabled: true,
    },
    {
        value: 'Photochromic Brown Blue Mass - 0.00 €',
        label: 'Photochromic Brown Blue Mass - N/A',
        isDisabled: true,
    },
];
export const LensTypeDetailsB2 = [
    { value: '', label: '' },
    // { value: "Night Drive - 0.00 €", label: "Night Drive - N/A" },
    {
        value: 'Photochromic Grey - 125.00 €',
        label: 'Photochromic Grey - 125.00 €',
    },
    {
        value: 'Photochromic Brown - 125.00 €',
        label: 'Photochromic Brown - 125.00 €',
    },
    {
        value: 'Photochromic G15 - 125.00 €',
        label: 'Photochromic G15 - 125.00 €',
    },
    {
        value: 'Photochromic Blue - 125.00 €',
        label: 'Photochromic Blue - 125.00 €',
    },
    { value: 'Nupolar Grey - 75.00 €', label: 'Nupolar Grey - 75.00 €' },
    { value: 'Nupolar Brown - 75.00 €', label: 'Nupolar Brown - 75.00 €' },
    { value: 'Nupolar G15 - 75.00 €', label: 'Nupolar G15 - 75.00 €' },
    { value: 'Nupolar Y30 - 75.00 €', label: 'Nupolar Y30 - 75.00 €' },
    { value: 'Nupolar Blue - 75.00 €', label: 'Nupolar Blue - 75.00 €' },
    // { value: "Transition 7 Brown - 250.00 €", label: "Transition 7 Brown - 250.00 €" },
    {
        value: 'Transition 8 Grey - 250.00 €',
        label: 'Transition 8 Grey - 250.00 €',
    },
    {
        value: 'Transition 8 Brown - 250.00 €',
        label: 'Transition 8 Brown - 250.00 €',
    },
    {
        value: 'Transition 8 Green - 250.00 €',
        label: 'Transition 8 Green - 250.00 €',
    },
    {
        value: 'Transition Vantage Grey - 250.00 €',
        label: 'Transition Vantage Grey - 250.00 €',
    },
    {
        value: 'Transition XTRA Grey - 250.00 €',
        label: 'Transition XTRA Grey - 250.00 €',
    },
    { value: 'Blue Mass - 50.00 €', label: 'Blue Mass - 50.00 €' },
    {
        value: 'Photochromic Grey Blue Mass - 175.00 €',
        label: 'Photochromic Grey Blue Mass - 175.00 €',
    },
    {
        value: 'Photochromic Brown Blue Mass - 175.00 €',
        label: 'Photochromic Brown Blue Mass - 175.00 €',
    },
];
export const LensTypeDetailsB34 = [
    { value: '', label: '' },
    // { value: "Night Drive - 0.00 €", label: "Night Drive - N/A" },
    {
        value: 'Photochromic Grey - 150.00 €',
        label: 'Photochromic Grey - 150.00 €',
    },
    {
        value: 'Photochromic Brown - 150.00 €',
        label: 'Photochromic Brown - 150.00 €',
    },
    {
        value: 'Photochromic G15 - 150.00 €',
        label: 'Photochromic G15 - 150.00 €',
    },
    { value: 'Nupolar Grey - 100.00 €', label: 'Nupolar Grey - 100.00 €' },
    { value: 'Nupolar Brown - 100.00 €', label: 'Nupolar Brown - 100.00 €' },
    { value: 'Nupolar G15 - 100.00 €', label: 'Nupolar G15 - 100.00 €' },
    { value: 'Nupolar Y30 - 100.00 €', label: 'Nupolar Y30 - 100.00 €' },
    { value: 'Nupolar Blue - 100.00 €', label: 'Nupolar Blue - 100.00 €' },
    // { value: "Transition 7 Brown - 300.00 €", label: "Transition 7 Brown - 300.00 €" },
    {
        value: 'Transition 8 Grey - 300.00 €',
        label: 'Transition 8 Grey - 300.00 €',
    },
    {
        value: 'Transition 8 Brown - 300.00 €',
        label: 'Transition 8 Brown - 300.00 €',
    },
    {
        value: 'Transition 8 Green - 300.00 €',
        label: 'Transition 8 Green - 300.00 €',
    },
    {
        value: 'Transition Vantage Grey - 300.00 €',
        label: 'Transition Vantage Grey - 300.00 €',
    },
    {
        value: 'Transition XTRA Grey - 300.00 €',
        label: 'Transition XTRA Grey - 300.00 €',
    },
    { value: 'Blue Mass - 50.00 €', label: 'Blue Mass - 50.00 €' },
    {
        value: 'Photochromic Grey Blue Mass - 200.00 €',
        label: 'Photochromic Grey Blue Mass - 200.00 €',
    },
    {
        value: 'Photochromic Brown Blue Mass - 200.00 €',
        label: 'Photochromic Brown Blue Mass - 200.00 €',
    },
];
////////////////////////////////////////////////
export const Typedeteinte = [
    { value: '', label: '' },
    { value: 'Solid', label: 'Solid' },
    { value: 'GradientColor', label: 'GradientColor' },
];

//////////////////////Monture//////////////////////
export const MontureA1 = [
    { value: '', label: '' },
    { value: 'Autre - 30.00 €', label: 'Autre - 30.00 €' },
    { value: 'SYM 0U 4308 C2 - 30.00 €', label: 'SYM 0U 4308 C2 - 30.00 €' },
    { value: 'SYM 12038 C3 - 30.00 €', label: 'SYM 12038 C3 - 30.00 €' },
    { value: 'SYM 12048 C4 - 30.00 €', label: 'SYM 12048 C4 - 30.00 €' },
    { value: 'SYM 15091 C2 - 30.00 €', label: 'SYM 15091 C2 - 30.00 €' },
    { value: 'SYM 23005 C2 - 30.00 €', label: 'SYM 23005 C2 - 30.00 €' },
    { value: 'SYM 26012 C3 - 30.00 €', label: 'SYM 26012 C3 - 30.00 €' },
    { value: 'SYM 62725 C3 - 30.00 €', label: 'SYM 62725 C3 - 30.00 €' },
    { value: 'SYM B 6109 C2 - 30.00 €', label: 'SYM B 6109 C2 - 30.00 €' },
    { value: 'BT 0012 C2 - 30.00 €', label: 'BT 0012 C2 - 30.00 €' },
    { value: 'BT 0014 C2 - 30.00 €', label: 'BT 0014 C2 - 30.00 €' },
    { value: 'BT 0014 C6 - 30.00 €', label: 'BT 0014 C6 - 30.00 €' },
    { value: 'IN-2216 N01 - 30.00 €', label: 'IN-2216 N01 - 30.00 €' },
    { value: 'SYM OU 1131 C1 - 30.00 €', label: 'SYM OU 1131 C1 - 30.00 €' },
    { value: 'SYM OU 1295 C2 - 30.00 €', label: 'SYM OU 1295 C2 - 30.00 €' },
    { value: 'SYM OU 1295 C4 - 30.00 €', label: 'SYM OU 1295 C4 - 30.00 €' },
    { value: 'SYM OU 1489 C1 - 30.00 €', label: 'SYM OU 1489 C1 - 30.00 €' },
    { value: 'SYM OU 1750 C3 - 30.00 €', label: 'SYM OU 1750 C3 - 30.00 €' },
    { value: 'SYM OU 4228 C4 - 30.00 €', label: 'SYM OU 4228 C4 - 30.00 €' },
    { value: 'SYM OU 4236 C4 - 30.00 €', label: 'SYM OU 4236 C4 - 30.00 €' },
    { value: 'SYM OU 4238 C1 - 30.00 €', label: 'SYM OU 4238 C1 - 30.00 €' },
    { value: 'SYM OU 4238 C2 - 30.00 €', label: 'SYM OU 4238 C2 - 30.00 €' },
    { value: 'SYM OU 4308 C3 - 30.00 €', label: 'SYM OU 4308 C3 - 30.00 €' },
    { value: 'SYM OU 4311 C2 - 30.00 €', label: 'SYM OU 4311 C2 - 30.00 €' },
    { value: 'SYM OU 4311 C4 - 30.00 €', label: 'SYM OU 4311 C4 - 30.00 €' },
    { value: 'SYM OU 4353 C3 - 30.00 €', label: 'SYM OU 4353 C3 - 30.00 €' },
    { value: 'SYM OU 4353 C4 - 30.00 €', label: 'SYM OU 4353 C4 - 30.00 €' },
    { value: 'SYM OU 4432 C2 - 30.00 €', label: 'SYM OU 4432 C2 - 30.00 €' },
    { value: 'SYM OU 4432 C3 - 30.00 €', label: 'SYM OU 4432 C3 - 30.00 €' },
    { value: 'SYM OU 4435 C3 - 30.00 €', label: 'SYM OU 4435 C3 - 30.00 €' },
    { value: 'SYM OU 4451 C1 - 30.00 €', label: 'SYM OU 4451 C1 - 30.00 €' },
    { value: 'SYM A 01 006 - 30.00 €', label: 'SYM A 01 006 - 30.00 €' },
    { value: 'SYM A 01 009 - 30.00 €', label: 'SYM A 01 009 - 30.00 €' },
    { value: 'SYM A 01 011 - 30.00 €', label: 'SYM A 01 011 - 30.00 €' },
    { value: 'SYM A 02 001 - 30.00 €', label: 'SYM A 02 001 - 30.00 €' },
    { value: 'SYM A 02 002 - 30.00 €', label: 'SYM A 02 002 - 30.00 €' },
    { value: 'SYM A 02 013 - 30.00 €', label: 'SYM A 02 013 - 30.00 €' },
    { value: 'SYM A 03 003 - 30.00 €', label: 'SYM A 03 003 - 30.00 €' },
    { value: 'SYM A 03 008 - 30.00 €', label: 'SYM A 03 008 - 30.00 €' },
    { value: 'SYM A 03 011 - 30.00 €', label: 'SYM A 03 011 - 30.00 €' },
    { value: 'SYM A 04 004 - 30.00 €', label: 'SYM A 04 004 - 30.00 €' },
    { value: 'SYM A 04 005 - 30.00 €', label: 'SYM A 04 005 - 30.00 €' },
    { value: 'SYM A 04 014 - 30.00 €', label: 'SYM A 04 014 - 30.00 €' },
    { value: 'SYM A 05 001 - 30.00 €', label: 'SYM A 05 001 - 30.00 €' },
    { value: 'SYM A 05 010 - 30.00 €', label: 'SYM A 05 010 - 30.00 €' },
    { value: 'SYM A 05 013 - 30.00 €', label: 'SYM A 05 013 - 30.00 €' },
    { value: 'SYM A 06 008 - 30.00 €', label: 'SYM A 06 008 - 30.00 €' },
    { value: 'SYM A 06 012 - 30.00 €', label: 'SYM A 06 012 - 30.00 €' },
    { value: 'SYM A 06 014 - 30.00 €', label: 'SYM A 06 014 - 30.00 €' },
    { value: 'SYM A 06 015 - 30.00 €', label: 'SYM A 06 015 - 30.00 €' },
    { value: 'SYM A 07 219 - 30.00 €', label: 'SYM A 07 219 - 30.00 €' },
    { value: 'SYM A 07 220 - 30.00 €', label: 'SYM A 07 220 - 30.00 €' },
    { value: 'SYM A 07 245 - 30.00 €', label: 'SYM A 07 245 - 30.00 €' },
    { value: 'SYM A 08 245 - 30.00 €', label: 'SYM A 08 245 - 30.00 €' },
    { value: 'SYM B 01 225 - 30.00 €', label: 'SYM B 01 225 - 30.00 €' },
    { value: 'SYM B 01 245 - 30.00 €', label: 'SYM B 01 245 - 30.00 €' },
    { value: 'SYM B 02 001 - 30.00 €', label: 'SYM B 02 001 - 30.00 €' },
    { value: 'SYM B 02 013 - 30.00 €', label: 'SYM B 02 013 - 30.00 €' },
    { value: 'SYM B 02 226 - 30.00 €', label: 'SYM B 02 226 - 30.00 €' },
    { value: 'SYM B 03 014 - 30.00 €', label: 'SYM B 03 014 - 30.00 €' },
    { value: 'SYM B 03 227 - 30.00 €', label: 'SYM B 03 227 - 30.00 €' },
    { value: 'SYM B 03 228 - 30.00 €', label: 'SYM B 03 228 - 30.00 €' },
    { value: 'SYM B 04 230 - 30.00 €', label: 'SYM B 04 230 - 30.00 €' },
    { value: 'SYM B 04 257 - 30.00 €', label: 'SYM B 04 257 - 30.00 €' },
    { value: 'SYM B 05 232 - 30.00 €', label: 'SYM B 05 232 - 30.00 €' },
    { value: 'SYM B 05 233 - 30.00 €', label: 'SYM B 05 233 - 30.00 €' },
    { value: 'SYM B 05 234 - 30.00 €', label: 'SYM B 05 234 - 30.00 €' },
    { value: 'SYM B 06 004 - 30.00 €', label: 'SYM B 06 004 - 30.00 €' },
    { value: 'SYM B 06 015 - 30.00 €', label: 'SYM B 06 015 - 30.00 €' },
    { value: 'SYM B 06 235 - 30.00 €', label: 'SYM B 06 235 - 30.00 €' },
    { value: 'SYM C 01 238 - 30.00 €', label: 'SYM C 01 238 - 30.00 €' },
    { value: 'SYM C 02 233 - 30.00 €', label: 'SYM C 02 233 - 30.00 €' },
    { value: 'SYM C 02 246 - 30.00 €', label: 'SYM C 02 246 - 30.00 €' },
    { value: 'SYM C 02 247 - 30.00 €', label: 'SYM C 02 247 - 30.00 €' },
    { value: 'SYM C 03 016 - 30.00 €', label: 'SYM C 03 016 - 30.00 €' },
    { value: 'SYM C 03 240 - 30.00 €', label: 'SYM C 03 240 - 30.00 €' },
    { value: 'SYM C 03 248 - 30.00 €', label: 'SYM C 03 248 - 30.00 €' },
    { value: 'SYM C 04 224 - 30.00 €', label: 'SYM C 04 224 - 30.00 €' },
    { value: 'SYM C 04 228 - 30.00 €', label: 'SYM C 04 228 - 30.00 €' },
    { value: 'SYM C 04 241 - 30.00 €', label: 'SYM C 04 241 - 30.00 €' },
    { value: 'SYM C 05 242 - 30.00 €', label: 'SYM C 05 242 - 30.00 €' },
    { value: 'SYM C 05 243 - 30.00 €', label: 'SYM C 05 243 - 30.00 €' },
    { value: 'SYM C 05 244 - 30.00 €', label: 'SYM C 05 244 - 30.00 €' },
    { value: 'SYM K 01 251 - 30.00 €', label: 'SYM K 01 251 - 30.00 €' },
    { value: 'SYM K 01 252 - 30.00 €', label: 'SYM K 01 252 - 30.00 €' },
    { value: 'SYM K 01 253 - 30.00 €', label: 'SYM K 01 253 - 30.00 €' },
    { value: 'SYM K 01 254 - 30.00 €', label: 'SYM K 01 254 - 30.00 €' },
    { value: 'SYM K 01 255 - 30.00 €', label: 'SYM K 01 255 - 30.00 €' },
    { value: 'SYM K 02 251 - 30.00 €', label: 'SYM K 02 251 - 30.00 €' },
    { value: 'SYM K 02 252 - 30.00 €', label: 'SYM K 02 252 - 30.00 €' },
    { value: 'SYM K 02 253 - 30.00 €', label: 'SYM K 02 253 - 30.00 €' },
    { value: 'SYM K 02 254 - 30.00 €', label: 'SYM K 02 254 - 30.00 €' },
    { value: 'SYM K 02 255 - 30.00 €', label: 'SYM K 02 255 - 30.00 €' },
    { value: 'SYM K 03 251 - 30.00 €', label: 'SYM K 03 251 - 30.00 €' },
    { value: 'SYM K 03 252 - 30.00 €', label: 'SYM K 03 252 - 30.00 €' },
    { value: 'SYM K 03 253 - 30.00 €', label: 'SYM K 03 253 - 30.00 €' },
    { value: 'SYM K 03 254 - 30.00 €', label: 'SYM K 03 254 - 30.00 €' },
    { value: 'SYM K 03 255 - 30.00 €', label: 'SYM K 03 255 - 30.00 €' },
    { value: 'SYM K 04 251 - 30.00 €', label: 'SYM K 04 251 - 30.00 €' },
    { value: 'SYM K 04 252 - 30.00 €', label: 'SYM K 04 252 - 30.00 €' },
    { value: 'SYM K 04 253 - 30.00 €', label: 'SYM K 04 253 - 30.00 €' },
    { value: 'SYM K 04 254 - 30.00 €', label: 'SYM K 04 254 - 30.00 €' },
    { value: 'SYM K 04 255 - 30.00 €', label: 'SYM K 04 255 - 30.00 €' },
    { value: 'YC 1091 C1 - 30.00 €', label: 'YC 1091 C1 - 30.00 €' },
    { value: 'YC 11069 C4 - 30.00 €', label: 'YC 11069 C4 - 30.00 €' },
    { value: 'YC 12003 C3 - 30.00 €', label: 'YC 12003 C3 - 30.00 €' },
    { value: 'YC 13001 C2 - 30.00 €', label: 'YC 13001 C2 - 30.00 €' },
    { value: 'YC 14042 C4 - 30.00 €', label: 'YC 14042 C4 - 30.00 €' },
    { value: 'YC 14044 C3 - 30.00 €', label: 'YC 14044 C3 - 30.00 €' },
    { value: 'YC 14045 C2 - 30.00 €', label: 'YC 14045 C2 - 30.00 €' },
    { value: 'YC 14047 C4 - 30.00 €', label: 'YC 14047 C4 - 30.00 €' },
    { value: 'YC 14048 C1 - 30.00 €', label: 'YC 14048 C1 - 30.00 €' },
    { value: 'YC 14048 C2 - 30.00 €', label: 'YC 14048 C2 - 30.00 €' },
    { value: 'YC 15035 C2 - 30.00 €', label: 'YC 15035 C2 - 30.00 €' },
    { value: 'YC 15085 C2 - 30.00 €', label: 'YC 15085 C2 - 30.00 €' },
    { value: 'YC 15086 C4 - 30.00 €', label: 'YC 15086 C4 - 30.00 €' },
    { value: 'YC 21002 C3 - 30.00 €', label: 'YC 21002 C3 - 30.00 €' },
    { value: 'YC 21007 C4 - 30.00 €', label: 'YC 21007 C4 - 30.00 €' },
    { value: 'YC 21009 C1 - 30.00 €', label: 'YC 21009 C1 - 30.00 €' },
    { value: 'YC 21012 C1 - 30.00 €', label: 'YC 21012 C1 - 30.00 €' },
    { value: 'YC 21012 C3 - 30.00 €', label: 'YC 21012 C3 - 30.00 €' },
    { value: 'YC 21012 C4 - 30.00 €', label: 'YC 21012 C4 - 30.00 €' },
    { value: 'YC 21013 C1 - 30.00 €', label: 'YC 21013 C1 - 30.00 €' },
    { value: 'YC 21013 C2 - 30.00 €', label: 'YC 21013 C2 - 30.00 €' },
    { value: 'YC 21013 C3 - 30.00 €', label: 'YC 21013 C3 - 30.00 €' },
    { value: 'YC 21013 C4 - 30.00 €', label: 'YC 21013 C4 - 30.00 €' },
    { value: 'YC 21031 C1 - 30.00 €', label: 'YC 21031 C1 - 30.00 €' },
    { value: 'YC 21031 C4 - 30.00 €', label: 'YC 21031 C4 - 30.00 €' },
    { value: 'YC 21034 C1 - 30.00 €', label: 'YC 21034 C1 - 30.00 €' },
    { value: 'YC 21034 C3 - 30.00 €', label: 'YC 21034 C3 - 30.00 €' },
    { value: 'YC 21036 C1 - 30.00 €', label: 'YC 21036 C1 - 30.00 €' },
    { value: 'YC 21038 C2 - 30.00 €', label: 'YC 21038 C2 - 30.00 €' },
    { value: 'YC 21039 C4 - 30.00 €', label: 'YC 21039 C4 - 30.00 €' },
    { value: 'YC 21105 C2 - 30.00 €', label: 'YC 21105 C2 - 30.00 €' },
    { value: 'YC 21105 C3 - 30.00 €', label: 'YC 21105 C3 - 30.00 €' },
    { value: 'YC 21122 C4 - 30.00 €', label: 'YC 21122 C4 - 30.00 €' },
    { value: 'YC 21131 C3 - 30.00 €', label: 'YC 21131 C3 - 30.00 €' },
    { value: 'YC 21144 C3 - 30.00 €', label: 'YC 21144 C3 - 30.00 €' },
    { value: 'YC 21144 C4 - 30.00 €', label: 'YC 21144 C4 - 30.00 €' },
    { value: 'YC 21145 C3 - 30.00 €', label: 'YC 21145 C3 - 30.00 €' },
    { value: 'YC 21145 C4 - 30.00 €', label: 'YC 21145 C4 - 30.00 €' },
    { value: 'YC 21146 C1 - 30.00 €', label: 'YC 21146 C1 - 30.00 €' },
    { value: 'YC 21147 C1 - 30.00 €', label: 'YC 21147 C1 - 30.00 €' },
    { value: 'YC 21148 C3 - 30.00 €', label: 'YC 21148 C3 - 30.00 €' },
    { value: 'YC 21148 C4 - 30.00 €', label: 'YC 21148 C4 - 30.00 €' },
    { value: 'YC 21149 C1 - 30.00 €', label: 'YC 21149 C1 - 30.00 €' },
    { value: 'YC 21151 C4 - 30.00 €', label: 'YC 21151 C4 - 30.00 €' },
    { value: 'YC 21155 C3 - 30.00 €', label: 'YC 21155 C3 - 30.00 €' },
    { value: 'YC 21156 C2 - 30.00 €', label: 'YC 21156 C2 - 30.00 €' },
    { value: 'YC 21158 C1 - 30.00 €', label: 'YC 21158 C1 - 30.00 €' },
    { value: 'YC 21158 C4 - 30.00 €', label: 'YC 21158 C4 - 30.00 €' },
    { value: 'YC 21159 C4 - 30.00 €', label: 'YC 21159 C4 - 30.00 €' },
    { value: 'YC 21163 C2 - 30.00 €', label: 'YC 21163 C2 - 30.00 €' },
    { value: 'YC 21163 C3 - 30.00 €', label: 'YC 21163 C3 - 30.00 €' },
    { value: 'YC 21166 C2 - 30.00 €', label: 'YC 21166 C2 - 30.00 €' },
    { value: 'YC 21184 C4 - 30.00 €', label: 'YC 21184 C4 - 30.00 €' },
    { value: 'YC 2171 C1 - 30.00 €', label: 'YC 2171 C1 - 30.00 €' },
    { value: 'YC 2171 C4 - 30.00 €', label: 'YC 2171 C4 - 30.00 €' },
    { value: 'YC 22034 C3 - 30.00 €', label: 'YC 22034 C3 - 30.00 €' },
    { value: 'YC 22036 C4 - 30.00 €', label: 'YC 22036 C4 - 30.00 €' },
    { value: 'YC 22043 C3 - 30.00 €', label: 'YC 22043 C3 - 30.00 €' },
    { value: 'YC 22050 C4 - 30.00 €', label: 'YC 22050 C4 - 30.00 €' },
    { value: 'YC 22057 C1 - 30.00 €', label: 'YC 22057 C1 - 30.00 €' },
    { value: 'YC 22057 C4 - 30.00 €', label: 'YC 22057 C4 - 30.00 €' },
    { value: 'YC 22082 C3 - 30.00 €', label: 'YC 22082 C3 - 30.00 €' },
    { value: 'YC 22095 C2 - 30.00 €', label: 'YC 22095 C2 - 30.00 €' },
    { value: 'YC 22101 C1 - 30.00 €', label: 'YC 22101 C1 - 30.00 €' },
    { value: 'YC 23043 C2 - 30.00 €', label: 'YC 23043 C2 - 30.00 €' },
    { value: 'YC 23055 C2 - 30.00 €', label: 'YC 23055 C2 - 30.00 €' },
    { value: 'YC 23076 C3 - 30.00 €', label: 'YC 23076 C3 - 30.00 €' },
    { value: 'YC 23139 C4 - 30.00 €', label: 'YC 23139 C4 - 30.00 €' },
    { value: 'YC 23153 C3 - 30.00 €', label: 'YC 23153 C3 - 30.00 €' },
    { value: 'YC 23168 C1 - 30.00 €', label: 'YC 23168 C1 - 30.00 €' },
    { value: 'YC 23168 C2 - 30.00 €', label: 'YC 23168 C2 - 30.00 €' },
    { value: 'YC 23168 C3 - 30.00 €', label: 'YC 23168 C3 - 30.00 €' },
    { value: 'YC 25025 C2 - 30.00 €', label: 'YC 25025 C2 - 30.00 €' },
    { value: 'YC 26008 C2 - 30.00 €', label: 'YC 26008 C2 - 30.00 €' },
    { value: 'YC 26032 C1 - 30.00 €', label: 'YC 26032 C1 - 30.00 €' },
    { value: 'YC 26049 C4 - 30.00 €', label: 'YC 26049 C4 - 30.00 €' },
    { value: 'YC 28004 C1 - 30.00 €', label: 'YC 28004 C1 - 30.00 €' },
    { value: 'YC 28027 C2 - 30.00 €', label: 'YC 28027 C2 - 30.00 €' },
    { value: 'YC 28032 C3 - 30.00 €', label: 'YC 28032 C3 - 30.00 €' },
    { value: 'YC 28052 C2 - 30.00 €', label: 'YC 28052 C2 - 30.00 €' },
    { value: 'YC 28055 C3 - 30.00 €', label: 'YC 28055 C3 - 30.00 €' },
    { value: 'YC 30057 C2 - 30.00 €', label: 'YC 30057 C2 - 30.00 €' },
    { value: 'YC 313 C4 - 30.00 €', label: 'YC 313 C4 - 30.00 €' },
    { value: 'YC 34009 C3 - 30.00 €', label: 'YC 34009 C3 - 30.00 €' },
    { value: 'YC 60019 C4 - 30.00 €', label: 'YC 60019 C4 - 30.00 €' },
    { value: 'YC 60023 C8 - 30.00 €', label: 'YC 60023 C8 - 30.00 €' },
    { value: 'YC 60026 C4 - 30.00 €', label: 'YC 60026 C4 - 30.00 €' },
    { value: 'YC 60037 C4 - 30.00 €', label: 'YC 60037 C4 - 30.00 €' },
    { value: 'YC 63006 C5 - 30.00 €', label: 'YC 63006 C5 - 30.00 €' },
    { value: 'YC 63006 C6 - 30.00 €', label: 'YC 63006 C6 - 30.00 €' },
    { value: 'YC 8087 C1 - 30.00 €', label: 'YC 8087 C1 - 30.00 €' },
    { value: 'YC 9609 C1 - 30.00 €', label: 'YC 9609 C1 - 30.00 €' },
    { value: 'GC 001 C2 - 30.00 €', label: 'GC 001 C2 - 30.00 €' },
    { value: 'GC 001 C3 - 30.00 €', label: 'GC 001 C3 - 30.00 €' },
    { value: 'GC 002 C2 - 30.00 €', label: 'GC 002 C2 - 30.00 €' },
    { value: 'GC 002 C3 - 30.00 €', label: 'GC 002 C3 - 30.00 €' },
    { value: 'GC 003 C2 - 30.00 €', label: 'GC 003 C2 - 30.00 €' },
    { value: 'GC 003 C3 - 30.00 €', label: 'GC 003 C3 - 30.00 €' },
    { value: 'GC 004 C1 - 30.00 €', label: 'GC 004 C1 - 30.00 €' },
    { value: 'GC 004 C2 - 30.00 €', label: 'GC 004 C2 - 30.00 €' },
    { value: 'GC 004 C3 - 30.00 €', label: 'GC 004 C3 - 30.00 €' },
    { value: 'GC 005 C3 - 30.00 €', label: 'GC 005 C3 - 30.00 €' },
    { value: 'GC 006 C1 - 30.00 €', label: 'GC 006 C1 - 30.00 €' },
    { value: 'GC 006 C3 - 30.00 €', label: 'GC 006 C3 - 30.00 €' },
    { value: 'GC 007 C3 - 30.00 €', label: 'GC 007 C3 - 30.00 €' },
    { value: 'SYM OU 1166 C4 - 30.00 €', label: 'SYM OU 1166 C4 - 30.00 €' },
    { value: 'YC 29005 C2 - 30.00 €', label: 'YC 29005 C2 - 30.00 €' },
    { value: 'YC 29006 C2 - 30.00 €', label: 'YC 29006 C2 - 30.00 €' },
    { value: 'YC 29009 C4 - 30.00 €', label: 'YC 29009 C4 - 30.00 €' },
    { value: 'YC 29011 C1 - 30.00 €', label: 'YC 29011 C1 - 30.00 €' },
    { value: 'YC 29011 C4 - 30.00 €', label: 'YC 29011 C4 - 30.00 €' },
    { value: 'YC 29047 C3 - 30.00 €', label: 'YC 29047 C3 - 30.00 €' },
    { value: 'YC 29048 C1 - 30.00 €', label: 'YC 29048 C1 - 30.00 €' },
    { value: 'YC 29065 C1 - 30.00 €', label: 'YC 29065 C1 - 30.00 €' },
    { value: 'YC 29065 C2 - 30.00 €', label: 'YC 29065 C2 - 30.00 €' },
    { value: 'YC 30017 C1 - 30.00 €', label: 'YC 30017 C1 - 30.00 €' },
    { value: 'YC 30017 C2 - 30.00 €', label: 'YC 30017 C2 - 30.00 €' },
    { value: 'YC 31078 C1 - 30.00 €', label: 'YC 31078 C1 - 30.00 €' },
    { value: 'YC 39027 C1 - 30.00 €', label: 'YC 39027 C1 - 30.00 €' },
    { value: 'YC 39028 C2 - 30.00 €', label: 'YC 39028 C2 - 30.00 €' },
    { value: 'M 3003 C1 - 30.00 €', label: 'M 3003 C1 - 30.00 €' },
    { value: 'M 3003 C2 - 30.00 €', label: 'M 3003 C2 - 30.00 €' },
    { value: 'M 3003 C3 - 30.00 €', label: 'M 3003 C3 - 30.00 €' },
    { value: 'M 3003 C5 - 30.00 €', label: 'M 3003 C5 - 30.00 €' },
    { value: 'M 3007 C1 - 30.00 €', label: 'M 3007 C1 - 30.00 €' },
    { value: 'M 3007 C2 - 30.00 €', label: 'M 3007 C2 - 30.00 €' },
    { value: 'M 3009 C2 - 30.00 €', label: 'M 3009 C2 - 30.00 €' },
    { value: 'M 3009 C3 - 30.00 €', label: 'M 3009 C3 - 30.00 €' },
    { value: 'M 3009 C5 - 30.00 €', label: 'M 3009 C5 - 30.00 €' },
    { value: 'M 3009 C6 - 30.00 €', label: 'M 3009 C6 - 30.00 €' },
    { value: 'OU 4020 C1 - 30.00 €', label: 'OU 4020 C1 - 30.00 €' },
    { value: 'OU 4020 C3 - 30.00 €', label: 'OU 4020 C3 - 30.00 €' },
    { value: 'OU 4051 C1 - 30.00 €', label: 'OU 4051 C1 - 30.00 €' },
    { value: 'OU 4051 C3 - 30.00 €', label: 'OU 4051 C3 - 30.00 €' },
    { value: 'OU 4051 C4 - 30.00 €', label: 'OU 4051 C4 - 30.00 €' },
    { value: 'OU 4090 C1 - 30.00 €', label: 'OU 4090 C1 - 30.00 €' },
    { value: 'OU 4090 C2 - 30.00 €', label: 'OU 4090 C2 - 30.00 €' },
    { value: 'OU 4090 C3 - 30.00 €', label: 'OU 4090 C3 - 30.00 €' },
    { value: 'OU 4090 C4 - 30.00 €', label: 'OU 4090 C4 - 30.00 €' },
    { value: 'OU 4401 C1 - 30.00 €', label: 'OU 4401 C1 - 30.00 €' },
    { value: 'OU 4401 C2 - 30.00 €', label: 'OU 4401 C2 - 30.00 €' },
    { value: 'OU 4401 C3 - 30.00 €', label: 'OU 4401 C3 - 30.00 €' },
    { value: 'OU 4401 C4 - 30.00 €', label: 'OU 4401 C4 - 30.00 €' },
    { value: 'OU 4152 C1 - 30.00 €', label: 'OU 4152 C1 - 30.00 €' },
    { value: 'OU 4152 C2 - 30.00 €', label: 'OU 4152 C2 - 30.00 €' },
    { value: 'OU 4235 C1 - 30.00 €', label: 'OU 4235 C1 - 30.00 €' },
    { value: 'OU 4235 C2 - 30.00 €', label: 'OU 4235 C2 - 30.00 €' },
    { value: 'OU 4244 C4 - 30.00 €', label: 'OU 4244 C4 - 30.00 €' },
    { value: 'OU 4247 C2 - 30.00 €', label: 'OU 4247 C2 - 30.00 €' },
    { value: 'OU 4247 C3 - 30.00 €', label: 'OU 4247 C3 - 30.00 €' },
    { value: 'OU 4247 C4 - 30.00 €', label: 'OU 4247 C4 - 30.00 €' },
    { value: 'OU 4357 C1 - 30.00 €', label: 'OU 4357 C1 - 30.00 €' },
    { value: 'OU 4393 C1 - 30.00 €', label: 'OU 4393 C1 - 30.00 €' },
    { value: 'OU 4393 C3 - 30.00 €', label: 'OU 4393 C3 - 30.00 €' },
    { value: 'OU 4368 C1 - 30.00 €', label: 'OU 4368 C1 - 30.00 €' },
    { value: 'OU 4368 C2 - 30.00 €', label: 'OU 4368 C2 - 30.00 €' },
    { value: 'OU 4368 C3 - 30.00 €', label: 'OU 4368 C3 - 30.00 €' },
    { value: 'OU 4368 C4 - 30.00 €', label: 'OU 4368 C4 - 30.00 €' },
    { value: 'A 4515 C1 - 30.00 €', label: 'A 4515 C1 - 30.00 €' },
    { value: 'A 4515 C3 - 30.00 €', label: 'A 4515 C3 - 30.00 €' },
    { value: 'A 4515 C4 - 30.00 €', label: 'A 4515 C4 - 30.00 €' },
    { value: 'OU 4600 C1 - 30.00 €', label: 'OU 4600 C1 - 30.00 €' },
    { value: 'OU 4600 C4 - 30.00 €', label: 'OU 4600 C4 - 30.00 €' },
    { value: 'OU 4668 C2 - 30.00 €', label: 'OU 4668 C2 - 30.00 €' },
    { value: 'OU 4668 C3 - 30.00 €', label: 'OU 4668 C3 - 30.00 €' },
    { value: 'OU 4668 C4 - 30.00 €', label: 'OU 4668 C4 - 30.00 €' },
    { value: 'TL 2001 C4 - 30.00 €', label: 'TL 2001 C4 - 30.00 €' },
    { value: 'TL 2011 C3 - 30.00 €', label: 'TL 2011 C3 - 30.00 €' },
    { value: 'M 3010 C2 - 30.00 €', label: 'M 3010 C2 - 30.00 €' },
    { value: 'M 3010 C3 - 30.00 €', label: 'M 3010 C3 - 30.00 €' },
    { value: 'M 3010 C5 - 30.00 €', label: 'M 3010 C5 - 30.00 €' },
    { value: 'M 3010 C6 - 30.00 €', label: 'M 3010 C6 - 30.00 €' },
    { value: 'M 3012 C2 - 30.00 €', label: 'M 3012 C2 - 30.00 €' },
    { value: 'M 3012 C3 - 30.00 €', label: 'M 3012 C3 - 30.00 €' },
    { value: 'M 3012 C6 - 30.00 €', label: 'M 3012 C6 - 30.00 €' },
    { value: 'M 3013 C1 - 30.00 €', label: 'M 3013 C1 - 30.00 €' },
    { value: 'M 3013 C6 - 30.00 €', label: 'M 3013 C6 - 30.00 €' },
    { value: 'M 3018 C1 - 30.00 €', label: 'M 3018 C1 - 30.00 €' },
    { value: 'M 3018 C2 - 30.00 €', label: 'M 3018 C2 - 30.00 €' },
    { value: 'M 3018 C3 - 30.00 €', label: 'M 3018 C3 - 30.00 €' },
    { value: 'M 3020 C1 - 30.00 €', label: 'M 3020 C1 - 30.00 €' },
    { value: 'M 3020 C3 - 30.00 €', label: 'M 3020 C3 - 30.00 €' },
    { value: 'M 3020 C5 - 30.00 €', label: 'M 3020 C5 - 30.00 €' },
    { value: 'M 3021 C1 - 30.00 €', label: 'M 3021 C1 - 30.00 €' },
    { value: 'M 3021 C2 - 30.00 €', label: 'M 3021 C2 - 30.00 €' },
    { value: 'M 3021 C3 - 30.00 €', label: 'M 3021 C3 - 30.00 €' },
    { value: 'M 3021 C5 - 30.00 €', label: 'M 3021 C5 - 30.00 €' },
    { value: 'M 3025 C1 - 30.00 €', label: 'M 3025 C1 - 30.00 €' },
    { value: 'M 3025 C2 - 30.00 €', label: 'M 3025 C2 - 30.00 €' },
    { value: 'M 3025 C6 - 30.00 €', label: 'M 3025 C6 - 30.00 €' },
    { value: 'M 3027 C2 - 30.00 €', label: 'M 3027 C2 - 30.00 €' },
    { value: 'M 3027 C3 - 30.00 €', label: 'M 3027 C3 - 30.00 €' },
    { value: 'M 3027 C5 - 30.00 €', label: 'M 3027 C5 - 30.00 €' },
    { value: 'M 3027 C6 - 30.00 €', label: 'M 3027 C6 - 30.00 €' },
    { value: 'M 3037 C1 - 30.00 €', label: 'M 3037 C1 - 30.00 €' },
    { value: 'M 3037 C6 - 30.00 €', label: 'M 3037 C6 - 30.00 €' },
    { value: 'M 3060 C2 - 30.00 €', label: 'M 3060 C2 - 30.00 €' },
    { value: 'M 3060 C3 - 30.00 €', label: 'M 3060 C3 - 30.00 €' },
    { value: 'M 3061 C3 - 30.00 €', label: 'M 3061 C3 - 30.00 €' },
    { value: 'M 3061 C6 - 30.00 €', label: 'M 3061 C6 - 30.00 €' },
    { value: 'OU 4059 C3 - 30.00 €', label: 'OU 4059 C3 - 30.00 €' },
    { value: 'OU 4152 C3 - 30.00 €', label: 'OU 4152 C3 - 30.00 €' },
    { value: '0U 4160 C1 - 30.00 €', label: '0U 4160 C1 - 30.00 €' },
    { value: 'OU 4160 C2 - 30.00 €', label: 'OU 4160 C2 - 30.00 €' },
    { value: 'OU 4160 C3 - 30.00 €', label: 'OU 4160 C3 - 30.00 €' },
    { value: 'OU 4160 C4 - 30.00 €', label: 'OU 4160 C4 - 30.00 €' },
    { value: 'OU 4235 C3 - 30.00 €', label: 'OU 4235 C3 - 30.00 €' },
    { value: 'OU 4235 C4 - 30.00 €', label: 'OU 4235 C4 - 30.00 €' },
    { value: 'OU 4316 C1 - 30.00 €', label: 'OU 4316 C1 - 30.00 €' },
    { value: 'OU 4316 C2 - 30.00 €', label: 'OU 4316 C2 - 30.00 €' },
    { value: 'OU 4316 C3 - 30.00 €', label: 'OU 4316 C3 - 30.00 €' },
    { value: 'OU 4316 C4 - 30.00 €', label: 'OU 4316 C4 - 30.00 €' },
    { value: 'OU 4333 C1 - 30.00 €', label: 'OU 4333 C1 - 30.00 €' },
    { value: 'OU 4333 C2 - 30.00 €', label: 'OU 4333 C2 - 30.00 €' },
    { value: 'OU 4333 C3 - 30.00 €', label: 'OU 4333 C3 - 30.00 €' },
    { value: 'OU 4333 C4 - 30.00 €', label: 'OU 4333 C4 - 30.00 €' },
    { value: 'OU 4339 C1 - 30.00 €', label: 'OU 4339 C1 - 30.00 €' },
    { value: 'OU 4339 C4 - 30.00 €', label: 'OU 4339 C4 - 30.00 €' },
    { value: 'OU 4340 C1 - 30.00 €', label: 'OU 4340 C1 - 30.00 €' },
    { value: 'OU 4340 C2 - 30.00 €', label: 'OU 4340 C2 - 30.00 €' },
    { value: 'OU 4340 C4 - 30.00 €', label: 'OU 4340 C4 - 30.00 €' },
    { value: 'OU 4393 C2 - 30.00 €', label: 'OU 4393 C2 - 30.00 €' },
    { value: 'OU 4393 C4 - 30.00 €', label: 'OU 4393 C4 - 30.00 €' },
    { value: 'OU 4770 C1 - 30.00 €', label: 'OU 4770 C1 - 30.00 €' },
    { value: 'OU 4770 C2 - 30.00 €', label: 'OU 4770 C2 - 30.00 €' },
    { value: 'OU 4770 C3 - 30.00 €', label: 'OU 4770 C3 - 30.00 €' },
    { value: 'OU 4770 C4 - 30.00 €', label: 'OU 4770 C4 - 30.00 €' },
    { value: 'OU 4402 C1 - 30.00 €', label: 'OU 4402 C1 - 30.00 €' },
    { value: 'OU 4402 C3 - 30.00 €', label: 'OU 4402 C3 - 30.00 €' },
    { value: 'OU 4402 C4 - 30.00 €', label: 'OU 4402 C4 - 30.00 €' },
    { value: 'OU 4059 C1 - 30.00 €', label: 'OU 4059 C1 - 30.00 €' },
    { value: 'OU 4152 C1 - 30.00 €', label: 'OU 4152 C1 - 30.00 €' },
    { value: 'OU 4152 C3 - 30.00 €', label: 'OU 4152 C3 - 30.00 €' },
    { value: 'OU 4770 C4 - 30.00 €', label: 'OU 4770 C4 - 30.00 €' },
    { value: 'OU 4402 C1 - 30.00 €', label: 'OU 4402 C1 - 30.00 €' },
    { value: 'OU 4402 C3 - 30.00 €', label: 'OU 4402 C3 - 30.00 €' },
    { value: 'OU 4402 C4 - 30.00 €', label: 'OU 4402 C4 - 30.00 €' },
    { value: 'OU 4412 C1 - 30.00 €', label: 'OU 4412 C1 - 30.00 €' },
    { value: 'OU 4412 C4 - 30.00 €', label: 'OU 4412 C4 - 30.00 €' },
    { value: 'OU 4442 C2 - 30.00 €', label: 'OU 4442 C2 - 30.00 €' },
    { value: 'OU 4442 C4 - 30.00 €', label: 'OU 4442 C4 - 30.00 €' },
    { value: 'OU 4453 C1 - 30.00 €', label: 'OU 4453 C1 - 30.00 €' },
    { value: 'OU 4453 C2 - 30.00 €', label: 'OU 4453 C2 - 30.00 €' },
    { value: 'OU 4453 C3 - 30.00 €', label: 'OU 4453 C3 - 30.00 €' },
    { value: 'OU 4453 C4 - 30.00 €', label: 'OU 4453 C4 - 30.00 €' },
    { value: 'OU 4469 C1 - 30.00 €', label: 'OU 4469 C1 - 30.00 €' },
    { value: 'OU 4469 C2 - 30.00 €', label: 'OU 4469 C2 - 30.00 €' },
    { value: 'OU 4469 C4 - 30.00 €', label: 'OU 4469 C4 - 30.00 €' },
    { value: 'OU 4537 C2 - 30.00 €', label: 'OU 4537 C2 - 30.00 €' },
    { value: 'OU 4537 C3 - 30.00 €', label: 'OU 4537 C3 - 30.00 €' },
    { value: 'OU 4537 C4 - 30.00 €', label: 'OU 4537 C4 - 30.00 €' },
    { value: 'OU 4600 C1 - 30.00 €', label: 'OU 4600 C1 - 30.00 €' },
    { value: 'OU 4600 C2 - 30.00 €', label: 'OU 4600 C2 - 30.00 €' },
    { value: 'OU 4600 C3 - 30.00 €', label: 'OU 4600 C3 - 30.00 €' },
    { value: 'OU 4600 C4 - 30.00 €', label: 'OU 4600 C4 - 30.00 €' },
    { value: 'OU 4667 C2 - 30.00 €', label: 'OU 4667 C2 - 30.00 €' },
    { value: 'OU 4667 C3 - 30.00 €', label: 'OU 4667 C3 - 30.00 €' },
    { value: 'OU 4667 C4 - 30.00 €', label: 'OU 4667 C4 - 30.00 €' },
    { value: 'OU 1102 C1 - 30.00 €', label: 'OU 1102 C1 - 30.00 €' },
    { value: 'OU 1102 C2 - 30.00 €', label: 'OU 1102 C2 - 30.00 €' },
    { value: 'OU 1462 C1 - 30.00 €', label: 'OU 1462 C1 - 30.00 €' },
    { value: 'OU 1462 C3 - 30.00 €', label: 'OU 1462 C3 - 30.00 €' },
    { value: 'OU 1462 C4 - 30.00 €', label: 'OU 1462 C4 - 30.00 €' },
    { value: 'OU A4513 C1 - 30.00 €', label: 'OU A4513 C1 - 30.00 €' },
    { value: 'OU A4513 C2 - 30.00 €', label: 'OU A4513 C2 - 30.00 €' },
    { value: 'OU A4515 C2 - 30.00 €', label: 'OU A4515 C2 - 30.00 €' },
    { value: 'OU A4515 C3 - 30.00 €', label: 'OU A4515 C3 - 30.00 €' },
    { value: 'OU A4514 C2 - 30.00 €', label: 'OU A4514 C2 - 30.00 €' },
    { value: 'OU 4402 C1 - 30.00 €', label: 'OU 4402 C1 - 30.00 €' },
    { value: 'OU 4402 C3 - 30.00 €', label: 'OU 4402 C3 - 30.00 €' },
    { value: 'OU 4402 C4 - 30.00 €', label: 'OU 4402 C4 - 30.00 €' },
    { value: 'OU 4412 C1 - 30.00 €', label: 'OU 4412 C1 - 30.00 €' },
    { value: ' OU 2726 C1 - 30.00 €', label: ' OU 2726 C1 - 30.00 €' },
    { value: ' OU 2726 C2 - 30.00 €', label: ' OU 2726 C2 - 30.00 €' },
    { value: ' OU 2726 C3 - 30.00 €', label: ' OU 2726 C3 - 30.00 €' },
    { value: 'OU 2504 C1 - 30.00 €', label: 'OU 2504 C1 - 30.00 €' },
    { value: 'OU 2504 C2 - 30.00 €', label: 'OU 2504 C2 - 30.00 €' },
    { value: 'OU 2307 C3 - 30.00 €', label: 'OU 2307 C3 - 30.00 €' },
    { value: 'OU 2307 C8 - 30.00 €', label: 'OU 2307 C8 - 30.00 €' },
    { value: 'OU 2307 C5 - 30.00 €', label: 'OU 2307 C5 - 30.00 €' },
    { value: 'OU 2156 C1 - 30.00 €', label: 'OU 2156 C1 - 30.00 €' },
    { value: 'OU 2156 C2 - 30.00 €', label: 'OU 2156 C2 - 30.00 €' },
    { value: 'OU 2156 C3 - 30.00 €', label: 'OU 2156 C3 - 30.00 €' },
    { value: 'OU 2156 C4 - 30.00 €', label: 'OU 2156 C4 - 30.00 €' },
    { value: 'OU 2073 C1 - 30.00 €', label: 'OU 2073 C1 - 30.00 €' },
    { value: 'OU 2073 C2 - 30.00 €', label: 'OU 2073 C2 - 30.00 €' },
    { value: 'OU 2073 C3 - 30.00 €', label: 'OU 2073 C3 - 30.00 €' },
    { value: 'OU 2058 C2 - 30.00 €', label: 'OU 2058 C2 - 30.00 €' },
    { value: 'OU 2058 C3 - 30.00 €', label: 'OU 2058 C3 - 30.00 €' },
    { value: 'OU 2058 C4 - 30.00 €', label: 'OU 2058 C4 - 30.00 €' },
    { value: 'OU 1330 C1 - 30.00 €', label: 'OU 1330 C1 - 30.00 €' },
    { value: 'OU 1330 C2 - 30.00 €', label: 'OU 1330 C2 - 30.00 €' },
    { value: 'OU 1330 C4 - 30.00 €', label: 'OU 1330 C4 - 30.00 €' },
    { value: 'OU 1414 C1 - 30.00 €', label: 'OU 1414 C1 - 30.00 €' },
    { value: 'OU 1414 C2 - 30.00 €', label: 'OU 1414 C2 - 30.00 €' },
    { value: 'OU 1414 C3 - 30.00 €', label: 'OU 1414 C3 - 30.00 €' },
    { value: 'OU 1414 C4 - 30.00 €', label: 'OU 1414 C4 - 30.00 €' },
    { value: 'OU 1714 C4 - 30.00 €', label: 'OU 1714 C4 - 30.00 €' },
    { value: 'OU 1991 C3 - 30.00 €', label: 'OU 1991 C3 - 30.00 €' },
    { value: 'OU 1991 C4 - 30.00 €', label: 'OU 1991 C4 - 30.00 €' },
    { value: 'OU 4247 C1  - 30.00 €', label: 'OU 4247 C1  - 30.00 €' },
    { value: 'OU 4247 C2 - 30.00 €', label: 'OU 4247 C2 - 30.00 €' },
    { value: 'OU 4247 C3 - 30.00 €', label: 'OU 4247 C3 - 30.00 €' },
    { value: 'OU 4308 C1 - 30.00 €', label: 'OU 4308 C1 - 30.00 €' },
    { value: 'OU 4308 C2 - 30.00 €', label: 'OU 4308 C2 - 30.00 €' },
    { value: 'OU 4308 C3 - 30.00 €', label: 'OU 4308 C3 - 30.00 €' },
    { value: 'OU 4457 C2  - 30.00 €', label: 'OU 4457 C2  - 30.00 €' },
    { value: 'OU 4466 C1  - 30.00 €', label: 'OU 4466 C1  - 30.00 €' },
    { value: 'OU 4539 C3  - 30.00 €', label: 'OU 4539 C3  - 30.00 €' },
    { value: 'OU 4539 C4 - 30.00 €', label: 'OU 4539 C4 - 30.00 €' },
    { value: 'OU 4544 C2  - 30.00 €', label: 'OU 4544 C2  - 30.00 €' },
    { value: 'OU 4544 C4 - 30.00 €', label: 'OU 4544 C4 - 30.00 €' },
    { value: 'OU 4550 C1 - 30.00 €', label: 'OU 4550 C1 - 30.00 €' },
    { value: 'OU 4550 C2 - 30.00 €', label: 'OU 4550 C2 - 30.00 €' },
    { value: 'OU 4550 C3 - 30.00 €', label: 'OU 4550 C3 - 30.00 €' },
    { value: 'OU 4550 C4 - 30.00 €', label: 'OU 4550 C4 - 30.00 €' },
    { value: 'OU 4553 C1 - 30.00 €', label: 'OU 4553 C1 - 30.00 €' },
    { value: 'OU 4553 C2 - 30.00 €', label: 'OU 4553 C2 - 30.00 €' },
    { value: 'OU 4553 C3 - 30.00 €', label: 'OU 4553 C3 - 30.00 €' },
    { value: 'OU 4553 C4 - 30.00 €', label: 'OU 4553 C4 - 30.00 €' },
    { value: 'OU 4667 C1  - 30.00 €', label: 'OU 4667 C1  - 30.00 €' },
    { value: 'OU 4667 C4 - 30.00 €', label: 'OU 4667 C4 - 30.00 €' },
    { value: 'OU 4667 C3 - 30.00 €', label: 'OU 4667 C3 - 30.00 €' },
    { value: 'OU 4668 C1  - 30.00 €', label: 'OU 4668 C1  - 30.00 €' },
    { value: 'OU 4668 C2 - 30.00 €', label: 'OU 4668 C2 - 30.00 €' },
    { value: 'OU 4668 C3 - 30.00 €', label: 'OU 4668 C3 - 30.00 €' },
    { value: 'OU 4668 C4 - 30.00 €', label: 'OU 4668 C4 - 30.00 €' },
    { value: 'OU 4662H C1 - 30.00 €', label: 'OU 4662H C1 - 30.00 €' },
    { value: 'OU 4662H C2 - 30.00 €', label: 'OU 4662H C2 - 30.00 €' },
    { value: 'OU 4662H C3 - 30.00 €', label: 'OU 4662H C3 - 30.00 €' },
    { value: 'OU 4662H C4 - 30.00 €', label: 'OU 4662H C4 - 30.00 €' },
    { value: 'OU 4707 C2  - 30.00 €', label: 'OU 4707 C2  - 30.00 €' },
    { value: 'OU 4707 C3 - 30.00 €', label: 'OU 4707 C3 - 30.00 €' },
    { value: 'OU 4059 C1 - 30.00 €', label: 'OU 4059 C1 - 30.00 €' },
    { value: 'OU 4059 C4 - 30.00 €', label: 'OU 4059 C4 - 30.00 €' },
    { value: 'OU 4059 C3 - 30.00 €', label: 'OU 4059 C3 - 30.00 €' },
    { value: 'OU 4060 C1 - 30.00 €', label: 'OU 4060 C1 - 30.00 €' },
    { value: 'OU 4060 C2 - 30.00 €', label: 'OU 4060 C2 - 30.00 €' },
    { value: 'OU 4060 C3 - 30.00 €', label: 'OU 4060 C3 - 30.00 €' },
    { value: 'OU 4060 C4 - 30.00 €', label: 'OU 4060 C4 - 30.00 €' },
    { value: 'OU 4307 C1 - 30.00 €', label: 'OU 4307 C1 - 30.00 €' },
    { value: 'OU 4307 C2 - 30.00 €', label: 'OU 4307 C2 - 30.00 €' },
    { value: 'OU 4307 C3 - 30.00 €', label: 'OU 4307 C3 - 30.00 €' },
    { value: 'OU 4307 C4 - 30.00 €', label: 'OU 4307 C4 - 30.00 €' },
    { value: 'OU 4308 C4  - 30.00 €', label: 'OU 4308 C4  - 30.00 €' },
    { value: 'OU 4561 C1  - 30.00 €', label: 'OU 4561 C1  - 30.00 €' },
    { value: 'OU 4561 C2 - 30.00 €', label: 'OU 4561 C2 - 30.00 €' },
    { value: 'OU 4561 C3 - 30.00 €', label: 'OU 4561 C3 - 30.00 €' },
    { value: 'OU 4619 C1 - 30.00 €', label: 'OU 4619 C1 - 30.00 €' },
    { value: 'OU 4619 C2 - 30.00 €', label: 'OU 4619 C2 - 30.00 €' },
    { value: 'OU 4619 C3 - 30.00 €', label: 'OU 4619 C3 - 30.00 €' },
    { value: 'OU 4619 C4 - 30.00 €', label: 'OU 4619 C4 - 30.00 €' },
    { value: 'OU 2073 C4 - 30.00 €', label: 'OU 2073 C4 - 30.00 €' },
    { value: 'OU 2108 C3 - 30.00 €', label: 'OU 2108 C3 - 30.00 €' },
    { value: 'OU 2108 C4 - 30.00 €', label: 'OU 2108 C4 - 30.00 €' },
    { value: 'OU 2308 C1 - 30.00 €', label: 'OU 2308 C1 - 30.00 €' },
    { value: 'OU 2308 C2 - 30.00 €', label: 'OU 2308 C2 - 30.00 €' },
    { value: 'OU 2308 C3 - 30.00 €', label: 'OU 2308 C3 - 30.00 €' },
    { value: 'OU 2308 C7 - 30.00 €', label: 'OU 2308 C7 - 30.00 €' },
    { value: 'OU 2308 C5 - 30.00 €', label: 'OU 2308 C5 - 30.00 €' },
    { value: 'OU 2385 C1  - 30.00 €', label: 'OU 2385 C1  - 30.00 €' },
    { value: 'OU 2385 C4 - 30.00 €', label: 'OU 2385 C4 - 30.00 €' },
    { value: 'OU 2747 C1  - 30.00 €', label: 'OU 2747 C1  - 30.00 €' },
    { value: 'OU 2747 C2 - 30.00 €', label: 'OU 2747 C2 - 30.00 €' },
    { value: 'OU 2747 C3 - 30.00 €', label: 'OU 2747 C3 - 30.00 €' },
    { value: 'OU 2747 C4 - 30.00 €', label: 'OU 2747 C4 - 30.00 €' },
    { value: 'OU 4402 C1 - 30.00 €', label: 'OU 4402 C1 - 30.00 €' },
    { value: 'OU 4402 C3 - 30.00 €', label: 'OU 4402 C3 - 30.00 €' },
    { value: 'OU 4402 C4 - 30.00 €', label: 'OU 4402 C4 - 30.00 €' },
    { value: 'OU 4412 C1 - 30.00 €', label: 'OU 4412 C1 - 30.00 €' },
    { value: ' OU 2726 C1 - 30.00 €', label: ' OU 2726 C1 - 30.00 €' },
    { value: ' OU 2726 C2 - 30.00 €', label: ' OU 2726 C2 - 30.00 €' },
    { value: ' OU 2726 C3 - 30.00 €', label: ' OU 2726 C3 - 30.00 €' },
    { value: 'OU 2504 C1 - 30.00 €', label: 'OU 2504 C1 - 30.00 €' },
    { value: 'OU 2504 C2 - 30.00 €', label: 'OU 2504 C2 - 30.00 €' },
    { value: 'OU 2307 C3 - 30.00 €', label: 'OU 2307 C3 - 30.00 €' },
    { value: 'OU 2307 C8 - 30.00 €', label: 'OU 2307 C8 - 30.00 €' },
    { value: 'OU 2307 C5 - 30.00 €', label: 'OU 2307 C5 - 30.00 €' },
    { value: 'OU 2156 C1 - 30.00 €', label: 'OU 2156 C1 - 30.00 €' },
    { value: 'OU 2156 C2 - 30.00 €', label: 'OU 2156 C2 - 30.00 €' },
    { value: 'OU 2156 C3 - 30.00 €', label: 'OU 2156 C3 - 30.00 €' },
    { value: 'OU 2156 C4 - 30.00 €', label: 'OU 2156 C4 - 30.00 €' },
    { value: 'OU 2073 C1 - 30.00 €', label: 'OU 2073 C1 - 30.00 €' },
    { value: 'OU 2073 C2 - 30.00 €', label: 'OU 2073 C2 - 30.00 €' },
    { value: 'OU 2073 C3 - 30.00 €', label: 'OU 2073 C3 - 30.00 €' },
    { value: 'OU 2058 C2 - 30.00 €', label: 'OU 2058 C2 - 30.00 €' },
    { value: 'OU 2058 C3 - 30.00 €', label: 'OU 2058 C3 - 30.00 €' },
    { value: 'OU 2058 C4 - 30.00 €', label: 'OU 2058 C4 - 30.00 €' },
    { value: 'OU 1330 C1 - 30.00 €', label: 'OU 1330 C1 - 30.00 €' },
    { value: 'OU 1330 C2 - 30.00 €', label: 'OU 1330 C2 - 30.00 €' },
    { value: 'OU 1330 C4 - 30.00 €', label: 'OU 1330 C4 - 30.00 €' },
    { value: 'OU 1414 C1 - 30.00 €', label: 'OU 1414 C1 - 30.00 €' },
    { value: 'OU 1414 C2 - 30.00 €', label: 'OU 1414 C2 - 30.00 €' },
    { value: 'OU 1414 C3 - 30.00 €', label: 'OU 1414 C3 - 30.00 €' },
    { value: 'OU 1414 C4 - 30.00 €', label: 'OU 1414 C4 - 30.00 €' },
    { value: 'OU 1714 C4 - 30.00 €', label: 'OU 1714 C4 - 30.00 €' },
    { value: 'OU 1991 C3 - 30.00 €', label: 'OU 1991 C3 - 30.00 €' },
    { value: 'OU 1991 C4 - 30.00 €', label: 'OU 1991 C4 - 30.00 €' },
    { value: 'OU 4247 C1  - 30.00 €', label: 'OU 4247 C1  - 30.00 €' },
    { value: 'OU 4247 C2 - 30.00 €', label: 'OU 4247 C2 - 30.00 €' },
    { value: 'OU 4247 C3 - 30.00 €', label: 'OU 4247 C3 - 30.00 €' },
    { value: 'OU 4308 C1 - 30.00 €', label: 'OU 4308 C1 - 30.00 €' },
    { value: 'OU 4308 C2 - 30.00 €', label: 'OU 4308 C2 - 30.00 €' },
    { value: 'OU 4308 C3 - 30.00 €', label: 'OU 4308 C3 - 30.00 €' },
    { value: 'OU 4457 C2  - 30.00 €', label: 'OU 4457 C2  - 30.00 €' },
    { value: 'OU 4466 C1  - 30.00 €', label: 'OU 4466 C1  - 30.00 €' },
    { value: 'OU 4539 C3  - 30.00 €', label: 'OU 4539 C3  - 30.00 €' },
    { value: 'OU 4539 C4 - 30.00 €', label: 'OU 4539 C4 - 30.00 €' },
    { value: 'OU 4544 C2  - 30.00 €', label: 'OU 4544 C2  - 30.00 €' },
    { value: 'OU 4544 C4 - 30.00 €', label: 'OU 4544 C4 - 30.00 €' },
    { value: 'OU 4550 C1 - 30.00 €', label: 'OU 4550 C1 - 30.00 €' },
    { value: 'OU 4550 C2 - 30.00 €', label: 'OU 4550 C2 - 30.00 €' },
    { value: 'OU 4550 C3 - 30.00 €', label: 'OU 4550 C3 - 30.00 €' },
    { value: 'OU 4550 C4 - 30.00 €', label: 'OU 4550 C4 - 30.00 €' },
    { value: 'OU 4553 C1 - 30.00 €', label: 'OU 4553 C1 - 30.00 €' },
    { value: 'OU 4553 C2 - 30.00 €', label: 'OU 4553 C2 - 30.00 €' },
    { value: 'OU 4553 C3 - 30.00 €', label: 'OU 4553 C3 - 30.00 €' },
    { value: 'OU 4553 C4 - 30.00 €', label: 'OU 4553 C4 - 30.00 €' },
    { value: 'OU 4667 C1  - 30.00 €', label: 'OU 4667 C1  - 30.00 €' },
    { value: 'OU 4667 C4 - 30.00 €', label: 'OU 4667 C4 - 30.00 €' },
    { value: 'OU 4667 C3 - 30.00 €', label: 'OU 4667 C3 - 30.00 €' },
    { value: 'OU 4668 C1  - 30.00 €', label: 'OU 4668 C1  - 30.00 €' },
    { value: 'OU 4668 C2 - 30.00 €', label: 'OU 4668 C2 - 30.00 €' },
    { value: 'OU 4668 C3 - 30.00 €', label: 'OU 4668 C3 - 30.00 €' },
    { value: 'OU 4668 C4 - 30.00 €', label: 'OU 4668 C4 - 30.00 €' },
    { value: 'OU 4662H C1 - 30.00 €', label: 'OU 4662H C1 - 30.00 €' },
    { value: 'OU 4662H C2 - 30.00 €', label: 'OU 4662H C2 - 30.00 €' },
    { value: 'OU 4662H C3 - 30.00 €', label: 'OU 4662H C3 - 30.00 €' },
    { value: 'OU 4662H C4 - 30.00 €', label: 'OU 4662H C4 - 30.00 €' },
    { value: 'OU 4707 C2  - 30.00 €', label: 'OU 4707 C2  - 30.00 €' },
    { value: 'OU 4707 C3 - 30.00 €', label: 'OU 4707 C3 - 30.00 €' },
    { value: 'OU 4059 C1 - 30.00 €', label: 'OU 4059 C1 - 30.00 €' },
    { value: 'OU 4059 C4 - 30.00 €', label: 'OU 4059 C4 - 30.00 €' },
    { value: 'OU 4059 C3 - 30.00 €', label: 'OU 4059 C3 - 30.00 €' },
    { value: 'OU 4060 C1 - 30.00 €', label: 'OU 4060 C1 - 30.00 €' },
    { value: 'OU 4060 C2 - 30.00 €', label: 'OU 4060 C2 - 30.00 €' },
    { value: 'OU 4060 C3 - 30.00 €', label: 'OU 4060 C3 - 30.00 €' },
    { value: 'OU 4060 C4 - 30.00 €', label: 'OU 4060 C4 - 30.00 €' },
    { value: 'OU 4307 C1 - 30.00 €', label: 'OU 4307 C1 - 30.00 €' },
    { value: 'OU 4307 C2 - 30.00 €', label: 'OU 4307 C2 - 30.00 €' },
    { value: 'OU 4307 C3 - 30.00 €', label: 'OU 4307 C3 - 30.00 €' },
    { value: 'OU 4307 C4 - 30.00 €', label: 'OU 4307 C4 - 30.00 €' },
    { value: 'OU 4308 C4  - 30.00 €', label: 'OU 4308 C4  - 30.00 €' },
    { value: 'OU 4561 C1  - 30.00 €', label: 'OU 4561 C1  - 30.00 €' },
    { value: 'OU 4561 C2 - 30.00 €', label: 'OU 4561 C2 - 30.00 €' },
    { value: 'OU 4561 C3 - 30.00 €', label: 'OU 4561 C3 - 30.00 €' },
    { value: 'OU 4619 C1 - 30.00 €', label: 'OU 4619 C1 - 30.00 €' },
    { value: 'OU 4619 C2 - 30.00 €', label: 'OU 4619 C2 - 30.00 €' },
    { value: 'OU 4619 C3 - 30.00 €', label: 'OU 4619 C3 - 30.00 €' },
    { value: 'OU 4619 C4 - 30.00 €', label: 'OU 4619 C4 - 30.00 €' },
    { value: 'OU 2073 C4 - 30.00 €', label: 'OU 2073 C4 - 30.00 €' },
    { value: 'OU 2108 C3 - 30.00 €', label: 'OU 2108 C3 - 30.00 €' },
    { value: 'OU 2108 C4 - 30.00 €', label: 'OU 2108 C4 - 30.00 €' },
    { value: 'OU 2308 C1 - 30.00 €', label: 'OU 2308 C1 - 30.00 €' },
    { value: 'OU 2308 C2 - 30.00 €', label: 'OU 2308 C2 - 30.00 €' },
    { value: 'OU 2308 C3 - 30.00 €', label: 'OU 2308 C3 - 30.00 €' },
    { value: 'OU 2308 C7 - 30.00 €', label: 'OU 2308 C7 - 30.00 €' },
    { value: 'OU 2308 C5 - 30.00 €', label: 'OU 2308 C5 - 30.00 €' },
    { value: 'OU 2385 C1  - 30.00 €', label: 'OU 2385 C1  - 30.00 €' },
    { value: 'OU 2385 C4 - 30.00 €', label: 'OU 2385 C4 - 30.00 €' },
    { value: 'OU 2747 C1  - 30.00 €', label: 'OU 2747 C1  - 30.00 €' },
    { value: 'OU 2747 C2 - 30.00 €', label: 'OU 2747 C2 - 30.00 €' },
    { value: 'OU 2747 C3 - 30.00 €', label: 'OU 2747 C3 - 30.00 €' },
    { value: 'OU 2747 C4 - 30.00 €', label: 'OU 2747 C4 - 30.00 €' },
    // --- Nouvelles montures Sym ajoutées le 2026-09-17 ---
    { value: 'F-3301 - 30.00 €', label: 'F-3301 - 30.00 €' },
    { value: 'F-3306 - 30.00 €', label: 'F-3306 - 30.00 €' },
    { value: 'F-3363 - 30.00 €', label: 'F-3363 - 30.00 €' },
    { value: 'FP-2206 - 30.00 €', label: 'FP-2206 - 30.00 €' },
    { value: 'M-3001 - 30.00 €', label: 'M-3001 - 30.00 €' },
    { value: 'M-3003 - 30.00 €', label: 'M-3003 - 30.00 €' },
    { value: 'M-3005 - 30.00 €', label: 'M-3005 - 30.00 €' },
    { value: 'M-3018 - 30.00 €', label: 'M-3018 - 30.00 €' },
    { value: 'M-3020 - 30.00 €', label: 'M-3020 - 30.00 €' },
    { value: 'M-3021 - 30.00 €', label: 'M-3021 - 30.00 €' },
    { value: 'M-3022 - 30.00 €', label: 'M-3022 - 30.00 €' },
    { value: 'M-3061 - 30.00 €', label: 'M-3061 - 30.00 €' },
    { value: 'OU-1801 - 30.00 €', label: 'OU-1801 - 30.00 €' },
    { value: 'OU-25040 - 30.00 €', label: 'OU-25040 - 30.00 €' },
    { value: 'OU-4060 - 30.00 €', label: 'OU-4060 - 30.00 €' },
    { value: 'OU-4410 - 30.00 €', label: 'OU-4410 - 30.00 €' },
    { value: 'OU-4451 - 30.00 €', label: 'OU-4451 - 30.00 €' },
    { value: 'OU-4454 - 30.00 €', label: 'OU-4454 - 30.00 €' },
    { value: 'OU-4455 - 30.00 €', label: 'OU-4455 - 30.00 €' },
    { value: 'OU-4542 - 30.00 €', label: 'OU-4542 - 30.00 €' },
    { value: 'OU-4543 - 30.00 €', label: 'OU-4543 - 30.00 €' },
    { value: 'OU-4550 - 30.00 €', label: 'OU-4550 - 30.00 €' },
    { value: 'OU-4565 - 30.00 €', label: 'OU-4565 - 30.00 €' },
    { value: 'OU-4666H - 30.00 €', label: 'OU-4666H - 30.00 €' },
    { value: 'OU-4668 - 30.00 €', label: 'OU-4668 - 30.00 €' },
    { value: 'OU-4696 - 30.00 €', label: 'OU-4696 - 30.00 €' },
    { value: 'OU-4708 - 30.00 €', label: 'OU-4708 - 30.00 €' },
    { value: 'OU-4725 - 30.00 €', label: 'OU-4725 - 30.00 €' },
    { value: 'OU-4759 - 30.00 €', label: 'OU-4759 - 30.00 €' },
    { value: 'OU-4764H - 30.00 €', label: 'OU-4764H - 30.00 €' },
    { value: 'OU-7680 - 30.00 €', label: 'OU-7680 - 30.00 €' },
    { value: 'OU-S0003 - 30.00 €', label: 'OU-S0003 - 30.00 €' },
    { value: 'TR-99012 - 30.00 €', label: 'TR-99012 - 30.00 €' },
    { value: 'TR-99066 - 30.00 €', label: 'TR-99066 - 30.00 €' },
    { value: 'XB-2163 - 30.00 €', label: 'XB-2163 - 30.00 €' },
    { value: 'XB-2171 - 30.00 €', label: 'XB-2171 - 30.00 €' },
    { value: 'XB-2174 - 30.00 €', label: 'XB-2174 - 30.00 €' },
    { value: 'XB-2181 - 30.00 €', label: 'XB-2181 - 30.00 €' },
    { value: 'XB-2185 - 30.00 €', label: 'XB-2185 - 30.00 €' },
];
export const MontureB1 = [
    { value: '', label: '' },
    { value: 'Autre - 100.00 €', label: 'Autre - 100.00 €' },
    { value: 'SYM 0U 4308 C2 - 100.00 €', label: 'SYM 0U 4308 C2 - 100.00 €' },
    { value: 'SYM 12038 C3 - 100.00 €', label: 'SYM 12038 C3 - 100.00 €' },
    { value: 'SYM 12048 C4 - 100.00 €', label: 'SYM 12048 C4 - 100.00 €' },
    { value: 'SYM 15091 C2 - 100.00 €', label: 'SYM 15091 C2 - 100.00 €' },
    { value: 'SYM 23005 C2 - 100.00 €', label: 'SYM 23005 C2 - 100.00 €' },
    { value: 'SYM 26012 C3 - 100.00 €', label: 'SYM 26012 C3 - 100.00 €' },
    { value: 'SYM 62725 C3 - 100.00 €', label: 'SYM 62725 C3 - 100.00 €' },
    { value: 'SYM B 6109 C2 - 100.00 €', label: 'SYM B 6109 C2 - 100.00 €' },
    { value: 'BT 0012 C2 - 100.00 €', label: 'BT 0012 C2 - 100.00 €' },
    { value: 'BT 0014 C2 - 100.00 €', label: 'BT 0014 C2 - 100.00 €' },
    { value: 'BT 0014 C6 - 100.00 €', label: 'BT 0014 C6 - 100.00 €' },
    { value: 'IN-2216 N01 - 100.00 €', label: 'IN-2216 N01 - 100.00 €' },
    { value: 'SYM OU 1131 C1 - 100.00 €', label: 'SYM OU 1131 C1 - 100.00 €' },
    { value: 'SYM OU 1295 C2 - 100.00 €', label: 'SYM OU 1295 C2 - 100.00 €' },
    { value: 'SYM OU 1295 C4 - 100.00 €', label: 'SYM OU 1295 C4 - 100.00 €' },
    { value: 'SYM OU 1489 C1 - 100.00 €', label: 'SYM OU 1489 C1 - 100.00 €' },
    { value: 'SYM OU 1750 C3 - 100.00 €', label: 'SYM OU 1750 C3 - 100.00 €' },
    { value: 'SYM OU 4228 C4 - 100.00 €', label: 'SYM OU 4228 C4 - 100.00 €' },
    { value: 'SYM OU 4236 C4 - 100.00 €', label: 'SYM OU 4236 C4 - 100.00 €' },
    { value: 'SYM OU 4238 C1 - 100.00 €', label: 'SYM OU 4238 C1 - 100.00 €' },
    { value: 'SYM OU 4238 C2 - 100.00 €', label: 'SYM OU 4238 C2 - 100.00 €' },
    { value: 'SYM OU 4308 C3 - 100.00 €', label: 'SYM OU 4308 C3 - 100.00 €' },
    { value: 'SYM OU 4311 C2 - 100.00 €', label: 'SYM OU 4311 C2 - 100.00 €' },
    { value: 'SYM OU 4311 C4 - 100.00 €', label: 'SYM OU 4311 C4 - 100.00 €' },
    { value: 'SYM OU 4353 C3 - 100.00 €', label: 'SYM OU 4353 C3 - 100.00 €' },
    { value: 'SYM OU 4353 C4 - 100.00 €', label: 'SYM OU 4353 C4 - 100.00 €' },
    { value: 'SYM OU 4432 C2 - 100.00 €', label: 'SYM OU 4432 C2 - 100.00 €' },
    { value: 'SYM OU 4432 C3 - 100.00 €', label: 'SYM OU 4432 C3 - 100.00 €' },
    { value: 'SYM OU 4435 C3 - 100.00 €', label: 'SYM OU 4435 C3 - 100.00 €' },
    { value: 'SYM OU 4451 C1 - 100.00 €', label: 'SYM OU 4451 C1 - 100.00 €' },
    { value: 'SYM A 01 006 - 100.00 €', label: 'SYM A 01 006 - 100.00 €' },
    { value: 'SYM A 01 009 - 100.00 €', label: 'SYM A 01 009 - 100.00 €' },
    { value: 'SYM A 01 011 - 100.00 €', label: 'SYM A 01 011 - 100.00 €' },
    { value: 'SYM A 02 001 - 100.00 €', label: 'SYM A 02 001 - 100.00 €' },
    { value: 'SYM A 02 002 - 100.00 €', label: 'SYM A 02 002 - 100.00 €' },
    { value: 'SYM A 02 013 - 100.00 €', label: 'SYM A 02 013 - 100.00 €' },
    { value: 'SYM A 03 003 - 100.00 €', label: 'SYM A 03 003 - 100.00 €' },
    { value: 'SYM A 03 008 - 100.00 €', label: 'SYM A 03 008 - 100.00 €' },
    { value: 'SYM A 03 011 - 100.00 €', label: 'SYM A 03 011 - 100.00 €' },
    { value: 'SYM A 04 004 - 100.00 €', label: 'SYM A 04 004 - 100.00 €' },
    { value: 'SYM A 04 005 - 100.00 €', label: 'SYM A 04 005 - 100.00 €' },
    { value: 'SYM A 04 014 - 100.00 €', label: 'SYM A 04 014 - 100.00 €' },
    { value: 'SYM A 05 001 - 100.00 €', label: 'SYM A 05 001 - 100.00 €' },
    { value: 'SYM A 05 010 - 100.00 €', label: 'SYM A 05 010 - 100.00 €' },
    { value: 'SYM A 05 013 - 100.00 €', label: 'SYM A 05 013 - 100.00 €' },
    { value: 'SYM A 06 008 - 100.00 €', label: 'SYM A 06 008 - 100.00 €' },
    { value: 'SYM A 06 012 - 100.00 €', label: 'SYM A 06 012 - 100.00 €' },
    { value: 'SYM A 06 014 - 100.00 €', label: 'SYM A 06 014 - 100.00 €' },
    { value: 'SYM A 06 015 - 100.00 €', label: 'SYM A 06 015 - 100.00 €' },
    { value: 'SYM A 07 219 - 100.00 €', label: 'SYM A 07 219 - 100.00 €' },
    { value: 'SYM A 07 220 - 100.00 €', label: 'SYM A 07 220 - 100.00 €' },
    { value: 'SYM A 07 245 - 100.00 €', label: 'SYM A 07 245 - 100.00 €' },
    { value: 'SYM A 08 245 - 100.00 €', label: 'SYM A 08 245 - 100.00 €' },
    { value: 'SYM B 01 225 - 100.00 €', label: 'SYM B 01 225 - 100.00 €' },
    { value: 'SYM B 01 245 - 100.00 €', label: 'SYM B 01 245 - 100.00 €' },
    { value: 'SYM B 02 001 - 100.00 €', label: 'SYM B 02 001 - 100.00 €' },
    { value: 'SYM B 02 013 - 100.00 €', label: 'SYM B 02 013 - 100.00 €' },
    { value: 'SYM B 02 226 - 100.00 €', label: 'SYM B 02 226 - 100.00 €' },
    { value: 'SYM B 03 014 - 100.00 €', label: 'SYM B 03 014 - 100.00 €' },
    { value: 'SYM B 03 227 - 100.00 €', label: 'SYM B 03 227 - 100.00 €' },
    { value: 'SYM B 03 228 - 100.00 €', label: 'SYM B 03 228 - 100.00 €' },
    { value: 'SYM B 04 230 - 100.00 €', label: 'SYM B 04 230 - 100.00 €' },
    { value: 'SYM B 04 257 - 100.00 €', label: 'SYM B 04 257 - 100.00 €' },
    { value: 'SYM B 05 232 - 100.00 €', label: 'SYM B 05 232 - 100.00 €' },
    { value: 'SYM B 05 233 - 100.00 €', label: 'SYM B 05 233 - 100.00 €' },
    { value: 'SYM B 05 234 - 100.00 €', label: 'SYM B 05 234 - 100.00 €' },
    { value: 'SYM B 06 004 - 100.00 €', label: 'SYM B 06 004 - 100.00 €' },
    { value: 'SYM B 06 015 - 100.00 €', label: 'SYM B 06 015 - 100.00 €' },
    { value: 'SYM B 06 235 - 100.00 €', label: 'SYM B 06 235 - 100.00 €' },
    { value: 'SYM C 01 238 - 100.00 €', label: 'SYM C 01 238 - 100.00 €' },
    { value: 'SYM C 02 233 - 100.00 €', label: 'SYM C 02 233 - 100.00 €' },
    { value: 'SYM C 02 246 - 100.00 €', label: 'SYM C 02 246 - 100.00 €' },
    { value: 'SYM C 02 247 - 100.00 €', label: 'SYM C 02 247 - 100.00 €' },
    { value: 'SYM C 03 016 - 100.00 €', label: 'SYM C 03 016 - 100.00 €' },
    { value: 'SYM C 03 240 - 100.00 €', label: 'SYM C 03 240 - 100.00 €' },
    { value: 'SYM C 03 248 - 100.00 €', label: 'SYM C 03 248 - 100.00 €' },
    { value: 'SYM C 04 224 - 100.00 €', label: 'SYM C 04 224 - 100.00 €' },
    { value: 'SYM C 04 228 - 100.00 €', label: 'SYM C 04 228 - 100.00 €' },
    { value: 'SYM C 04 241 - 100.00 €', label: 'SYM C 04 241 - 100.00 €' },
    { value: 'SYM C 05 242 - 100.00 €', label: 'SYM C 05 242 - 100.00 €' },
    { value: 'SYM C 05 243 - 100.00 €', label: 'SYM C 05 243 - 100.00 €' },
    { value: 'SYM C 05 244 - 100.00 €', label: 'SYM C 05 244 - 100.00 €' },
    { value: 'SYM K 01 251 - 100.00 €', label: 'SYM K 01 251 - 100.00 €' },
    { value: 'SYM K 01 252 - 100.00 €', label: 'SYM K 01 252 - 100.00 €' },
    { value: 'SYM K 01 253 - 100.00 €', label: 'SYM K 01 253 - 100.00 €' },
    { value: 'SYM K 01 254 - 100.00 €', label: 'SYM K 01 254 - 100.00 €' },
    { value: 'SYM K 01 255 - 100.00 €', label: 'SYM K 01 255 - 100.00 €' },
    { value: 'SYM K 02 251 - 100.00 €', label: 'SYM K 02 251 - 100.00 €' },
    { value: 'SYM K 02 252 - 100.00 €', label: 'SYM K 02 252 - 100.00 €' },
    { value: 'SYM K 02 253 - 100.00 €', label: 'SYM K 02 253 - 100.00 €' },
    { value: 'SYM K 02 254 - 100.00 €', label: 'SYM K 02 254 - 100.00 €' },
    { value: 'SYM K 02 255 - 100.00 €', label: 'SYM K 02 255 - 100.00 €' },
    { value: 'SYM K 03 251 - 100.00 €', label: 'SYM K 03 251 - 100.00 €' },
    { value: 'SYM K 03 252 - 100.00 €', label: 'SYM K 03 252 - 100.00 €' },
    { value: 'SYM K 03 253 - 100.00 €', label: 'SYM K 03 253 - 100.00 €' },
    { value: 'SYM K 03 254 - 100.00 €', label: 'SYM K 03 254 - 100.00 €' },
    { value: 'SYM K 03 255 - 100.00 €', label: 'SYM K 03 255 - 100.00 €' },
    { value: 'SYM K 04 251 - 100.00 €', label: 'SYM K 04 251 - 100.00 €' },
    { value: 'SYM K 04 252 - 100.00 €', label: 'SYM K 04 252 - 100.00 €' },
    { value: 'SYM K 04 253 - 100.00 €', label: 'SYM K 04 253 - 100.00 €' },
    { value: 'SYM K 04 254 - 100.00 €', label: 'SYM K 04 254 - 100.00 €' },
    { value: 'SYM K 04 255 - 100.00 €', label: 'SYM K 04 255 - 100.00 €' },
    { value: 'YC 1091 C1 - 100.00 €', label: 'YC 1091 C1 - 100.00 €' },
    { value: 'YC 11069 C4 - 100.00 €', label: 'YC 11069 C4 - 100.00 €' },
    { value: 'YC 12003 C3 - 100.00 €', label: 'YC 12003 C3 - 100.00 €' },
    { value: 'YC 13001 C2 - 100.00 €', label: 'YC 13001 C2 - 100.00 €' },
    { value: 'YC 14042 C4 - 100.00 €', label: 'YC 14042 C4 - 100.00 €' },
    { value: 'YC 14044 C3 - 100.00 €', label: 'YC 14044 C3 - 100.00 €' },
    { value: 'YC 14045 C2 - 100.00 €', label: 'YC 14045 C2 - 100.00 €' },
    { value: 'YC 14047 C4 - 100.00 €', label: 'YC 14047 C4 - 100.00 €' },
    { value: 'YC 14048 C1 - 100.00 €', label: 'YC 14048 C1 - 100.00 €' },
    { value: 'YC 14048 C2 - 100.00 €', label: 'YC 14048 C2 - 100.00 €' },
    { value: 'YC 15035 C2 - 100.00 €', label: 'YC 15035 C2 - 100.00 €' },
    { value: 'YC 15085 C2 - 100.00 €', label: 'YC 15085 C2 - 100.00 €' },
    { value: 'YC 15086 C4 - 100.00 €', label: 'YC 15086 C4 - 100.00 €' },
    { value: 'YC 21002 C3 - 100.00 €', label: 'YC 21002 C3 - 100.00 €' },
    { value: 'YC 21007 C4 - 100.00 €', label: 'YC 21007 C4 - 100.00 €' },
    { value: 'YC 21009 C1 - 100.00 €', label: 'YC 21009 C1 - 100.00 €' },
    { value: 'YC 21012 C1 - 100.00 €', label: 'YC 21012 C1 - 100.00 €' },
    { value: 'YC 21012 C3 - 100.00 €', label: 'YC 21012 C3 - 100.00 €' },
    { value: 'YC 21012 C4 - 100.00 €', label: 'YC 21012 C4 - 100.00 €' },
    { value: 'YC 21013 C1 - 100.00 €', label: 'YC 21013 C1 - 100.00 €' },
    { value: 'YC 21013 C2 - 100.00 €', label: 'YC 21013 C2 - 100.00 €' },
    { value: 'YC 21013 C3 - 100.00 €', label: 'YC 21013 C3 - 100.00 €' },
    { value: 'YC 21013 C4 - 100.00 €', label: 'YC 21013 C4 - 100.00 €' },
    { value: 'YC 21031 C1 - 100.00 €', label: 'YC 21031 C1 - 100.00 €' },
    { value: 'YC 21031 C4 - 100.00 €', label: 'YC 21031 C4 - 100.00 €' },
    { value: 'YC 21034 C1 - 100.00 €', label: 'YC 21034 C1 - 100.00 €' },
    { value: 'YC 21034 C3 - 100.00 €', label: 'YC 21034 C3 - 100.00 €' },
    { value: 'YC 21036 C1 - 100.00 €', label: 'YC 21036 C1 - 100.00 €' },
    { value: 'YC 21038 C2 - 100.00 €', label: 'YC 21038 C2 - 100.00 €' },
    { value: 'YC 21039 C4 - 100.00 €', label: 'YC 21039 C4 - 100.00 €' },
    { value: 'YC 21105 C2 - 100.00 €', label: 'YC 21105 C2 - 100.00 €' },
    { value: 'YC 21105 C3 - 100.00 €', label: 'YC 21105 C3 - 100.00 €' },
    { value: 'YC 21122 C4 - 100.00 €', label: 'YC 21122 C4 - 100.00 €' },
    { value: 'YC 21131 C3 - 100.00 €', label: 'YC 21131 C3 - 100.00 €' },
    { value: 'YC 21144 C3 - 100.00 €', label: 'YC 21144 C3 - 100.00 €' },
    { value: 'YC 21144 C4 - 100.00 €', label: 'YC 21144 C4 - 100.00 €' },
    { value: 'YC 21145 C3 - 100.00 €', label: 'YC 21145 C3 - 100.00 €' },
    { value: 'YC 21145 C4 - 100.00 €', label: 'YC 21145 C4 - 100.00 €' },
    { value: 'YC 21146 C1 - 100.00 €', label: 'YC 21146 C1 - 100.00 €' },
    { value: 'YC 21147 C1 - 100.00 €', label: 'YC 21147 C1 - 100.00 €' },
    { value: 'YC 21148 C3 - 100.00 €', label: 'YC 21148 C3 - 100.00 €' },
    { value: 'YC 21148 C4 - 100.00 €', label: 'YC 21148 C4 - 100.00 €' },
    { value: 'YC 21149 C1 - 100.00 €', label: 'YC 21149 C1 - 100.00 €' },
    { value: 'YC 21151 C4 - 100.00 €', label: 'YC 21151 C4 - 100.00 €' },
    { value: 'YC 21155 C3 - 100.00 €', label: 'YC 21155 C3 - 100.00 €' },
    { value: 'YC 21156 C2 - 100.00 €', label: 'YC 21156 C2 - 100.00 €' },
    { value: 'YC 21158 C1 - 100.00 €', label: 'YC 21158 C1 - 100.00 €' },
    { value: 'YC 21158 C4 - 100.00 €', label: 'YC 21158 C4 - 100.00 €' },
    { value: 'YC 21159 C4 - 100.00 €', label: 'YC 21159 C4 - 100.00 €' },
    { value: 'YC 21163 C2 - 100.00 €', label: 'YC 21163 C2 - 100.00 €' },
    { value: 'YC 21163 C3 - 100.00 €', label: 'YC 21163 C3 - 100.00 €' },
    { value: 'YC 21166 C2 - 100.00 €', label: 'YC 21166 C2 - 100.00 €' },
    { value: 'YC 21184 C4 - 100.00 €', label: 'YC 21184 C4 - 100.00 €' },
    { value: 'YC 2171 C1 - 100.00 €', label: 'YC 2171 C1 - 100.00 €' },
    { value: 'YC 2171 C4 - 100.00 €', label: 'YC 2171 C4 - 100.00 €' },
    { value: 'YC 22034 C3 - 100.00 €', label: 'YC 22034 C3 - 100.00 €' },
    { value: 'YC 22036 C4 - 100.00 €', label: 'YC 22036 C4 - 100.00 €' },
    { value: 'YC 22043 C3 - 100.00 €', label: 'YC 22043 C3 - 100.00 €' },
    { value: 'YC 22050 C4 - 100.00 €', label: 'YC 22050 C4 - 100.00 €' },
    { value: 'YC 22057 C1 - 100.00 €', label: 'YC 22057 C1 - 100.00 €' },
    { value: 'YC 22057 C4 - 100.00 €', label: 'YC 22057 C4 - 100.00 €' },
    { value: 'YC 22082 C3 - 100.00 €', label: 'YC 22082 C3 - 100.00 €' },
    { value: 'YC 22095 C2 - 100.00 €', label: 'YC 22095 C2 - 100.00 €' },
    { value: 'YC 22101 C1 - 100.00 €', label: 'YC 22101 C1 - 100.00 €' },
    { value: 'YC 23043 C2 - 100.00 €', label: 'YC 23043 C2 - 100.00 €' },
    { value: 'YC 23055 C2 - 100.00 €', label: 'YC 23055 C2 - 100.00 €' },
    { value: 'YC 23076 C3 - 100.00 €', label: 'YC 23076 C3 - 100.00 €' },
    { value: 'YC 23139 C4 - 100.00 €', label: 'YC 23139 C4 - 100.00 €' },
    { value: 'YC 23153 C3 - 100.00 €', label: 'YC 23153 C3 - 100.00 €' },
    { value: 'YC 23168 C1 - 100.00 €', label: 'YC 23168 C1 - 100.00 €' },
    { value: 'YC 23168 C2 - 100.00 €', label: 'YC 23168 C2 - 100.00 €' },
    { value: 'YC 23168 C3 - 100.00 €', label: 'YC 23168 C3 - 100.00 €' },
    { value: 'YC 25025 C2 - 100.00 €', label: 'YC 25025 C2 - 100.00 €' },
    { value: 'YC 26008 C2 - 100.00 €', label: 'YC 26008 C2 - 100.00 €' },
    { value: 'YC 26032 C1 - 100.00 €', label: 'YC 26032 C1 - 100.00 €' },
    { value: 'YC 26049 C4 - 100.00 €', label: 'YC 26049 C4 - 100.00 €' },
    { value: 'YC 28004 C1 - 100.00 €', label: 'YC 28004 C1 - 100.00 €' },
    { value: 'YC 28027 C2 - 100.00 €', label: 'YC 28027 C2 - 100.00 €' },
    { value: 'YC 28032 C3 - 100.00 €', label: 'YC 28032 C3 - 100.00 €' },
    { value: 'YC 28052 C2 - 100.00 €', label: 'YC 28052 C2 - 100.00 €' },
    { value: 'YC 28055 C3 - 100.00 €', label: 'YC 28055 C3 - 100.00 €' },
    { value: 'YC 30057 C2 - 100.00 €', label: 'YC 30057 C2 - 100.00 €' },
    { value: 'YC 313 C4 - 100.00 €', label: 'YC 313 C4 - 100.00 €' },
    { value: 'YC 34009 C3 - 100.00 €', label: 'YC 34009 C3 - 100.00 €' },
    { value: 'YC 60019 C4 - 100.00 €', label: 'YC 60019 C4 - 100.00 €' },
    { value: 'YC 60023 C8 - 100.00 €', label: 'YC 60023 C8 - 100.00 €' },
    { value: 'YC 60026 C4 - 100.00 €', label: 'YC 60026 C4 - 100.00 €' },
    { value: 'YC 60037 C4 - 100.00 €', label: 'YC 60037 C4 - 100.00 €' },
    { value: 'YC 63006 C5 - 100.00 €', label: 'YC 63006 C5 - 100.00 €' },
    { value: 'YC 63006 C6 - 100.00 €', label: 'YC 63006 C6 - 100.00 €' },
    { value: 'YC 8087 C1 - 100.00 €', label: 'YC 8087 C1 - 100.00 €' },
    { value: 'YC 9609 C1 - 100.00 €', label: 'YC 9609 C1 - 100.00 €' },
    { value: 'GC 001 C2 - 100.00 €', label: 'GC 001 C2 - 100.00 €' },
    { value: 'GC 001 C3 - 100.00 €', label: 'GC 001 C3 - 100.00 €' },
    { value: 'GC 002 C2 - 100.00 €', label: 'GC 002 C2 - 100.00 €' },
    { value: 'GC 002 C3 - 100.00 €', label: 'GC 002 C3 - 100.00 €' },
    { value: 'GC 003 C2 - 100.00 €', label: 'GC 003 C2 - 100.00 €' },
    { value: 'GC 003 C3 - 100.00 €', label: 'GC 003 C3 - 100.00 €' },
    { value: 'GC 004 C1 - 100.00 €', label: 'GC 004 C1 - 100.00 €' },
    { value: 'GC 004 C2 - 100.00 €', label: 'GC 004 C2 - 100.00 €' },
    { value: 'GC 004 C3 - 100.00 €', label: 'GC 004 C3 - 100.00 €' },
    { value: 'GC 005 C3 - 100.00 €', label: 'GC 005 C3 - 100.00 €' },
    { value: 'GC 006 C1 - 100.00 €', label: 'GC 006 C1 - 100.00 €' },
    { value: 'GC 006 C3 - 100.00 €', label: 'GC 006 C3 - 100.00 €' },
    { value: 'GC 007 C3 - 100.00 €', label: 'GC 007 C3 - 100.00 €' },
    { value: 'SYM OU 1166 C4 - 100.00 €', label: 'SYM OU 1166 C4 - 100.00 €' },
    { value: 'YC 29005 C2 - 100.00 €', label: 'YC 29005 C2 - 100.00 €' },
    { value: 'YC 29006 C2 - 100.00 €', label: 'YC 29006 C2 - 100.00 €' },
    { value: 'YC 29009 C4 - 100.00 €', label: 'YC 29009 C4 - 100.00 €' },
    { value: 'YC 29011 C1 - 100.00 €', label: 'YC 29011 C1 - 100.00 €' },
    { value: 'YC 29011 C4 - 100.00 €', label: 'YC 29011 C4 - 100.00 €' },
    { value: 'YC 29047 C3 - 100.00 €', label: 'YC 29047 C3 - 100.00 €' },
    { value: 'YC 29048 C1 - 100.00 €', label: 'YC 29048 C1 - 100.00 €' },
    { value: 'YC 29065 C1 - 100.00 €', label: 'YC 29065 C1 - 100.00 €' },
    { value: 'YC 29065 C2 - 100.00 €', label: 'YC 29065 C2 - 100.00 €' },
    { value: 'YC 30017 C1 - 100.00 €', label: 'YC 30017 C1 - 100.00 €' },
    { value: 'YC 30017 C2 - 100.00 €', label: 'YC 30017 C2 - 100.00 €' },
    { value: 'YC 31078 C1 - 100.00 €', label: 'YC 31078 C1 - 100.00 €' },
    { value: 'YC 39027 C1 - 100.00 €', label: 'YC 39027 C1 - 100.00 €' },
    { value: 'YC 39028 C2 - 100.00 €', label: 'YC 39028 C2 - 100.00 €' },
    { value: 'M 3003 C1 - 100.00 €', label: 'M 3003 C1 - 100.00 €' },
    { value: 'M 3003 C2 - 100.00 €', label: 'M 3003 C2 - 100.00 €' },
    { value: 'M 3003 C3 - 100.00 €', label: 'M 3003 C3 - 100.00 €' },
    { value: 'M 3003 C5 - 100.00 €', label: 'M 3003 C5 - 100.00 €' },
    { value: 'M 3007 C1 - 100.00 €', label: 'M 3007 C1 - 100.00 €' },
    { value: 'M 3007 C2 - 100.00 €', label: 'M 3007 C2 - 100.00 €' },
    { value: 'M 3009 C2 - 100.00 €', label: 'M 3009 C2 - 100.00 €' },
    { value: 'M 3009 C3 - 100.00 €', label: 'M 3009 C3 - 100.00 €' },
    { value: 'M 3009 C5 - 100.00 €', label: 'M 3009 C5 - 100.00 €' },
    { value: 'M 3009 C6 - 100.00 €', label: 'M 3009 C6 - 100.00 €' },
    { value: 'OU 4020 C1 - 100.00 €', label: 'OU 4020 C1 - 100.00 €' },
    { value: 'OU 4020 C3 - 100.00 €', label: 'OU 4020 C3 - 100.00 €' },
    { value: 'OU 4051 C1 - 100.00 €', label: 'OU 4051 C1 - 100.00 €' },
    { value: 'OU 4051 C3 - 100.00 €', label: 'OU 4051 C3 - 100.00 €' },
    { value: 'OU 4051 C4 - 100.00 €', label: 'OU 4051 C4 - 100.00 €' },
    { value: 'OU 4090 C1 - 100.00 €', label: 'OU 4090 C1 - 100.00 €' },
    { value: 'OU 4090 C2 - 100.00 €', label: 'OU 4090 C2 - 100.00 €' },
    { value: 'OU 4090 C3 - 100.00 €', label: 'OU 4090 C3 - 100.00 €' },
    { value: 'OU 4090 C4 - 100.00 €', label: 'OU 4090 C4 - 100.00 €' },
    { value: 'OU 4401 C1 - 100.00 €', label: 'OU 4401 C1 - 100.00 €' },
    { value: 'OU 4401 C2 - 100.00 €', label: 'OU 4401 C2 - 100.00 €' },
    { value: 'OU 4401 C3 - 100.00 €', label: 'OU 4401 C3 - 100.00 €' },
    { value: 'OU 4401 C4 - 100.00 €', label: 'OU 4401 C4 - 100.00 €' },
    { value: 'OU 4152 C1 - 100.00 €', label: 'OU 4152 C1 - 100.00 €' },
    { value: 'OU 4152 C2 - 100.00 €', label: 'OU 4152 C2 - 100.00 €' },
    { value: 'OU 4235 C1 - 100.00 €', label: 'OU 4235 C1 - 100.00 €' },
    { value: 'OU 4235 C2 - 100.00 €', label: 'OU 4235 C2 - 100.00 €' },
    { value: 'OU 4244 C4 - 100.00 €', label: 'OU 4244 C4 - 100.00 €' },
    { value: 'OU 4247 C2 - 100.00 €', label: 'OU 4247 C2 - 100.00 €' },
    { value: 'OU 4247 C3 - 100.00 €', label: 'OU 4247 C3 - 100.00 €' },
    { value: 'OU 4247 C4 - 100.00 €', label: 'OU 4247 C4 - 100.00 €' },
    { value: 'OU 4357 C1 - 100.00 €', label: 'OU 4357 C1 - 100.00 €' },
    { value: 'OU 4393 C1 - 100.00 €', label: 'OU 4393 C1 - 100.00 €' },
    { value: 'OU 4393 C3 - 100.00 €', label: 'OU 4393 C3 - 100.00 €' },
    { value: 'OU 4368 C1 - 100.00 €', label: 'OU 4368 C1 - 100.00 €' },
    { value: 'OU 4368 C2 - 100.00 €', label: 'OU 4368 C2 - 100.00 €' },
    { value: 'OU 4368 C3 - 100.00 €', label: 'OU 4368 C3 - 100.00 €' },
    { value: 'OU 4368 C4 - 100.00 €', label: 'OU 4368 C4 - 100.00 €' },
    { value: 'A 4515 C1 - 100.00 €', label: 'A 4515 C1 - 100.00 €' },
    { value: 'A 4515 C3 - 100.00 €', label: 'A 4515 C3 - 100.00 €' },
    { value: 'A 4515 C4 - 100.00 €', label: 'A 4515 C4 - 100.00 €' },
    { value: 'OU 4600 C1 - 100.00 €', label: 'OU 4600 C1 - 100.00 €' },
    { value: 'OU 4600 C4 - 100.00 €', label: 'OU 4600 C4 - 100.00 €' },
    { value: 'OU 4668 C2 - 100.00 €', label: 'OU 4668 C2 - 100.00 €' },
    { value: 'OU 4668 C3 - 100.00 €', label: 'OU 4668 C3 - 100.00 €' },
    { value: 'OU 4668 C4 - 100.00 €', label: 'OU 4668 C4 - 100.00 €' },
    { value: 'TL 2001 C4 - 100.00 €', label: 'TL 2001 C4 - 100.00 €' },
    { value: 'TL 2011 C3 - 100.00 €', label: 'TL 2011 C3 - 100.00 €' },
    { value: 'M 3010 C2 - 100.00 €', label: 'M 3010 C2 - 100.00 €' },
    { value: 'M 3010 C3 - 100.00 €', label: 'M 3010 C3 - 100.00 €' },
    { value: 'M 3010 C5 - 100.00 €', label: 'M 3010 C5 - 100.00 €' },
    { value: 'M 3010 C6 - 100.00 €', label: 'M 3010 C6 - 100.00 €' },
    { value: 'M 3012 C2 - 100.00 €', label: 'M 3012 C2 - 100.00 €' },
    { value: 'M 3012 C3 - 100.00 €', label: 'M 3012 C3 - 100.00 €' },
    { value: 'M 3012 C6 - 100.00 €', label: 'M 3012 C6 - 100.00 €' },
    { value: 'M 3013 C1 - 100.00 €', label: 'M 3013 C1 - 100.00 €' },
    { value: 'M 3013 C6 - 100.00 €', label: 'M 3013 C6 - 100.00 €' },
    { value: 'M 3018 C1 - 100.00 €', label: 'M 3018 C1 - 100.00 €' },
    { value: 'M 3018 C2 - 100.00 €', label: 'M 3018 C2 - 100.00 €' },
    { value: 'M 3018 C3 - 100.00 €', label: 'M 3018 C3 - 100.00 €' },
    { value: 'M 3020 C1 - 100.00 €', label: 'M 3020 C1 - 100.00 €' },
    { value: 'M 3020 C3 - 100.00 €', label: 'M 3020 C3 - 100.00 €' },
    { value: 'M 3020 C5 - 100.00 €', label: 'M 3020 C5 - 100.00 €' },
    { value: 'M 3021 C1 - 100.00 €', label: 'M 3021 C1 - 100.00 €' },
    { value: 'M 3021 C2 - 100.00 €', label: 'M 3021 C2 - 100.00 €' },
    { value: 'M 3021 C3 - 100.00 €', label: 'M 3021 C3 - 100.00 €' },
    { value: 'M 3021 C5 - 100.00 €', label: 'M 3021 C5 - 100.00 €' },
    { value: 'M 3025 C1 - 100.00 €', label: 'M 3025 C1 - 100.00 €' },
    { value: 'M 3025 C2 - 100.00 €', label: 'M 3025 C2 - 100.00 €' },
    { value: 'M 3025 C6 - 100.00 €', label: 'M 3025 C6 - 100.00 €' },
    { value: 'M 3027 C2 - 100.00 €', label: 'M 3027 C2 - 100.00 €' },
    { value: 'M 3027 C3 - 100.00 €', label: 'M 3027 C3 - 100.00 €' },
    { value: 'M 3027 C5 - 100.00 €', label: 'M 3027 C5 - 100.00 €' },
    { value: 'M 3027 C6 - 100.00 €', label: 'M 3027 C6 - 100.00 €' },
    { value: 'M 3037 C1 - 100.00 €', label: 'M 3037 C1 - 100.00 €' },
    { value: 'M 3037 C6 - 100.00 €', label: 'M 3037 C6 - 100.00 €' },
    { value: 'M 3060 C2 - 100.00 €', label: 'M 3060 C2 - 100.00 €' },
    { value: 'M 3060 C3 - 100.00 €', label: 'M 3060 C3 - 100.00 €' },
    { value: 'M 3061 C3 - 100.00 €', label: 'M 3061 C3 - 100.00 €' },
    { value: 'M 3061 C6 - 100.00 €', label: 'M 3061 C6 - 100.00 €' },
    { value: 'OU 4059 C1 - 100.00 €', label: 'OU 4059 C1 - 100.00 €' },
    { value: 'OU 4152 C3 - 100.00 €', label: 'OU 4152 C3 - 100.00 €' },
    { value: '0U 4160 C1 - 100.00 €', label: '0U 4160 C1 - 100.00 €' },
    { value: 'OU 4160 C2 - 100.00 €', label: 'OU 4160 C2 - 100.00 €' },
    { value: 'OU 4160 C3 - 100.00 €', label: 'OU 4160 C3 - 100.00 €' },
    { value: 'OU 4160 C4 - 100.00 €', label: 'OU 4160 C4 - 100.00 €' },
    { value: 'OU 4235 C3 - 100.00 €', label: 'OU 4235 C3 - 100.00 €' },
    { value: 'OU 4235 C4 - 100.00 €', label: 'OU 4235 C4 - 100.00 €' },
    { value: 'OU 4316 C1 - 100.00 €', label: 'OU 4316 C1 - 100.00 €' },
    { value: 'OU 4316 C2 - 100.00 €', label: 'OU 4316 C2 - 100.00 €' },
    { value: 'OU 4316 C3 - 100.00 €', label: 'OU 4316 C3 - 100.00 €' },
    { value: 'OU 4316 C4 - 100.00 €', label: 'OU 4316 C4 - 100.00 €' },
    { value: 'OU 4333 C1 - 100.00 €', label: 'OU 4333 C1 - 100.00 €' },
    { value: 'OU 4333 C2 - 100.00 €', label: 'OU 4333 C2 - 100.00 €' },
    { value: 'OU 4333 C3 - 100.00 €', label: 'OU 4333 C3 - 100.00 €' },
    { value: 'OU 4333 C4 - 100.00 €', label: 'OU 4333 C4 - 100.00 €' },
    { value: 'OU 4339 C1 - 100.00 €', label: 'OU 4339 C1 - 100.00 €' },
    { value: 'OU 4339 C4 - 100.00 €', label: 'OU 4339 C4 - 100.00 €' },
    { value: 'OU 4340 C1 - 100.00 €', label: 'OU 4340 C1 - 100.00 €' },
    { value: 'OU 4340 C2 - 100.00 €', label: 'OU 4340 C2 - 100.00 €' },
    { value: 'OU 4340 C4 - 100.00 €', label: 'OU 4340 C4 - 100.00 €' },
    { value: 'OU 4393 C2 - 100.00 €', label: 'OU 4393 C2 - 100.00 €' },
    { value: 'OU 4393 C4 - 100.00 €', label: 'OU 4393 C4 - 100.00 €' },
    { value: 'OU 4770 C1 - 100.00 €', label: 'OU 4770 C1 - 100.00 €' },
    { value: 'OU 4770 C2 - 100.00 €', label: 'OU 4770 C2 - 100.00 €' },
    { value: 'OU 4770 C3 - 100.00 €', label: 'OU 4770 C3 - 100.00 €' },
    { value: 'OU 4770 C4 - 100.00 €', label: 'OU 4770 C4 - 100.00 €' },
    { value: 'OU 4402 C1 - 100.00 €', label: 'OU 4402 C1 - 100.00 €' },
    { value: 'OU 4402 C3 - 100.00 €', label: 'OU 4402 C3 - 100.00 €' },
    { value: 'OU 4402 C4 - 100.00 €', label: 'OU 4402 C4 - 100.00 €' },
    { value: 'OU 4059 C3 - 100.00 €', label: 'OU 4059 C3 - 100.00 €' },
    { value: 'OU 4152 C1 - 100.00 €', label: 'OU 4152 C1 - 100.00 €' },
    { value: 'OU 4152 C3 - 100.00 €', label: 'OU 4152 C3 - 100.00 €' },
    { value: 'OU 4770 C4 - 100.00 €', label: 'OU 4770 C4 - 100.00 €' },
    { value: 'OU 4402 C1 - 100.00 €', label: 'OU 4402 C1 - 100.00 €' },
    { value: 'OU 4402 C3 - 100.00 €', label: 'OU 4402 C3 - 100.00 €' },
    { value: 'OU 4402 C4 - 100.00 €', label: 'OU 4402 C4 - 100.00 €' },
    { value: 'OU 4412 C1 - 100.00 €', label: 'OU 4412 C1 - 100.00 €' },
    { value: 'OU 4412 C4 - 100.00 €', label: 'OU 4412 C4 - 100.00 €' },
    { value: 'OU 4442 C2 - 100.00 €', label: 'OU 4442 C2 - 100.00 €' },
    { value: 'OU 4442 C4 - 100.00 €', label: 'OU 4442 C4 - 100.00 €' },
    { value: 'OU 4453 C1 - 100.00 €', label: 'OU 4453 C1 - 100.00 €' },
    { value: 'OU 4453 C2 - 100.00 €', label: 'OU 4453 C2 - 100.00 €' },
    { value: 'OU 4453 C3 - 100.00 €', label: 'OU 4453 C3 - 100.00 €' },
    { value: 'OU 4453 C4 - 100.00 €', label: 'OU 4453 C4 - 100.00 €' },
    { value: 'OU 4469 C1 - 100.00 €', label: 'OU 4469 C1 - 100.00 €' },
    { value: 'OU 4469 C2 - 100.00 €', label: 'OU 4469 C2 - 100.00 €' },
    { value: 'OU 4469 C4 - 100.00 €', label: 'OU 4469 C4 - 100.00 €' },
    { value: 'OU 4537 C2 - 100.00 €', label: 'OU 4537 C2 - 100.00 €' },
    { value: 'OU 4537 C3 - 100.00 €', label: 'OU 4537 C3 - 100.00 €' },
    { value: 'OU 4537 C4 - 100.00 €', label: 'OU 4537 C4 - 100.00 €' },
    { value: 'OU 4600 C1 - 100.00 €', label: 'OU 4600 C1 - 100.00 €' },
    { value: 'OU 4600 C2 - 100.00 €', label: 'OU 4600 C2 - 100.00 €' },
    { value: 'OU 4600 C3 - 100.00 €', label: 'OU 4600 C3 - 100.00 €' },
    { value: 'OU 4600 C4 - 100.00 €', label: 'OU 4600 C4 - 100.00 €' },
    { value: 'OU 4667 C2 - 100.00 €', label: 'OU 4667 C2 - 100.00 €' },
    { value: 'OU 4667 C3 - 100.00 €', label: 'OU 4667 C3 - 100.00 €' },
    { value: 'OU 4667 C4 - 100.00 €', label: 'OU 4667 C4 - 100.00 €' },
    { value: 'OU 1102 C1 - 100.00 €', label: 'OU 1102 C1 - 100.00 €' },
    { value: 'OU 1102 C2 - 100.00 €', label: 'OU 1102 C2 - 100.00 €' },
    { value: 'OU 1462 C1 - 100.00 €', label: 'OU 1462 C1 - 100.00 €' },
    { value: 'OU 1462 C3 - 100.00 €', label: 'OU 1462 C3 - 100.00 €' },
    { value: 'OU 1462 C4 - 100.00 €', label: 'OU 1462 C4 - 100.00 €' },
    { value: 'OU A4513 C1 - 100.00 €', label: 'OU A4513 C1 - 100.00 €' },
    { value: 'OU A4513 C2 - 100.00 €', label: 'OU A4513 C2 - 100.00 €' },
    { value: 'OU A4515 C2 - 100.00 €', label: 'OU A4515 C2 - 100.00 €' },
    { value: 'OU A4515 C3 - 100.00 €', label: 'OU A4515 C3 - 100.00 €' },
    { value: 'OU A4514 C2 - 100.00 €', label: 'OU A4514 C2 - 100.00 €' },
    { value: 'OU 4402 C1 - 100.00 €', label: 'OU 4402 C1 - 100.00 €' },
    { value: 'OU 4402 C3 - 100.00 €', label: 'OU 4402 C3 - 100.00 €' },
    { value: 'OU 4402 C4 - 100.00 €', label: 'OU 4402 C4 - 100.00 €' },
    { value: 'OU 4412 C1 - 100.00 €', label: 'OU 4412 C1 - 100.00 €' },
    { value: ' OU 2726 C1 - 100.00 €', label: ' OU 2726 C1 - 100.00 €' },
    { value: ' OU 2726 C2 - 100.00 €', label: ' OU 2726 C2 - 100.00 €' },
    { value: ' OU 2726 C3 - 100.00 €', label: ' OU 2726 C3 - 100.00 €' },
    { value: 'OU 2504 C1 - 100.00 €', label: 'OU 2504 C1 - 100.00 €' },
    { value: 'OU 2504 C2 - 100.00 €', label: 'OU 2504 C2 - 100.00 €' },
    { value: 'OU 2307 C3 - 100.00 €', label: 'OU 2307 C3 - 100.00 €' },
    { value: 'OU 2307 C8 - 100.00 €', label: 'OU 2307 C8 - 100.00 €' },
    { value: 'OU 2307 C5 - 100.00 €', label: 'OU 2307 C5 - 100.00 €' },
    { value: 'OU 2156 C1 - 100.00 €', label: 'OU 2156 C1 - 100.00 €' },
    { value: 'OU 2156 C2 - 100.00 €', label: 'OU 2156 C2 - 100.00 €' },
    { value: 'OU 2156 C3 - 100.00 €', label: 'OU 2156 C3 - 100.00 €' },
    { value: 'OU 2156 C4 - 100.00 €', label: 'OU 2156 C4 - 100.00 €' },
    { value: 'OU 2073 C1 - 100.00 €', label: 'OU 2073 C1 - 100.00 €' },
    { value: 'OU 2073 C2 - 100.00 €', label: 'OU 2073 C2 - 100.00 €' },
    { value: 'OU 2073 C3 - 100.00 €', label: 'OU 2073 C3 - 100.00 €' },
    { value: 'OU 2058 C2 - 100.00 €', label: 'OU 2058 C2 - 100.00 €' },
    { value: 'OU 2058 C3 - 100.00 €', label: 'OU 2058 C3 - 100.00 €' },
    { value: 'OU 2058 C4 - 100.00 €', label: 'OU 2058 C4 - 100.00 €' },
    { value: 'OU 1330 C1 - 100.00 €', label: 'OU 1330 C1 - 100.00 €' },
    { value: 'OU 1330 C2 - 100.00 €', label: 'OU 1330 C2 - 100.00 €' },
    { value: 'OU 1330 C4 - 100.00 €', label: 'OU 1330 C4 - 100.00 €' },
    { value: 'OU 1414 C1 - 100.00 €', label: 'OU 1414 C1 - 100.00 €' },
    { value: 'OU 1414 C2 - 100.00 €', label: 'OU 1414 C2 - 100.00 €' },
    { value: 'OU 1414 C3 - 100.00 €', label: 'OU 1414 C3 - 100.00 €' },
    { value: 'OU 1414 C4 - 100.00 €', label: 'OU 1414 C4 - 100.00 €' },
    { value: 'OU 1714 C4 - 100.00 €', label: 'OU 1714 C4 - 100.00 €' },
    { value: 'OU 1991 C3 - 100.00 €', label: 'OU 1991 C3 - 100.00 €' },
    { value: 'OU 1991 C4 - 100.00 €', label: 'OU 1991 C4 - 100.00 €' },
    { value: 'OU 4247 C1  - 100.00 €', label: 'OU 4247 C1  - 100.00 €' },
    { value: 'OU 4247 C2 - 100.00 €', label: 'OU 4247 C2 - 100.00 €' },
    { value: 'OU 4247 C3 - 100.00 €', label: 'OU 4247 C3 - 100.00 €' },
    { value: 'OU 4308 C1 - 100.00 €', label: 'OU 4308 C1 - 100.00 €' },
    { value: 'OU 4308 C2 - 100.00 €', label: 'OU 4308 C2 - 100.00 €' },
    { value: 'OU 4308 C3 - 100.00 €', label: 'OU 4308 C3 - 100.00 €' },
    { value: 'OU 4457 C2  - 100.00 €', label: 'OU 4457 C2  - 100.00 €' },
    { value: 'OU 4466 C1  - 100.00 €', label: 'OU 4466 C1  - 100.00 €' },
    { value: 'OU 4539 C3  - 100.00 €', label: 'OU 4539 C3  - 100.00 €' },
    { value: 'OU 4539 C4 - 100.00 €', label: 'OU 4539 C4 - 100.00 €' },
    { value: 'OU 4544 C2  - 100.00 €', label: 'OU 4544 C2  - 100.00 €' },
    { value: 'OU 4544 C4 - 100.00 €', label: 'OU 4544 C4 - 100.00 €' },
    { value: 'OU 4550 C1 - 100.00 €', label: 'OU 4550 C1 - 100.00 €' },
    { value: 'OU 4550 C2 - 100.00 €', label: 'OU 4550 C2 - 100.00 €' },
    { value: 'OU 4550 C3 - 100.00 €', label: 'OU 4550 C3 - 100.00 €' },
    { value: 'OU 4550 C4 - 100.00 €', label: 'OU 4550 C4 - 100.00 €' },
    { value: 'OU 4553 C1 - 100.00 €', label: 'OU 4553 C1 - 100.00 €' },
    { value: 'OU 4553 C2 - 100.00 €', label: 'OU 4553 C2 - 100.00 €' },
    { value: 'OU 4553 C3 - 100.00 €', label: 'OU 4553 C3 - 100.00 €' },
    { value: 'OU 4553 C4 - 100.00 €', label: 'OU 4553 C4 - 100.00 €' },
    { value: 'OU 4667 C1  - 100.00 €', label: 'OU 4667 C1  - 100.00 €' },
    { value: 'OU 4667 C4 - 100.00 €', label: 'OU 4667 C4 - 100.00 €' },
    { value: 'OU 4667 C3 - 100.00 €', label: 'OU 4667 C3 - 100.00 €' },
    { value: 'OU 4668 C1  - 100.00 €', label: 'OU 4668 C1  - 100.00 €' },
    { value: 'OU 4668 C2 - 100.00 €', label: 'OU 4668 C2 - 100.00 €' },
    { value: 'OU 4668 C3 - 100.00 €', label: 'OU 4668 C3 - 100.00 €' },
    { value: 'OU 4668 C4 - 100.00 €', label: 'OU 4668 C4 - 100.00 €' },
    { value: 'OU 4662H C1 - 100.00 €', label: 'OU 4662H C1 - 100.00 €' },
    { value: 'OU 4662H C2 - 100.00 €', label: 'OU 4662H C2 - 100.00 €' },
    { value: 'OU 4662H C3 - 100.00 €', label: 'OU 4662H C3 - 100.00 €' },
    { value: 'OU 4662H C4 - 100.00 €', label: 'OU 4662H C4 - 100.00 €' },
    { value: 'OU 4707 C2  - 100.00 €', label: 'OU 4707 C2  - 100.00 €' },
    { value: 'OU 4707 C3 - 100.00 €', label: 'OU 4707 C3 - 100.00 €' },
    { value: 'OU 4059 C1 - 100.00 €', label: 'OU 4059 C1 - 100.00 €' },
    { value: 'OU 4059 C4 - 100.00 €', label: 'OU 4059 C4 - 100.00 €' },
    { value: 'OU 4059 C3 - 100.00 €', label: 'OU 4059 C3 - 100.00 €' },
    { value: 'OU 4060 C1 - 100.00 €', label: 'OU 4060 C1 - 100.00 €' },
    { value: 'OU 4060 C2 - 100.00 €', label: 'OU 4060 C2 - 100.00 €' },
    { value: 'OU 4060 C3 - 100.00 €', label: 'OU 4060 C3 - 100.00 €' },
    { value: 'OU 4060 C4 - 100.00 €', label: 'OU 4060 C4 - 100.00 €' },
    { value: 'OU 4307 C1 - 100.00 €', label: 'OU 4307 C1 - 100.00 €' },
    { value: 'OU 4307 C2 - 100.00 €', label: 'OU 4307 C2 - 100.00 €' },
    { value: 'OU 4307 C3 - 100.00 €', label: 'OU 4307 C3 - 100.00 €' },
    { value: 'OU 4307 C4 - 100.00 €', label: 'OU 4307 C4 - 100.00 €' },
    { value: 'OU 4308 C4  - 100.00 €', label: 'OU 4308 C4  - 100.00 €' },
    { value: 'OU 4561 C1  - 100.00 €', label: 'OU 4561 C1  - 100.00 €' },
    { value: 'OU 4561 C2 - 100.00 €', label: 'OU 4561 C2 - 100.00 €' },
    { value: 'OU 4561 C3 - 100.00 €', label: 'OU 4561 C3 - 100.00 €' },
    { value: 'OU 4619 C1 - 100.00 €', label: 'OU 4619 C1 - 100.00 €' },
    { value: 'OU 4619 C2 - 100.00 €', label: 'OU 4619 C2 - 100.00 €' },
    { value: 'OU 4619 C3 - 100.00 €', label: 'OU 4619 C3 - 100.00 €' },
    { value: 'OU 4619 C4 - 100.00 €', label: 'OU 4619 C4 - 100.00 €' },
    { value: 'OU 2073 C4 - 100.00 €', label: 'OU 2073 C4 - 100.00 €' },
    { value: 'OU 2108 C3 - 100.00 €', label: 'OU 2108 C3 - 100.00 €' },
    { value: 'OU 2108 C4 - 100.00 €', label: 'OU 2108 C4 - 100.00 €' },
    { value: 'OU 2308 C1 - 100.00 €', label: 'OU 2308 C1 - 100.00 €' },
    { value: 'OU 2308 C2 - 100.00 €', label: 'OU 2308 C2 - 100.00 €' },
    { value: 'OU 2308 C3 - 100.00 €', label: 'OU 2308 C3 - 100.00 €' },
    { value: 'OU 2308 C7 - 100.00 €', label: 'OU 2308 C7 - 100.00 €' },
    { value: 'OU 2308 C5 - 100.00 €', label: 'OU 2308 C5 - 100.00 €' },
    { value: 'OU 2385 C1  - 100.00 €', label: 'OU 2385 C1  - 100.00 €' },
    { value: 'OU 2385 C4 - 100.00 €', label: 'OU 2385 C4 - 100.00 €' },
    { value: 'OU 2747 C1  - 100.00 €', label: 'OU 2747 C1  - 100.00 €' },
    { value: 'OU 2747 C2 - 100.00 €', label: 'OU 2747 C2 - 100.00 €' },
    { value: 'OU 2747 C3 - 100.00 €', label: 'OU 2747 C3 - 100.00 €' },
    { value: 'OU 2747 C4 - 100.00 €', label: 'OU 2747 C4 - 100.00 €' },
    // --- Nouvelles montures Sym ajoutées le 2026-09-17 ---
    { value: 'F-3301 - 100.00 €', label: 'F-3301 - 100.00 €' },
    { value: 'F-3306 - 100.00 €', label: 'F-3306 - 100.00 €' },
    { value: 'F-3363 - 100.00 €', label: 'F-3363 - 100.00 €' },
    { value: 'FP-2206 - 100.00 €', label: 'FP-2206 - 100.00 €' },
    { value: 'M-3001 - 100.00 €', label: 'M-3001 - 100.00 €' },
    { value: 'M-3003 - 100.00 €', label: 'M-3003 - 100.00 €' },
    { value: 'M-3005 - 100.00 €', label: 'M-3005 - 100.00 €' },
    { value: 'M-3018 - 100.00 €', label: 'M-3018 - 100.00 €' },
    { value: 'M-3020 - 100.00 €', label: 'M-3020 - 100.00 €' },
    { value: 'M-3021 - 100.00 €', label: 'M-3021 - 100.00 €' },
    { value: 'M-3022 - 100.00 €', label: 'M-3022 - 100.00 €' },
    { value: 'M-3061 - 100.00 €', label: 'M-3061 - 100.00 €' },
    { value: 'OU-1801 - 100.00 €', label: 'OU-1801 - 100.00 €' },
    { value: 'OU-25040 - 100.00 €', label: 'OU-25040 - 100.00 €' },
    { value: 'OU-4060 - 100.00 €', label: 'OU-4060 - 100.00 €' },
    { value: 'OU-4410 - 100.00 €', label: 'OU-4410 - 100.00 €' },
    { value: 'OU-4451 - 100.00 €', label: 'OU-4451 - 100.00 €' },
    { value: 'OU-4454 - 100.00 €', label: 'OU-4454 - 100.00 €' },
    { value: 'OU-4455 - 100.00 €', label: 'OU-4455 - 100.00 €' },
    { value: 'OU-4542 - 100.00 €', label: 'OU-4542 - 100.00 €' },
    { value: 'OU-4543 - 100.00 €', label: 'OU-4543 - 100.00 €' },
    { value: 'OU-4550 - 100.00 €', label: 'OU-4550 - 100.00 €' },
    { value: 'OU-4565 - 100.00 €', label: 'OU-4565 - 100.00 €' },
    { value: 'OU-4666H - 100.00 €', label: 'OU-4666H - 100.00 €' },
    { value: 'OU-4668 - 100.00 €', label: 'OU-4668 - 100.00 €' },
    { value: 'OU-4696 - 100.00 €', label: 'OU-4696 - 100.00 €' },
    { value: 'OU-4708 - 100.00 €', label: 'OU-4708 - 100.00 €' },
    { value: 'OU-4725 - 100.00 €', label: 'OU-4725 - 100.00 €' },
    { value: 'OU-4759 - 100.00 €', label: 'OU-4759 - 100.00 €' },
    { value: 'OU-4764H - 100.00 €', label: 'OU-4764H - 100.00 €' },
    { value: 'OU-7680 - 100.00 €', label: 'OU-7680 - 100.00 €' },
    { value: 'OU-S0003 - 100.00 €', label: 'OU-S0003 - 100.00 €' },
    { value: 'TR-99012 - 100.00 €', label: 'TR-99012 - 100.00 €' },
    { value: 'TR-99066 - 100.00 €', label: 'TR-99066 - 100.00 €' },
    { value: 'XB-2163 - 100.00 €', label: 'XB-2163 - 100.00 €' },
    { value: 'XB-2171 - 100.00 €', label: 'XB-2171 - 100.00 €' },
    { value: 'XB-2174 - 100.00 €', label: 'XB-2174 - 100.00 €' },
    { value: 'XB-2181 - 100.00 €', label: 'XB-2181 - 100.00 €' },
    { value: 'XB-2185 - 100.00 €', label: 'XB-2185 - 100.00 €' },
];
export const Monture2 = [
    { value: '', label: '' },
    { value: 'Autre - 1.00 €', label: 'Autre - 1.00 €' },
    { value: 'SYM 0U 4308 C2 - 1.00 €', label: 'SYM 0U 4308 C2 - 1.00 €' },
    { value: 'SYM 12038 C3 - 1.00 €', label: 'SYM 12038 C3 - 1.00 €' },
    { value: 'SYM 12048 C4 - 1.00 €', label: 'SYM 12048 C4 - 1.00 €' },
    { value: 'SYM 15091 C2 - 1.00 €', label: 'SYM 15091 C2 - 1.00 €' },
    { value: 'SYM 23005 C2 - 1.00 €', label: 'SYM 23005 C2 - 1.00 €' },
    { value: 'SYM 26012 C3 - 1.00 €', label: 'SYM 26012 C3 - 1.00 €' },
    { value: 'SYM 62725 C3 - 1.00 €', label: 'SYM 62725 C3 - 1.00 €' },
    { value: 'SYM B 6109 C2 - 1.00 €', label: 'SYM B 6109 C2 - 1.00 €' },
    { value: 'BT 0012 C2 - 1.00 €', label: 'BT 0012 C2 - 1.00 €' },
    { value: 'BT 0014 C2 - 1.00 €', label: 'BT 0014 C2 - 1.00 €' },
    { value: 'BT 0014 C6 - 1.00 €', label: 'BT 0014 C6 - 1.00 €' },
    { value: 'IN-2216 N01 - 1.00 €', label: 'IN-2216 N01 - 1.00 €' },
    { value: 'SYM OU 1131 C1 - 1.00 €', label: 'SYM OU 1131 C1 - 1.00 €' },
    { value: 'SYM OU 1295 C2 - 1.00 €', label: 'SYM OU 1295 C2 - 1.00 €' },
    { value: 'SYM OU 1295 C4 - 1.00 €', label: 'SYM OU 1295 C4 - 1.00 €' },
    { value: 'SYM OU 1489 C1 - 1.00 €', label: 'SYM OU 1489 C1 - 1.00 €' },
    { value: 'SYM OU 1750 C3 - 1.00 €', label: 'SYM OU 1750 C3 - 1.00 €' },
    { value: 'SYM OU 4228 C4 - 1.00 €', label: 'SYM OU 4228 C4 - 1.00 €' },
    { value: 'SYM OU 4236 C4 - 1.00 €', label: 'SYM OU 4236 C4 - 1.00 €' },
    { value: 'SYM OU 4238 C1 - 1.00 €', label: 'SYM OU 4238 C1 - 1.00 €' },
    { value: 'SYM OU 4238 C2 - 1.00 €', label: 'SYM OU 4238 C2 - 1.00 €' },
    { value: 'SYM OU 4308 C3 - 1.00 €', label: 'SYM OU 4308 C3 - 1.00 €' },
    { value: 'SYM OU 4311 C2 - 1.00 €', label: 'SYM OU 4311 C2 - 1.00 €' },
    { value: 'SYM OU 4311 C4 - 1.00 €', label: 'SYM OU 4311 C4 - 1.00 €' },
    { value: 'SYM OU 4353 C3 - 1.00 €', label: 'SYM OU 4353 C3 - 1.00 €' },
    { value: 'SYM OU 4353 C4 - 1.00 €', label: 'SYM OU 4353 C4 - 1.00 €' },
    { value: 'SYM OU 4432 C2 - 1.00 €', label: 'SYM OU 4432 C2 - 1.00 €' },
    { value: 'SYM OU 4432 C3 - 1.00 €', label: 'SYM OU 4432 C3 - 1.00 €' },
    { value: 'SYM OU 4435 C3 - 1.00 €', label: 'SYM OU 4435 C3 - 1.00 €' },
    { value: 'SYM OU 4451 C1 - 1.00 €', label: 'SYM OU 4451 C1 - 1.00 €' },
    { value: 'SYM A 01 006 - 1.00 €', label: 'SYM A 01 006 - 1.00 €' },
    { value: 'SYM A 01 009 - 1.00 €', label: 'SYM A 01 009 - 1.00 €' },
    { value: 'SYM A 01 011 - 1.00 €', label: 'SYM A 01 011 - 1.00 €' },
    { value: 'SYM A 02 001 - 1.00 €', label: 'SYM A 02 001 - 1.00 €' },
    { value: 'SYM A 02 002 - 1.00 €', label: 'SYM A 02 002 - 1.00 €' },
    { value: 'SYM A 02 013 - 1.00 €', label: 'SYM A 02 013 - 1.00 €' },
    { value: 'SYM A 03 003 - 1.00 €', label: 'SYM A 03 003 - 1.00 €' },
    { value: 'SYM A 03 008 - 1.00 €', label: 'SYM A 03 008 - 1.00 €' },
    { value: 'SYM A 03 011 - 1.00 €', label: 'SYM A 03 011 - 1.00 €' },
    { value: 'SYM A 04 004 - 1.00 €', label: 'SYM A 04 004 - 1.00 €' },
    { value: 'SYM A 04 005 - 1.00 €', label: 'SYM A 04 005 - 1.00 €' },
    { value: 'SYM A 04 014 - 1.00 €', label: 'SYM A 04 014 - 1.00 €' },
    { value: 'SYM A 05 001 - 1.00 €', label: 'SYM A 05 001 - 1.00 €' },
    { value: 'SYM A 05 010 - 1.00 €', label: 'SYM A 05 010 - 1.00 €' },
    { value: 'SYM A 05 013 - 1.00 €', label: 'SYM A 05 013 - 1.00 €' },
    { value: 'SYM A 06 008 - 1.00 €', label: 'SYM A 06 008 - 1.00 €' },
    { value: 'SYM A 06 012 - 1.00 €', label: 'SYM A 06 012 - 1.00 €' },
    { value: 'SYM A 06 014 - 1.00 €', label: 'SYM A 06 014 - 1.00 €' },
    { value: 'SYM A 06 015 - 1.00 €', label: 'SYM A 06 015 - 1.00 €' },
    { value: 'SYM A 07 219 - 1.00 €', label: 'SYM A 07 219 - 1.00 €' },
    { value: 'SYM A 07 220 - 1.00 €', label: 'SYM A 07 220 - 1.00 €' },
    { value: 'SYM A 07 245 - 1.00 €', label: 'SYM A 07 245 - 1.00 €' },
    { value: 'SYM A 08 245 - 1.00 €', label: 'SYM A 08 245 - 1.00 €' },
    { value: 'SYM B 01 225 - 1.00 €', label: 'SYM B 01 225 - 1.00 €' },
    { value: 'SYM B 01 245 - 1.00 €', label: 'SYM B 01 245 - 1.00 €' },
    { value: 'SYM B 02 001 - 1.00 €', label: 'SYM B 02 001 - 1.00 €' },
    { value: 'SYM B 02 013 - 1.00 €', label: 'SYM B 02 013 - 1.00 €' },
    { value: 'SYM B 02 226 - 1.00 €', label: 'SYM B 02 226 - 1.00 €' },
    { value: 'SYM B 03 014 - 1.00 €', label: 'SYM B 03 014 - 1.00 €' },
    { value: 'SYM B 03 227 - 1.00 €', label: 'SYM B 03 227 - 1.00 €' },
    { value: 'SYM B 03 228 - 1.00 €', label: 'SYM B 03 228 - 1.00 €' },
    { value: 'SYM B 04 230 - 1.00 €', label: 'SYM B 04 230 - 1.00 €' },
    { value: 'SYM B 04 257 - 1.00 €', label: 'SYM B 04 257 - 1.00 €' },
    { value: 'SYM B 05 232 - 1.00 €', label: 'SYM B 05 232 - 1.00 €' },
    { value: 'SYM B 05 233 - 1.00 €', label: 'SYM B 05 233 - 1.00 €' },
    { value: 'SYM B 05 234 - 1.00 €', label: 'SYM B 05 234 - 1.00 €' },
    { value: 'SYM B 06 004 - 1.00 €', label: 'SYM B 06 004 - 1.00 €' },
    { value: 'SYM B 06 015 - 1.00 €', label: 'SYM B 06 015 - 1.00 €' },
    { value: 'SYM B 06 235 - 1.00 €', label: 'SYM B 06 235 - 1.00 €' },
    { value: 'SYM C 01 238 - 1.00 €', label: 'SYM C 01 238 - 1.00 €' },
    { value: 'SYM C 02 233 - 1.00 €', label: 'SYM C 02 233 - 1.00 €' },
    { value: 'SYM C 02 246 - 1.00 €', label: 'SYM C 02 246 - 1.00 €' },
    { value: 'SYM C 02 247 - 1.00 €', label: 'SYM C 02 247 - 1.00 €' },
    { value: 'SYM C 03 016 - 1.00 €', label: 'SYM C 03 016 - 1.00 €' },
    { value: 'SYM C 03 240 - 1.00 €', label: 'SYM C 03 240 - 1.00 €' },
    { value: 'SYM C 03 248 - 1.00 €', label: 'SYM C 03 248 - 1.00 €' },
    { value: 'SYM C 04 224 - 1.00 €', label: 'SYM C 04 224 - 1.00 €' },
    { value: 'SYM C 04 228 - 1.00 €', label: 'SYM C 04 228 - 1.00 €' },
    { value: 'SYM C 04 241 - 1.00 €', label: 'SYM C 04 241 - 1.00 €' },
    { value: 'SYM C 05 242 - 1.00 €', label: 'SYM C 05 242 - 1.00 €' },
    { value: 'SYM C 05 243 - 1.00 €', label: 'SYM C 05 243 - 1.00 €' },
    { value: 'SYM C 05 244 - 1.00 €', label: 'SYM C 05 244 - 1.00 €' },
    { value: 'SYM K 01 251 - 1.00 €', label: 'SYM K 01 251 - 1.00 €' },
    { value: 'SYM K 01 252 - 1.00 €', label: 'SYM K 01 252 - 1.00 €' },
    { value: 'SYM K 01 253 - 1.00 €', label: 'SYM K 01 253 - 1.00 €' },
    { value: 'SYM K 01 254 - 1.00 €', label: 'SYM K 01 254 - 1.00 €' },
    { value: 'SYM K 01 255 - 1.00 €', label: 'SYM K 01 255 - 1.00 €' },
    { value: 'SYM K 02 251 - 1.00 €', label: 'SYM K 02 251 - 1.00 €' },
    { value: 'SYM K 02 252 - 1.00 €', label: 'SYM K 02 252 - 1.00 €' },
    { value: 'SYM K 02 253 - 1.00 €', label: 'SYM K 02 253 - 1.00 €' },
    { value: 'SYM K 02 254 - 1.00 €', label: 'SYM K 02 254 - 1.00 €' },
    { value: 'SYM K 02 255 - 1.00 €', label: 'SYM K 02 255 - 1.00 €' },
    { value: 'SYM K 03 251 - 1.00 €', label: 'SYM K 03 251 - 1.00 €' },
    { value: 'SYM K 03 252 - 1.00 €', label: 'SYM K 03 252 - 1.00 €' },
    { value: 'SYM K 03 253 - 1.00 €', label: 'SYM K 03 253 - 1.00 €' },
    { value: 'SYM K 03 254 - 1.00 €', label: 'SYM K 03 254 - 1.00 €' },
    { value: 'SYM K 03 255 - 1.00 €', label: 'SYM K 03 255 - 1.00 €' },
    { value: 'SYM K 04 251 - 1.00 €', label: 'SYM K 04 251 - 1.00 €' },
    { value: 'SYM K 04 252 - 1.00 €', label: 'SYM K 04 252 - 1.00 €' },
    { value: 'SYM K 04 253 - 1.00 €', label: 'SYM K 04 253 - 1.00 €' },
    { value: 'SYM K 04 254 - 1.00 €', label: 'SYM K 04 254 - 1.00 €' },
    { value: 'SYM K 04 255 - 1.00 €', label: 'SYM K 04 255 - 1.00 €' },
    { value: 'YC 1091 C1 - 1.00 €', label: 'YC 1091 C1 - 1.00 €' },
    { value: 'YC 11069 C4 - 1.00 €', label: 'YC 11069 C4 - 1.00 €' },
    { value: 'YC 12003 C3 - 1.00 €', label: 'YC 12003 C3 - 1.00 €' },
    { value: 'YC 13001 C2 - 1.00 €', label: 'YC 13001 C2 - 1.00 €' },
    { value: 'YC 14042 C4 - 1.00 €', label: 'YC 14042 C4 - 1.00 €' },
    { value: 'YC 14044 C3 - 1.00 €', label: 'YC 14044 C3 - 1.00 €' },
    { value: 'YC 14045 C2 - 1.00 €', label: 'YC 14045 C2 - 1.00 €' },
    { value: 'YC 14047 C4 - 1.00 €', label: 'YC 14047 C4 - 1.00 €' },
    { value: 'YC 14048 C1 - 1.00 €', label: 'YC 14048 C1 - 1.00 €' },
    { value: 'YC 14048 C2 - 1.00 €', label: 'YC 14048 C2 - 1.00 €' },
    { value: 'YC 15035 C2 - 1.00 €', label: 'YC 15035 C2 - 1.00 €' },
    { value: 'YC 15085 C2 - 1.00 €', label: 'YC 15085 C2 - 1.00 €' },
    { value: 'YC 15086 C4 - 1.00 €', label: 'YC 15086 C4 - 1.00 €' },
    { value: 'YC 21002 C3 - 1.00 €', label: 'YC 21002 C3 - 1.00 €' },
    { value: 'YC 21007 C4 - 1.00 €', label: 'YC 21007 C4 - 1.00 €' },
    { value: 'YC 21009 C1 - 1.00 €', label: 'YC 21009 C1 - 1.00 €' },
    { value: 'YC 21012 C1 - 1.00 €', label: 'YC 21012 C1 - 1.00 €' },
    { value: 'YC 21012 C3 - 1.00 €', label: 'YC 21012 C3 - 1.00 €' },
    { value: 'YC 21012 C4 - 1.00 €', label: 'YC 21012 C4 - 1.00 €' },
    { value: 'YC 21013 C1 - 1.00 €', label: 'YC 21013 C1 - 1.00 €' },
    { value: 'YC 21013 C2 - 1.00 €', label: 'YC 21013 C2 - 1.00 €' },
    { value: 'YC 21013 C3 - 1.00 €', label: 'YC 21013 C3 - 1.00 €' },
    { value: 'YC 21013 C4 - 1.00 €', label: 'YC 21013 C4 - 1.00 €' },
    { value: 'YC 21031 C1 - 1.00 €', label: 'YC 21031 C1 - 1.00 €' },
    { value: 'YC 21031 C4 - 1.00 €', label: 'YC 21031 C4 - 1.00 €' },
    { value: 'YC 21034 C1 - 1.00 €', label: 'YC 21034 C1 - 1.00 €' },
    { value: 'YC 21034 C3 - 1.00 €', label: 'YC 21034 C3 - 1.00 €' },
    { value: 'YC 21036 C1 - 1.00 €', label: 'YC 21036 C1 - 1.00 €' },
    { value: 'YC 21038 C2 - 1.00 €', label: 'YC 21038 C2 - 1.00 €' },
    { value: 'YC 21039 C4 - 1.00 €', label: 'YC 21039 C4 - 1.00 €' },
    { value: 'YC 21105 C2 - 1.00 €', label: 'YC 21105 C2 - 1.00 €' },
    { value: 'YC 21105 C3 - 1.00 €', label: 'YC 21105 C3 - 1.00 €' },
    { value: 'YC 21122 C4 - 1.00 €', label: 'YC 21122 C4 - 1.00 €' },
    { value: 'YC 21131 C3 - 1.00 €', label: 'YC 21131 C3 - 1.00 €' },
    { value: 'YC 21144 C3 - 1.00 €', label: 'YC 21144 C3 - 1.00 €' },
    { value: 'YC 21144 C4 - 1.00 €', label: 'YC 21144 C4 - 1.00 €' },
    { value: 'YC 21145 C3 - 1.00 €', label: 'YC 21145 C3 - 1.00 €' },
    { value: 'YC 21145 C4 - 1.00 €', label: 'YC 21145 C4 - 1.00 €' },
    { value: 'YC 21146 C1 - 1.00 €', label: 'YC 21146 C1 - 1.00 €' },
    { value: 'YC 21147 C1 - 1.00 €', label: 'YC 21147 C1 - 1.00 €' },
    { value: 'YC 21148 C3 - 1.00 €', label: 'YC 21148 C3 - 1.00 €' },
    { value: 'YC 21148 C4 - 1.00 €', label: 'YC 21148 C4 - 1.00 €' },
    { value: 'YC 21149 C1 - 1.00 €', label: 'YC 21149 C1 - 1.00 €' },
    { value: 'YC 21151 C4 - 1.00 €', label: 'YC 21151 C4 - 1.00 €' },
    { value: 'YC 21155 C3 - 1.00 €', label: 'YC 21155 C3 - 1.00 €' },
    { value: 'YC 21156 C2 - 1.00 €', label: 'YC 21156 C2 - 1.00 €' },
    { value: 'YC 21158 C1 - 1.00 €', label: 'YC 21158 C1 - 1.00 €' },
    { value: 'YC 21158 C4 - 1.00 €', label: 'YC 21158 C4 - 1.00 €' },
    { value: 'YC 21159 C4 - 1.00 €', label: 'YC 21159 C4 - 1.00 €' },
    { value: 'YC 21163 C2 - 1.00 €', label: 'YC 21163 C2 - 1.00 €' },
    { value: 'YC 21163 C3 - 1.00 €', label: 'YC 21163 C3 - 1.00 €' },
    { value: 'YC 21166 C2 - 1.00 €', label: 'YC 21166 C2 - 1.00 €' },
    { value: 'YC 21184 C4 - 1.00 €', label: 'YC 21184 C4 - 1.00 €' },
    { value: 'YC 2171 C1 - 1.00 €', label: 'YC 2171 C1 - 1.00 €' },
    { value: 'YC 2171 C4 - 1.00 €', label: 'YC 2171 C4 - 1.00 €' },
    { value: 'YC 22034 C3 - 1.00 €', label: 'YC 22034 C3 - 1.00 €' },
    { value: 'YC 22036 C4 - 1.00 €', label: 'YC 22036 C4 - 1.00 €' },
    { value: 'YC 22043 C3 - 1.00 €', label: 'YC 22043 C3 - 1.00 €' },
    { value: 'YC 22050 C4 - 1.00 €', label: 'YC 22050 C4 - 1.00 €' },
    { value: 'YC 22057 C1 - 1.00 €', label: 'YC 22057 C1 - 1.00 €' },
    { value: 'YC 22057 C4 - 1.00 €', label: 'YC 22057 C4 - 1.00 €' },
    { value: 'YC 22082 C3 - 1.00 €', label: 'YC 22082 C3 - 1.00 €' },
    { value: 'YC 22095 C2 - 1.00 €', label: 'YC 22095 C2 - 1.00 €' },
    { value: 'YC 22101 C1 - 1.00 €', label: 'YC 22101 C1 - 1.00 €' },
    { value: 'YC 23043 C2 - 1.00 €', label: 'YC 23043 C2 - 1.00 €' },
    { value: 'YC 23055 C2 - 1.00 €', label: 'YC 23055 C2 - 1.00 €' },
    { value: 'YC 23076 C3 - 1.00 €', label: 'YC 23076 C3 - 1.00 €' },
    { value: 'YC 23139 C4 - 1.00 €', label: 'YC 23139 C4 - 1.00 €' },
    { value: 'YC 23153 C3 - 1.00 €', label: 'YC 23153 C3 - 1.00 €' },
    { value: 'YC 23168 C1 - 1.00 €', label: 'YC 23168 C1 - 1.00 €' },
    { value: 'YC 23168 C2 - 1.00 €', label: 'YC 23168 C2 - 1.00 €' },
    { value: 'YC 23168 C3 - 1.00 €', label: 'YC 23168 C3 - 1.00 €' },
    { value: 'YC 25025 C2 - 1.00 €', label: 'YC 25025 C2 - 1.00 €' },
    { value: 'YC 26008 C2 - 1.00 €', label: 'YC 26008 C2 - 1.00 €' },
    { value: 'YC 26032 C1 - 1.00 €', label: 'YC 26032 C1 - 1.00 €' },
    { value: 'YC 26049 C4 - 1.00 €', label: 'YC 26049 C4 - 1.00 €' },
    { value: 'YC 28004 C1 - 1.00 €', label: 'YC 28004 C1 - 1.00 €' },
    { value: 'YC 28027 C2 - 1.00 €', label: 'YC 28027 C2 - 1.00 €' },
    { value: 'YC 28032 C3 - 1.00 €', label: 'YC 28032 C3 - 1.00 €' },
    { value: 'YC 28052 C2 - 1.00 €', label: 'YC 28052 C2 - 1.00 €' },
    { value: 'YC 28055 C3 - 1.00 €', label: 'YC 28055 C3 - 1.00 €' },
    { value: 'YC 30057 C2 - 1.00 €', label: 'YC 30057 C2 - 1.00 €' },
    { value: 'YC 313 C4 - 1.00 €', label: 'YC 313 C4 - 1.00 €' },
    { value: 'YC 34009 C3 - 1.00 €', label: 'YC 34009 C3 - 1.00 €' },
    { value: 'YC 60019 C4 - 1.00 €', label: 'YC 60019 C4 - 1.00 €' },
    { value: 'YC 60023 C8 - 1.00 €', label: 'YC 60023 C8 - 1.00 €' },
    { value: 'YC 60026 C4 - 1.00 €', label: 'YC 60026 C4 - 1.00 €' },
    { value: 'YC 60037 C4 - 1.00 €', label: 'YC 60037 C4 - 1.00 €' },
    { value: 'YC 63006 C5 - 1.00 €', label: 'YC 63006 C5 - 1.00 €' },
    { value: 'YC 63006 C6 - 1.00 €', label: 'YC 63006 C6 - 1.00 €' },
    { value: 'YC 8087 C1 - 1.00 €', label: 'YC 8087 C1 - 1.00 €' },
    { value: 'YC 9609 C1 - 1.00 €', label: 'YC 9609 C1 - 1.00 €' },
    { value: 'GC 001 C2 - 1.00 €', label: 'GC 001 C2 - 1.00 €' },
    { value: 'GC 001 C3 - 1.00 €', label: 'GC 001 C3 - 1.00 €' },
    { value: 'GC 002 C2 - 1.00 €', label: 'GC 002 C2 - 1.00 €' },
    { value: 'GC 002 C3 - 1.00 €', label: 'GC 002 C3 - 1.00 €' },
    { value: 'GC 003 C2 - 1.00 €', label: 'GC 003 C2 - 1.00 €' },
    { value: 'GC 003 C3 - 1.00 €', label: 'GC 003 C3 - 1.00 €' },
    { value: 'GC 004 C1 - 1.00 €', label: 'GC 004 C1 - 1.00 €' },
    { value: 'GC 004 C2 - 1.00 €', label: 'GC 004 C2 - 1.00 €' },
    { value: 'GC 004 C3 - 1.00 €', label: 'GC 004 C3 - 1.00 €' },
    { value: 'GC 005 C3 - 1.00 €', label: 'GC 005 C3 - 1.00 €' },
    { value: 'GC 006 C1 - 1.00 €', label: 'GC 006 C1 - 1.00 €' },
    { value: 'GC 006 C3 - 1.00 €', label: 'GC 006 C3 - 1.00 €' },
    { value: 'GC 007 C3 - 1.00 €', label: 'GC 007 C3 - 1.00 €' },
    { value: 'SYM OU 1166 C4 - 1.00 €', label: 'SYM OU 1166 C4 - 1.00 €' },
    { value: 'YC 29005 C2 - 1.00 €', label: 'YC 29005 C2 - 1.00 €' },
    { value: 'YC 29006 C2 - 1.00 €', label: 'YC 29006 C2 - 1.00 €' },
    { value: 'YC 29009 C4 - 1.00 €', label: 'YC 29009 C4 - 1.00 €' },
    { value: 'YC 29011 C1 - 1.00 €', label: 'YC 29011 C1 - 1.00 €' },
    { value: 'YC 29011 C4 - 1.00 €', label: 'YC 29011 C4 - 1.00 €' },
    { value: 'YC 29047 C3 - 1.00 €', label: 'YC 29047 C3 - 1.00 €' },
    { value: 'YC 29048 C1 - 1.00 €', label: 'YC 29048 C1 - 1.00 €' },
    { value: 'YC 29065 C1 - 1.00 €', label: 'YC 29065 C1 - 1.00 €' },
    { value: 'YC 29065 C2 - 1.00 €', label: 'YC 29065 C2 - 1.00 €' },
    { value: 'YC 30017 C1 - 1.00 €', label: 'YC 30017 C1 - 1.00 €' },
    { value: 'YC 30017 C2 - 1.00 €', label: 'YC 30017 C2 - 1.00 €' },
    { value: 'YC 31078 C1 - 1.00 €', label: 'YC 31078 C1 - 1.00 €' },
    { value: 'YC 39027 C1 - 1.00 €', label: 'YC 39027 C1 - 1.00 €' },
    { value: 'YC 39028 C2 - 1.00 €', label: 'YC 39028 C2 - 1.00 €' },
    { value: 'M 3003 C1 - 1.00 €', label: 'M 3003 C1 - 1.00 €' },
    { value: 'M 3003 C2 - 1.00 €', label: 'M 3003 C2 - 1.00 €' },
    { value: 'M 3003 C3 - 1.00 €', label: 'M 3003 C3 - 1.00 €' },
    { value: 'M 3003 C5 - 1.00 €', label: 'M 3003 C5 - 1.00 €' },
    { value: 'M 3007 C1 - 1.00 €', label: 'M 3007 C1 - 1.00 €' },
    { value: 'M 3007 C2 - 1.00 €', label: 'M 3007 C2 - 1.00 €' },
    { value: 'M 3009 C2 - 1.00 €', label: 'M 3009 C2 - 1.00 €' },
    { value: 'M 3009 C3 - 1.00 €', label: 'M 3009 C3 - 1.00 €' },
    { value: 'M 3009 C5 - 1.00 €', label: 'M 3009 C5 - 1.00 €' },
    { value: 'M 3009 C6 - 1.00 €', label: 'M 3009 C6 - 1.00 €' },
    { value: 'OU 4020 C1 - 1.00 €', label: 'OU 4020 C1 - 1.00 €' },
    { value: 'OU 4020 C3 - 1.00 €', label: 'OU 4020 C3 - 1.00 €' },
    { value: 'OU 4051 C1 - 1.00 €', label: 'OU 4051 C1 - 1.00 €' },
    { value: 'OU 4051 C3 - 1.00 €', label: 'OU 4051 C3 - 1.00 €' },
    { value: 'OU 4051 C4 - 1.00 €', label: 'OU 4051 C4 - 1.00 €' },
    { value: 'OU 4090 C1 - 1.00 €', label: 'OU 4090 C1 - 1.00 €' },
    { value: 'OU 4090 C2 - 1.00 €', label: 'OU 4090 C2 - 1.00 €' },
    { value: 'OU 4090 C3 - 1.00 €', label: 'OU 4090 C3 - 1.00 €' },
    { value: 'OU 4090 C4 - 1.00 €', label: 'OU 4090 C4 - 1.00 €' },
    { value: 'OU 4401 C1 - 1.00 €', label: 'OU 4401 C1 - 1.00 €' },
    { value: 'OU 4401 C2 - 1.00 €', label: 'OU 4401 C2 - 1.00 €' },
    { value: 'OU 4401 C3 - 1.00 €', label: 'OU 4401 C3 - 1.00 €' },
    { value: 'OU 4401 C4 - 1.00 €', label: 'OU 4401 C4 - 1.00 €' },
    { value: 'OU 4152 C1 - 1.00 €', label: 'OU 4152 C1 - 1.00 €' },
    { value: 'OU 4152 C2 - 1.00 €', label: 'OU 4152 C2 - 1.00 €' },
    { value: 'OU 4235 C1 - 1.00 €', label: 'OU 4235 C1 - 1.00 €' },
    { value: 'OU 4235 C2 - 1.00 €', label: 'OU 4235 C2 - 1.00 €' },
    { value: 'OU 4244 C4 - 1.00 €', label: 'OU 4244 C4 - 1.00 €' },
    { value: 'OU 4247 C2 - 1.00 €', label: 'OU 4247 C2 - 1.00 €' },
    { value: 'OU 4247 C3 - 1.00 €', label: 'OU 4247 C3 - 1.00 €' },
    { value: 'OU 4247 C4 - 1.00 €', label: 'OU 4247 C4 - 1.00 €' },
    { value: 'OU 4357 C1 - 1.00 €', label: 'OU 4357 C1 - 1.00 €' },
    { value: 'OU 4393 C1 - 1.00 €', label: 'OU 4393 C1 - 1.00 €' },
    { value: 'OU 4393 C3 - 1.00 €', label: 'OU 4393 C3 - 1.00 €' },
    { value: 'OU 4368 C1 - 1.00 €', label: 'OU 4368 C1 - 1.00 €' },
    { value: 'OU 4368 C2 - 1.00 €', label: 'OU 4368 C2 - 1.00 €' },
    { value: 'OU 4368 C3 - 1.00 €', label: 'OU 4368 C3 - 1.00 €' },
    { value: 'OU 4368 C4 - 1.00 €', label: 'OU 4368 C4 - 1.00 €' },
    { value: 'A 4515 C1 - 1.00 €', label: 'A 4515 C1 - 1.00 €' },
    { value: 'A 4515 C3 - 1.00 €', label: 'A 4515 C3 - 1.00 €' },
    { value: 'A 4515 C4 - 1.00 €', label: 'A 4515 C4 - 1.00 €' },
    { value: 'OU 4600 C1 - 1.00 €', label: 'OU 4600 C1 - 1.00 €' },
    { value: 'OU 4600 C4 - 1.00 €', label: 'OU 4600 C4 - 1.00 €' },
    { value: 'OU 4668 C2 - 1.00 €', label: 'OU 4668 C2 - 1.00 €' },
    { value: 'OU 4668 C3 - 1.00 €', label: 'OU 4668 C3 - 1.00 €' },
    { value: 'OU 4668 C4 - 1.00 €', label: 'OU 4668 C4 - 1.00 €' },
    { value: 'TL 2001 C4 - 1.00 €', label: 'TL 2001 C4 - 1.00 €' },
    { value: 'TL 2011 C3 - 1.00 €', label: 'TL 2011 C3 - 1.00 €' },
    { value: 'M 3010 C2 - 1.00 €', label: 'M 3010 C2 - 1.00 €' },
    { value: 'M 3010 C3 - 1.00 €', label: 'M 3010 C3 - 1.00 €' },
    { value: 'M 3010 C5 - 1.00 €', label: 'M 3010 C5 - 1.00 €' },
    { value: 'M 3010 C6 - 1.00 €', label: 'M 3010 C6 - 1.00 €' },
    { value: 'M 3012 C2 - 1.00 €', label: 'M 3012 C2 - 1.00 €' },
    { value: 'M 3012 C3 - 1.00 €', label: 'M 3012 C3 - 1.00 €' },
    { value: 'M 3012 C6 - 1.00 €', label: 'M 3012 C6 - 1.00 €' },
    { value: 'M 3013 C1 - 1.00 €', label: 'M 3013 C1 - 1.00 €' },
    { value: 'M 3013 C6 - 1.00 €', label: 'M 3013 C6 - 1.00 €' },
    { value: 'M 3018 C1 - 1.00 €', label: 'M 3018 C1 - 1.00 €' },
    { value: 'M 3018 C2 - 1.00 €', label: 'M 3018 C2 - 1.00 €' },
    { value: 'M 3018 C3 - 1.00 €', label: 'M 3018 C3 - 1.00 €' },
    { value: 'M 3020 C1 - 1.00 €', label: 'M 3020 C1 - 1.00 €' },
    { value: 'M 3020 C3 - 1.00 €', label: 'M 3020 C3 - 1.00 €' },
    { value: 'M 3020 C5 - 1.00 €', label: 'M 3020 C5 - 1.00 €' },
    { value: 'M 3021 C1 - 1.00 €', label: 'M 3021 C1 - 1.00 €' },
    { value: 'M 3021 C2 - 1.00 €', label: 'M 3021 C2 - 1.00 €' },
    { value: 'M 3021 C3 - 1.00 €', label: 'M 3021 C3 - 1.00 €' },
    { value: 'M 3021 C5 - 1.00 €', label: 'M 3021 C5 - 1.00 €' },
    { value: 'M 3025 C1 - 1.00 €', label: 'M 3025 C1 - 1.00 €' },
    { value: 'M 3025 C2 - 1.00 €', label: 'M 3025 C2 - 1.00 €' },
    { value: 'M 3025 C6 - 1.00 €', label: 'M 3025 C6 - 1.00 €' },
    { value: 'M 3027 C2 - 1.00 €', label: 'M 3027 C2 - 1.00 €' },
    { value: 'M 3027 C3 - 1.00 €', label: 'M 3027 C3 - 1.00 €' },
    { value: 'M 3027 C5 - 1.00 €', label: 'M 3027 C5 - 1.00 €' },
    { value: 'M 3027 C6 - 1.00 €', label: 'M 3027 C6 - 1.00 €' },
    { value: 'M 3037 C1 - 1.00 €', label: 'M 3037 C1 - 1.00 €' },
    { value: 'M 3037 C6 - 1.00 €', label: 'M 3037 C6 - 1.00 €' },
    { value: 'M 3060 C2 - 1.00 €', label: 'M 3060 C2 - 1.00 €' },
    { value: 'M 3060 C3 - 1.00 €', label: 'M 3060 C3 - 1.00 €' },
    { value: 'M 3061 C3 - 1.00 €', label: 'M 3061 C3 - 1.00 €' },
    { value: 'M 3061 C6 - 1.00 €', label: 'M 3061 C6 - 1.00 €' },
    { value: 'OU 4059 C1 - 1.00 €', label: 'OU 4059 C1 - 1.00 €' },
    { value: 'OU 4152 C3 - 1.00 €', label: 'OU 4152 C3 - 1.00 €' },
    { value: '0U 4160 C1 - 1.00 €', label: '0U 4160 C1 - 1.00 €' },
    { value: 'OU 4160 C2 - 1.00 €', label: 'OU 4160 C2 - 1.00 €' },
    { value: 'OU 4160 C3 - 1.00 €', label: 'OU 4160 C3 - 1.00 €' },
    { value: 'OU 4160 C4 - 1.00 €', label: 'OU 4160 C4 - 1.00 €' },
    { value: 'OU 4235 C3 - 1.00 €', label: 'OU 4235 C3 - 1.00 €' },
    { value: 'OU 4235 C4 - 1.00 €', label: 'OU 4235 C4 - 1.00 €' },
    { value: 'OU 4316 C1 - 1.00 €', label: 'OU 4316 C1 - 1.00 €' },
    { value: 'OU 4316 C2 - 1.00 €', label: 'OU 4316 C2 - 1.00 €' },
    { value: 'OU 4316 C3 - 1.00 €', label: 'OU 4316 C3 - 1.00 €' },
    { value: 'OU 4316 C4 - 1.00 €', label: 'OU 4316 C4 - 1.00 €' },
    { value: 'OU 4333 C1 - 1.00 €', label: 'OU 4333 C1 - 1.00 €' },
    { value: 'OU 4333 C2 - 1.00 €', label: 'OU 4333 C2 - 1.00 €' },
    { value: 'OU 4333 C3 - 1.00 €', label: 'OU 4333 C3 - 1.00 €' },
    { value: 'OU 4333 C4 - 1.00 €', label: 'OU 4333 C4 - 1.00 €' },
    { value: 'OU 4339 C1 - 1.00 €', label: 'OU 4339 C1 - 1.00 €' },
    { value: 'OU 4339 C4 - 1.00 €', label: 'OU 4339 C4 - 1.00 €' },
    { value: 'OU 4340 C1 - 1.00 €', label: 'OU 4340 C1 - 1.00 €' },
    { value: 'OU 4340 C2 - 1.00 €', label: 'OU 4340 C2 - 1.00 €' },
    { value: 'OU 4340 C4 - 1.00 €', label: 'OU 4340 C4 - 1.00 €' },
    { value: 'OU 4393 C2 - 1.00 €', label: 'OU 4393 C2 - 1.00 €' },
    { value: 'OU 4393 C4 - 1.00 €', label: 'OU 4393 C4 - 1.00 €' },
    { value: 'OU 4770 C1 - 1.00 €', label: 'OU 4770 C1 - 1.00 €' },
    { value: 'OU 4770 C2 - 1.00 €', label: 'OU 4770 C2 - 1.00 €' },
    { value: 'OU 4770 C3 - 1.00 €', label: 'OU 4770 C3 - 1.00 €' },
    { value: 'OU 4770 C4 - 1.00 €', label: 'OU 4770 C4 - 1.00 €' },
    { value: 'OU 4402 C1 - 1.00 €', label: 'OU 4402 C1 - 1.00 €' },
    { value: 'OU 4402 C3 - 1.00 €', label: 'OU 4402 C3 - 1.00 €' },
    { value: 'OU 4402 C4 - 1.00 €', label: 'OU 4402 C4 - 1.00 €' },
    { value: 'OU 4059 C3 - 1.00 €', label: 'OU 4059 C3 - 1.00 €' },
    { value: 'OU 4152 C1 - 1.00 €', label: 'OU 4152 C1 - 1.00 €' },
    { value: 'OU 4152 C3 - 1.00 €', label: 'OU 4152 C3 - 1.00 €' },
    { value: 'OU 4770 C4 - 1.00 €', label: 'OU 4770 C4 - 1.00 €' },
    { value: 'OU 4402 C1 - 1.00 €', label: 'OU 4402 C1 - 1.00 €' },
    { value: 'OU 4402 C3 - 1.00 €', label: 'OU 4402 C3 - 1.00 €' },
    { value: 'OU 4402 C4 - 1.00 €', label: 'OU 4402 C4 - 1.00 €' },
    { value: 'OU 4412 C1 - 1.00 €', label: 'OU 4412 C1 - 1.00 €' },
    { value: 'OU 4412 C4 - 1.00 €', label: 'OU 4412 C4 - 1.00 €' },
    { value: 'OU 4442 C2 - 1.00 €', label: 'OU 4442 C2 - 1.00 €' },
    { value: 'OU 4442 C4 - 1.00 €', label: 'OU 4442 C4 - 1.00 €' },
    { value: 'OU 4453 C1 - 1.00 €', label: 'OU 4453 C1 - 1.00 €' },
    { value: 'OU 4453 C2 - 1.00 €', label: 'OU 4453 C2 - 1.00 €' },
    { value: 'OU 4453 C3 - 1.00 €', label: 'OU 4453 C3 - 1.00 €' },
    { value: 'OU 4453 C4 - 1.00 €', label: 'OU 4453 C4 - 1.00 €' },
    { value: 'OU 4469 C1 - 1.00 €', label: 'OU 4469 C1 - 1.00 €' },
    { value: 'OU 4469 C2 - 1.00 €', label: 'OU 4469 C2 - 1.00 €' },
    { value: 'OU 4469 C4 - 1.00 €', label: 'OU 4469 C4 - 1.00 €' },
    { value: 'OU 4537 C2 - 1.00 €', label: 'OU 4537 C2 - 1.00 €' },
    { value: 'OU 4537 C3 - 1.00 €', label: 'OU 4537 C3 - 1.00 €' },
    { value: 'OU 4537 C4 - 1.00 €', label: 'OU 4537 C4 - 1.00 €' },
    { value: 'OU 4600 C1 - 1.00 €', label: 'OU 4600 C1 - 1.00 €' },
    { value: 'OU 4600 C2 - 1.00 €', label: 'OU 4600 C2 - 1.00 €' },
    { value: 'OU 4600 C3 - 1.00 €', label: 'OU 4600 C3 - 1.00 €' },
    { value: 'OU 4600 C4 - 1.00 €', label: 'OU 4600 C4 - 1.00 €' },
    { value: 'OU 4667 C2 - 1.00 €', label: 'OU 4667 C2 - 1.00 €' },
    { value: 'OU 4667 C3 - 1.00 €', label: 'OU 4667 C3 - 1.00 €' },
    { value: 'OU 4667 C4 - 1.00 €', label: 'OU 4667 C4 - 1.00 €' },
    { value: 'OU 1102 C1 - 1.00 €', label: 'OU 1102 C1 - 1.00 €' },
    { value: 'OU 1102 C2 - 1.00 €', label: 'OU 1102 C2 - 1.00 €' },
    { value: 'OU 1462 C1 - 1.00 €', label: 'OU 1462 C1 - 1.00 €' },
    { value: 'OU 1462 C3 - 1.00 €', label: 'OU 1462 C3 - 1.00 €' },
    { value: 'OU 1462 C4 - 1.00 €', label: 'OU 1462 C4 - 1.00 €' },
    { value: 'OU A4513 C1 - 1.00 €', label: 'OU A4513 C1 - 1.00 €' },
    { value: 'OU A4513 C2 - 1.00 €', label: 'OU A4513 C2 - 1.00 €' },
    { value: 'OU A4515 C2 - 1.00 €', label: 'OU A4515 C2 - 1.00 €' },
    { value: 'OU A4515 C3 - 1.00 €', label: 'OU A4515 C3 - 1.00 €' },
    { value: 'OU A4514 C2 - 1.00 €', label: 'OU A4514 C2 - 1.00 €' },
    { value: 'OU 4402 C1 - 1.00 €', label: 'OU 4402 C1 - 1.00 €' },
    { value: 'OU 4402 C3 - 1.00 €', label: 'OU 4402 C3 - 1.00 €' },
    { value: 'OU 4402 C4 - 1.00 €', label: 'OU 4402 C4 - 1.00 €' },
    { value: 'OU 4412 C1 - 1.00 €', label: 'OU 4412 C1 - 1.00 €' },
    { value: ' OU 2726 C1 - 1.00 €', label: ' OU 2726 C1 - 1.00 €' },
    { value: ' OU 2726 C2 - 1.00 €', label: ' OU 2726 C2 - 1.00 €' },
    { value: ' OU 2726 C3 - 1.00 €', label: ' OU 2726 C3 - 1.00 €' },
    { value: 'OU 2504 C1 - 1.00 €', label: 'OU 2504 C1 - 1.00 €' },
    { value: 'OU 2504 C2 - 1.00 €', label: 'OU 2504 C2 - 1.00 €' },
    { value: 'OU 2307 C3 - 1.00 €', label: 'OU 2307 C3 - 1.00 €' },
    { value: 'OU 2307 C8 - 1.00 €', label: 'OU 2307 C8 - 1.00 €' },
    { value: 'OU 2307 C5 - 1.00 €', label: 'OU 2307 C5 - 1.00 €' },
    { value: 'OU 2156 C1 - 1.00 €', label: 'OU 2156 C1 - 1.00 €' },
    { value: 'OU 2156 C2 - 1.00 €', label: 'OU 2156 C2 - 1.00 €' },
    { value: 'OU 2156 C3 - 1.00 €', label: 'OU 2156 C3 - 1.00 €' },
    { value: 'OU 2156 C4 - 1.00 €', label: 'OU 2156 C4 - 1.00 €' },
    { value: 'OU 2073 C1 - 1.00 €', label: 'OU 2073 C1 - 1.00 €' },
    { value: 'OU 2073 C2 - 1.00 €', label: 'OU 2073 C2 - 1.00 €' },
    { value: 'OU 2073 C3 - 1.00 €', label: 'OU 2073 C3 - 1.00 €' },
    { value: 'OU 2058 C2 - 1.00 €', label: 'OU 2058 C2 - 1.00 €' },
    { value: 'OU 2058 C3 - 1.00 €', label: 'OU 2058 C3 - 1.00 €' },
    { value: 'OU 2058 C4 - 1.00 €', label: 'OU 2058 C4 - 1.00 €' },
    { value: 'OU 1330 C1 - 1.00 €', label: 'OU 1330 C1 - 1.00 €' },
    { value: 'OU 1330 C2 - 1.00 €', label: 'OU 1330 C2 - 1.00 €' },
    { value: 'OU 1330 C4 - 1.00 €', label: 'OU 1330 C4 - 1.00 €' },
    { value: 'OU 1414 C1 - 1.00 €', label: 'OU 1414 C1 - 1.00 €' },
    { value: 'OU 1414 C2 - 1.00 €', label: 'OU 1414 C2 - 1.00 €' },
    { value: 'OU 1414 C3 - 1.00 €', label: 'OU 1414 C3 - 1.00 €' },
    { value: 'OU 1414 C4 - 1.00 €', label: 'OU 1414 C4 - 1.00 €' },
    { value: 'OU 1714 C4 - 1.00 €', label: 'OU 1714 C4 - 1.00 €' },
    { value: 'OU 1991 C3 - 1.00 €', label: 'OU 1991 C3 - 1.00 €' },
    { value: 'OU 1991 C4 - 1.00 €', label: 'OU 1991 C4 - 1.00 €' },
    { value: 'OU 4247 C1  - 1.00 €', label: 'OU 4247 C1  - 1.00 €' },
    { value: 'OU 4247 C2 - 1.00 €', label: 'OU 4247 C2 - 1.00 €' },
    { value: 'OU 4247 C3 - 1.00 €', label: 'OU 4247 C3 - 1.00 €' },
    { value: 'OU 4308 C1 - 1.00 €', label: 'OU 4308 C1 - 1.00 €' },
    { value: 'OU 4308 C2 - 1.00 €', label: 'OU 4308 C2 - 1.00 €' },
    { value: 'OU 4308 C3 - 1.00 €', label: 'OU 4308 C3 - 1.00 €' },
    { value: 'OU 4457 C2  - 1.00 €', label: 'OU 4457 C2  - 1.00 €' },
    { value: 'OU 4466 C1  - 1.00 €', label: 'OU 4466 C1  - 1.00 €' },
    { value: 'OU 4539 C3  - 1.00 €', label: 'OU 4539 C3  - 1.00 €' },
    { value: 'OU 4539 C4 - 1.00 €', label: 'OU 4539 C4 - 1.00 €' },
    { value: 'OU 4544 C2  - 1.00 €', label: 'OU 4544 C2  - 1.00 €' },
    { value: 'OU 4544 C4 - 1.00 €', label: 'OU 4544 C4 - 1.00 €' },
    { value: 'OU 4550 C1 - 1.00 €', label: 'OU 4550 C1 - 1.00 €' },
    { value: 'OU 4550 C2 - 1.00 €', label: 'OU 4550 C2 - 1.00 €' },
    { value: 'OU 4550 C3 - 1.00 €', label: 'OU 4550 C3 - 1.00 €' },
    { value: 'OU 4550 C4 - 1.00 €', label: 'OU 4550 C4 - 1.00 €' },
    { value: 'OU 4553 C1 - 1.00 €', label: 'OU 4553 C1 - 1.00 €' },
    { value: 'OU 4553 C2 - 1.00 €', label: 'OU 4553 C2 - 1.00 €' },
    { value: 'OU 4553 C3 - 1.00 €', label: 'OU 4553 C3 - 1.00 €' },
    { value: 'OU 4553 C4 - 1.00 €', label: 'OU 4553 C4 - 1.00 €' },
    { value: 'OU 4667 C1  - 1.00 €', label: 'OU 4667 C1  - 1.00 €' },
    { value: 'OU 4667 C4 - 1.00 €', label: 'OU 4667 C4 - 1.00 €' },
    { value: 'OU 4667 C3 - 1.00 €', label: 'OU 4667 C3 - 1.00 €' },
    { value: 'OU 4668 C1  - 1.00 €', label: 'OU 4668 C1  - 1.00 €' },
    { value: 'OU 4668 C2 - 1.00 €', label: 'OU 4668 C2 - 1.00 €' },
    { value: 'OU 4668 C3 - 1.00 €', label: 'OU 4668 C3 - 1.00 €' },
    { value: 'OU 4668 C4 - 1.00 €', label: 'OU 4668 C4 - 1.00 €' },
    { value: 'OU 4662H C1 - 1.00 €', label: 'OU 4662H C1 - 1.00 €' },
    { value: 'OU 4662H C2 - 1.00 €', label: 'OU 4662H C2 - 1.00 €' },
    { value: 'OU 4662H C3 - 1.00 €', label: 'OU 4662H C3 - 1.00 €' },
    { value: 'OU 4662H C4 - 1.00 €', label: 'OU 4662H C4 - 1.00 €' },
    { value: 'OU 4707 C2  - 1.00 €', label: 'OU 4707 C2  - 1.00 €' },
    { value: 'OU 4707 C3 - 1.00 €', label: 'OU 4707 C3 - 1.00 €' },
    { value: 'OU 4059 C1 - 1.00 €', label: 'OU 4059 C1 - 1.00 €' },
    { value: 'OU 4059 C4 - 1.00 €', label: 'OU 4059 C4 - 1.00 €' },
    { value: 'OU 4059 C3 - 1.00 €', label: 'OU 4059 C3 - 1.00 €' },
    { value: 'OU 4060 C1 - 1.00 €', label: 'OU 4060 C1 - 1.00 €' },
    { value: 'OU 4060 C2 - 1.00 €', label: 'OU 4060 C2 - 1.00 €' },
    { value: 'OU 4060 C3 - 1.00 €', label: 'OU 4060 C3 - 1.00 €' },
    { value: 'OU 4060 C4 - 1.00 €', label: 'OU 4060 C4 - 1.00 €' },
    { value: 'OU 4307 C1 - 1.00 €', label: 'OU 4307 C1 - 1.00 €' },
    { value: 'OU 4307 C2 - 1.00 €', label: 'OU 4307 C2 - 1.00 €' },
    { value: 'OU 4307 C3 - 1.00 €', label: 'OU 4307 C3 - 1.00 €' },
    { value: 'OU 4307 C4 - 1.00 €', label: 'OU 4307 C4 - 1.00 €' },
    { value: 'OU 4308 C4  - 1.00 €', label: 'OU 4308 C4  - 1.00 €' },
    { value: 'OU 4561 C1  - 1.00 €', label: 'OU 4561 C1  - 1.00 €' },
    { value: 'OU 4561 C2 - 1.00 €', label: 'OU 4561 C2 - 1.00 €' },
    { value: 'OU 4561 C3 - 1.00 €', label: 'OU 4561 C3 - 1.00 €' },
    { value: 'OU 4619 C1 - 1.00 €', label: 'OU 4619 C1 - 1.00 €' },
    { value: 'OU 4619 C2 - 1.00 €', label: 'OU 4619 C2 - 1.00 €' },
    { value: 'OU 4619 C3 - 1.00 €', label: 'OU 4619 C3 - 1.00 €' },
    { value: 'OU 4619 C4 - 1.00 €', label: 'OU 4619 C4 - 1.00 €' },
    { value: 'OU 2073 C4 - 1.00 €', label: 'OU 2073 C4 - 1.00 €' },
    { value: 'OU 2108 C3 - 1.00 €', label: 'OU 2108 C3 - 1.00 €' },
    { value: 'OU 2108 C4 - 1.00 €', label: 'OU 2108 C4 - 1.00 €' },
    { value: 'OU 2308 C1 - 1.00 €', label: 'OU 2308 C1 - 1.00 €' },
    { value: 'OU 2308 C2 - 1.00 €', label: 'OU 2308 C2 - 1.00 €' },
    { value: 'OU 2308 C3 - 1.00 €', label: 'OU 2308 C3 - 1.00 €' },
    { value: 'OU 2308 C7 - 1.00 €', label: 'OU 2308 C7 - 1.00 €' },
    { value: 'OU 2308 C5 - 1.00 €', label: 'OU 2308 C5 - 1.00 €' },
    { value: 'OU 2385 C1  - 1.00 €', label: 'OU 2385 C1  - 1.00 €' },
    { value: 'OU 2385 C4 - 1.00 €', label: 'OU 2385 C4 - 1.00 €' },
    { value: 'OU 2747 C1  - 1.00 €', label: 'OU 2747 C1  - 1.00 €' },
    { value: 'OU 2747 C2 - 1.00 €', label: 'OU 2747 C2 - 1.00 €' },
    { value: 'OU 2747 C3 - 1.00 €', label: 'OU 2747 C3 - 1.00 €' },
    { value: 'OU 2747 C4 - 1.00 €', label: 'OU 2747 C4 - 1.00 €' },
    // --- Nouvelles montures Sym ajoutées le 2026-09-17 ---
    { value: 'F-3301 - 1.00 €', label: 'F-3301 - 1.00 €' },
    { value: 'F-3306 - 1.00 €', label: 'F-3306 - 1.00 €' },
    { value: 'F-3363 - 1.00 €', label: 'F-3363 - 1.00 €' },
    { value: 'FP-2206 - 1.00 €', label: 'FP-2206 - 1.00 €' },
    { value: 'M-3001 - 1.00 €', label: 'M-3001 - 1.00 €' },
    { value: 'M-3003 - 1.00 €', label: 'M-3003 - 1.00 €' },
    { value: 'M-3005 - 1.00 €', label: 'M-3005 - 1.00 €' },
    { value: 'M-3018 - 1.00 €', label: 'M-3018 - 1.00 €' },
    { value: 'M-3020 - 1.00 €', label: 'M-3020 - 1.00 €' },
    { value: 'M-3021 - 1.00 €', label: 'M-3021 - 1.00 €' },
    { value: 'M-3022 - 1.00 €', label: 'M-3022 - 1.00 €' },
    { value: 'M-3061 - 1.00 €', label: 'M-3061 - 1.00 €' },
    { value: 'OU-1801 - 1.00 €', label: 'OU-1801 - 1.00 €' },
    { value: 'OU-25040 - 1.00 €', label: 'OU-25040 - 1.00 €' },
    { value: 'OU-4060 - 1.00 €', label: 'OU-4060 - 1.00 €' },
    { value: 'OU-4410 - 1.00 €', label: 'OU-4410 - 1.00 €' },
    { value: 'OU-4451 - 1.00 €', label: 'OU-4451 - 1.00 €' },
    { value: 'OU-4454 - 1.00 €', label: 'OU-4454 - 1.00 €' },
    { value: 'OU-4455 - 1.00 €', label: 'OU-4455 - 1.00 €' },
    { value: 'OU-4542 - 1.00 €', label: 'OU-4542 - 1.00 €' },
    { value: 'OU-4543 - 1.00 €', label: 'OU-4543 - 1.00 €' },
    { value: 'OU-4550 - 1.00 €', label: 'OU-4550 - 1.00 €' },
    { value: 'OU-4565 - 1.00 €', label: 'OU-4565 - 1.00 €' },
    { value: 'OU-4666H - 1.00 €', label: 'OU-4666H - 1.00 €' },
    { value: 'OU-4668 - 1.00 €', label: 'OU-4668 - 1.00 €' },
    { value: 'OU-4696 - 1.00 €', label: 'OU-4696 - 1.00 €' },
    { value: 'OU-4708 - 1.00 €', label: 'OU-4708 - 1.00 €' },
    { value: 'OU-4725 - 1.00 €', label: 'OU-4725 - 1.00 €' },
    { value: 'OU-4759 - 1.00 €', label: 'OU-4759 - 1.00 €' },
    { value: 'OU-4764H - 1.00 €', label: 'OU-4764H - 1.00 €' },
    { value: 'OU-7680 - 1.00 €', label: 'OU-7680 - 1.00 €' },
    { value: 'OU-S0003 - 1.00 €', label: 'OU-S0003 - 1.00 €' },
    { value: 'TR-99012 - 1.00 €', label: 'TR-99012 - 1.00 €' },
    { value: 'TR-99066 - 1.00 €', label: 'TR-99066 - 1.00 €' },
    { value: 'XB-2163 - 1.00 €', label: 'XB-2163 - 1.00 €' },
    { value: 'XB-2171 - 1.00 €', label: 'XB-2171 - 1.00 €' },
    { value: 'XB-2174 - 1.00 €', label: 'XB-2174 - 1.00 €' },
    { value: 'XB-2181 - 1.00 €', label: 'XB-2181 - 1.00 €' },
    { value: 'XB-2185 - 1.00 €', label: 'XB-2185 - 1.00 €' },
];
export const Monture34 = [
    { value: '', label: '' },
    { value: 'Autre - 15.50 €', label: 'Autre - 15.50 €' },
    { value: 'SYM 0U 4308 C2 - 15.50 €', label: 'SYM 0U 4308 C2 - 15.50 €' },
    { value: 'SYM 12038 C3 - 15.50 €', label: 'SYM 12038 C3 - 15.50 €' },
    { value: 'SYM 12048 C4 - 15.50 €', label: 'SYM 12048 C4 - 15.50 €' },
    { value: 'SYM 15091 C2 - 15.50 €', label: 'SYM 15091 C2 - 15.50 €' },
    { value: 'SYM 23005 C2 - 15.50 €', label: 'SYM 23005 C2 - 15.50 €' },
    { value: 'SYM 26012 C3 - 15.50 €', label: 'SYM 26012 C3 - 15.50 €' },
    { value: 'SYM 62725 C3 - 15.50 €', label: 'SYM 62725 C3 - 15.50 €' },
    { value: 'SYM B 6109 C2 - 15.50 €', label: 'SYM B 6109 C2 - 15.50 €' },
    { value: 'BT 0012 C2 - 15.50 €', label: 'BT 0012 C2 - 15.50 €' },
    { value: 'BT 0014 C2 - 15.50 €', label: 'BT 0014 C2 - 15.50 €' },
    { value: 'BT 0014 C6 - 15.50 €', label: 'BT 0014 C6 - 15.50 €' },
    { value: 'IN-2216 N01 - 15.50 €', label: 'IN-2216 N01 - 15.50 €' },
    { value: 'SYM OU 1131 C1 - 15.50 €', label: 'SYM OU 1131 C1 - 15.50 €' },
    { value: 'SYM OU 1295 C2 - 15.50 €', label: 'SYM OU 1295 C2 - 15.50 €' },
    { value: 'SYM OU 1295 C4 - 15.50 €', label: 'SYM OU 1295 C4 - 15.50 €' },
    { value: 'SYM OU 1489 C1 - 15.50 €', label: 'SYM OU 1489 C1 - 15.50 €' },
    { value: 'SYM OU 1750 C3 - 15.50 €', label: 'SYM OU 1750 C3 - 15.50 €' },
    { value: 'SYM OU 4228 C4 - 15.50 €', label: 'SYM OU 4228 C4 - 15.50 €' },
    { value: 'SYM OU 4236 C4 - 15.50 €', label: 'SYM OU 4236 C4 - 15.50 €' },
    { value: 'SYM OU 4238 C1 - 15.50 €', label: 'SYM OU 4238 C1 - 15.50 €' },
    { value: 'SYM OU 4238 C2 - 15.50 €', label: 'SYM OU 4238 C2 - 15.50 €' },
    { value: 'SYM OU 4308 C3 - 15.50 €', label: 'SYM OU 4308 C3 - 15.50 €' },
    { value: 'SYM OU 4311 C2 - 15.50 €', label: 'SYM OU 4311 C2 - 15.50 €' },
    { value: 'SYM OU 4311 C4 - 15.50 €', label: 'SYM OU 4311 C4 - 15.50 €' },
    { value: 'SYM OU 4353 C3 - 15.50 €', label: 'SYM OU 4353 C3 - 15.50 €' },
    { value: 'SYM OU 4353 C4 - 15.50 €', label: 'SYM OU 4353 C4 - 15.50 €' },
    { value: 'SYM OU 4432 C2 - 15.50 €', label: 'SYM OU 4432 C2 - 15.50 €' },
    { value: 'SYM OU 4432 C3 - 15.50 €', label: 'SYM OU 4432 C3 - 15.50 €' },
    { value: 'SYM OU 4435 C3 - 15.50 €', label: 'SYM OU 4435 C3 - 15.50 €' },
    { value: 'SYM OU 4451 C1 - 15.50 €', label: 'SYM OU 4451 C1 - 15.50 €' },
    { value: 'SYM A 01 006 - 15.50 €', label: 'SYM A 01 006 - 15.50 €' },
    { value: 'SYM A 01 009 - 15.50 €', label: 'SYM A 01 009 - 15.50 €' },
    { value: 'SYM A 01 011 - 15.50 €', label: 'SYM A 01 011 - 15.50 €' },
    { value: 'SYM A 02 001 - 15.50 €', label: 'SYM A 02 001 - 15.50 €' },
    { value: 'SYM A 02 002 - 15.50 €', label: 'SYM A 02 002 - 15.50 €' },
    { value: 'SYM A 02 013 - 15.50 €', label: 'SYM A 02 013 - 15.50 €' },
    { value: 'SYM A 03 003 - 15.50 €', label: 'SYM A 03 003 - 15.50 €' },
    { value: 'SYM A 03 008 - 15.50 €', label: 'SYM A 03 008 - 15.50 €' },
    { value: 'SYM A 03 011 - 15.50 €', label: 'SYM A 03 011 - 15.50 €' },
    { value: 'SYM A 04 004 - 15.50 €', label: 'SYM A 04 004 - 15.50 €' },
    { value: 'SYM A 04 005 - 15.50 €', label: 'SYM A 04 005 - 15.50 €' },
    { value: 'SYM A 04 014 - 15.50 €', label: 'SYM A 04 014 - 15.50 €' },
    { value: 'SYM A 05 001 - 15.50 €', label: 'SYM A 05 001 - 15.50 €' },
    { value: 'SYM A 05 010 - 15.50 €', label: 'SYM A 05 010 - 15.50 €' },
    { value: 'SYM A 05 013 - 15.50 €', label: 'SYM A 05 013 - 15.50 €' },
    { value: 'SYM A 06 008 - 15.50 €', label: 'SYM A 06 008 - 15.50 €' },
    { value: 'SYM A 06 012 - 15.50 €', label: 'SYM A 06 012 - 15.50 €' },
    { value: 'SYM A 06 014 - 15.50 €', label: 'SYM A 06 014 - 15.50 €' },
    { value: 'SYM A 06 015 - 15.50 €', label: 'SYM A 06 015 - 15.50 €' },
    { value: 'SYM A 07 219 - 15.50 €', label: 'SYM A 07 219 - 15.50 €' },
    { value: 'SYM A 07 220 - 15.50 €', label: 'SYM A 07 220 - 15.50 €' },
    { value: 'SYM A 07 245 - 15.50 €', label: 'SYM A 07 245 - 15.50 €' },
    { value: 'SYM A 08 245 - 15.50 €', label: 'SYM A 08 245 - 15.50 €' },
    { value: 'SYM B 01 225 - 15.50 €', label: 'SYM B 01 225 - 15.50 €' },
    { value: 'SYM B 01 245 - 15.50 €', label: 'SYM B 01 245 - 15.50 €' },
    { value: 'SYM B 02 001 - 15.50 €', label: 'SYM B 02 001 - 15.50 €' },
    { value: 'SYM B 02 013 - 15.50 €', label: 'SYM B 02 013 - 15.50 €' },
    { value: 'SYM B 02 226 - 15.50 €', label: 'SYM B 02 226 - 15.50 €' },
    { value: 'SYM B 03 014 - 15.50 €', label: 'SYM B 03 014 - 15.50 €' },
    { value: 'SYM B 03 227 - 15.50 €', label: 'SYM B 03 227 - 15.50 €' },
    { value: 'SYM B 03 228 - 15.50 €', label: 'SYM B 03 228 - 15.50 €' },
    { value: 'SYM B 04 230 - 15.50 €', label: 'SYM B 04 230 - 15.50 €' },
    { value: 'SYM B 04 257 - 15.50 €', label: 'SYM B 04 257 - 15.50 €' },
    { value: 'SYM B 05 232 - 15.50 €', label: 'SYM B 05 232 - 15.50 €' },
    { value: 'SYM B 05 233 - 15.50 €', label: 'SYM B 05 233 - 15.50 €' },
    { value: 'SYM B 05 234 - 15.50 €', label: 'SYM B 05 234 - 15.50 €' },
    { value: 'SYM B 06 004 - 15.50 €', label: 'SYM B 06 004 - 15.50 €' },
    { value: 'SYM B 06 015 - 15.50 €', label: 'SYM B 06 015 - 15.50 €' },
    { value: 'SYM B 06 235 - 15.50 €', label: 'SYM B 06 235 - 15.50 €' },
    { value: 'SYM C 01 238 - 15.50 €', label: 'SYM C 01 238 - 15.50 €' },
    { value: 'SYM C 02 233 - 15.50 €', label: 'SYM C 02 233 - 15.50 €' },
    { value: 'SYM C 02 246 - 15.50 €', label: 'SYM C 02 246 - 15.50 €' },
    { value: 'SYM C 02 247 - 15.50 €', label: 'SYM C 02 247 - 15.50 €' },
    { value: 'SYM C 03 016 - 15.50 €', label: 'SYM C 03 016 - 15.50 €' },
    { value: 'SYM C 03 240 - 15.50 €', label: 'SYM C 03 240 - 15.50 €' },
    { value: 'SYM C 03 248 - 15.50 €', label: 'SYM C 03 248 - 15.50 €' },
    { value: 'SYM C 04 224 - 15.50 €', label: 'SYM C 04 224 - 15.50 €' },
    { value: 'SYM C 04 228 - 15.50 €', label: 'SYM C 04 228 - 15.50 €' },
    { value: 'SYM C 04 241 - 15.50 €', label: 'SYM C 04 241 - 15.50 €' },
    { value: 'SYM C 05 242 - 15.50 €', label: 'SYM C 05 242 - 15.50 €' },
    { value: 'SYM C 05 243 - 15.50 €', label: 'SYM C 05 243 - 15.50 €' },
    { value: 'SYM C 05 244 - 15.50 €', label: 'SYM C 05 244 - 15.50 €' },
    { value: 'SYM K 01 251 - 15.50 €', label: 'SYM K 01 251 - 15.50 €' },
    { value: 'SYM K 01 252 - 15.50 €', label: 'SYM K 01 252 - 15.50 €' },
    { value: 'SYM K 01 253 - 15.50 €', label: 'SYM K 01 253 - 15.50 €' },
    { value: 'SYM K 01 254 - 15.50 €', label: 'SYM K 01 254 - 15.50 €' },
    { value: 'SYM K 01 255 - 15.50 €', label: 'SYM K 01 255 - 15.50 €' },
    { value: 'SYM K 02 251 - 15.50 €', label: 'SYM K 02 251 - 15.50 €' },
    { value: 'SYM K 02 252 - 15.50 €', label: 'SYM K 02 252 - 15.50 €' },
    { value: 'SYM K 02 253 - 15.50 €', label: 'SYM K 02 253 - 15.50 €' },
    { value: 'SYM K 02 254 - 15.50 €', label: 'SYM K 02 254 - 15.50 €' },
    { value: 'SYM K 02 255 - 15.50 €', label: 'SYM K 02 255 - 15.50 €' },
    { value: 'SYM K 03 251 - 15.50 €', label: 'SYM K 03 251 - 15.50 €' },
    { value: 'SYM K 03 252 - 15.50 €', label: 'SYM K 03 252 - 15.50 €' },
    { value: 'SYM K 03 253 - 15.50 €', label: 'SYM K 03 253 - 15.50 €' },
    { value: 'SYM K 03 254 - 15.50 €', label: 'SYM K 03 254 - 15.50 €' },
    { value: 'SYM K 03 255 - 15.50 €', label: 'SYM K 03 255 - 15.50 €' },
    { value: 'SYM K 04 251 - 15.50 €', label: 'SYM K 04 251 - 15.50 €' },
    { value: 'SYM K 04 252 - 15.50 €', label: 'SYM K 04 252 - 15.50 €' },
    { value: 'SYM K 04 253 - 15.50 €', label: 'SYM K 04 253 - 15.50 €' },
    { value: 'SYM K 04 254 - 15.50 €', label: 'SYM K 04 254 - 15.50 €' },
    { value: 'SYM K 04 255 - 15.50 €', label: 'SYM K 04 255 - 15.50 €' },
    { value: 'YC 1091 C1 - 15.50 €', label: 'YC 1091 C1 - 15.50 €' },
    { value: 'YC 11069 C4 - 15.50 €', label: 'YC 11069 C4 - 15.50 €' },
    { value: 'YC 12003 C3 - 15.50 €', label: 'YC 12003 C3 - 15.50 €' },
    { value: 'YC 13001 C2 - 15.50 €', label: 'YC 13001 C2 - 15.50 €' },
    { value: 'YC 14042 C4 - 15.50 €', label: 'YC 14042 C4 - 15.50 €' },
    { value: 'YC 14044 C3 - 15.50 €', label: 'YC 14044 C3 - 15.50 €' },
    { value: 'YC 14045 C2 - 15.50 €', label: 'YC 14045 C2 - 15.50 €' },
    { value: 'YC 14047 C4 - 15.50 €', label: 'YC 14047 C4 - 15.50 €' },
    { value: 'YC 14048 C1 - 15.50 €', label: 'YC 14048 C1 - 15.50 €' },
    { value: 'YC 14048 C2 - 15.50 €', label: 'YC 14048 C2 - 15.50 €' },
    { value: 'YC 15035 C2 - 15.50 €', label: 'YC 15035 C2 - 15.50 €' },
    { value: 'YC 15085 C2 - 15.50 €', label: 'YC 15085 C2 - 15.50 €' },
    { value: 'YC 15086 C4 - 15.50 €', label: 'YC 15086 C4 - 15.50 €' },
    { value: 'YC 21002 C3 - 15.50 €', label: 'YC 21002 C3 - 15.50 €' },
    { value: 'YC 21007 C4 - 15.50 €', label: 'YC 21007 C4 - 15.50 €' },
    { value: 'YC 21009 C1 - 15.50 €', label: 'YC 21009 C1 - 15.50 €' },
    { value: 'YC 21012 C1 - 15.50 €', label: 'YC 21012 C1 - 15.50 €' },
    { value: 'YC 21012 C3 - 15.50 €', label: 'YC 21012 C3 - 15.50 €' },
    { value: 'YC 21012 C4 - 15.50 €', label: 'YC 21012 C4 - 15.50 €' },
    { value: 'YC 21013 C1 - 15.50 €', label: 'YC 21013 C1 - 15.50 €' },
    { value: 'YC 21013 C2 - 15.50 €', label: 'YC 21013 C2 - 15.50 €' },
    { value: 'YC 21013 C3 - 15.50 €', label: 'YC 21013 C3 - 15.50 €' },
    { value: 'YC 21013 C4 - 15.50 €', label: 'YC 21013 C4 - 15.50 €' },
    { value: 'YC 21031 C1 - 15.50 €', label: 'YC 21031 C1 - 15.50 €' },
    { value: 'YC 21031 C4 - 15.50 €', label: 'YC 21031 C4 - 15.50 €' },
    { value: 'YC 21034 C1 - 15.50 €', label: 'YC 21034 C1 - 15.50 €' },
    { value: 'YC 21034 C3 - 15.50 €', label: 'YC 21034 C3 - 15.50 €' },
    { value: 'YC 21036 C1 - 15.50 €', label: 'YC 21036 C1 - 15.50 €' },
    { value: 'YC 21038 C2 - 15.50 €', label: 'YC 21038 C2 - 15.50 €' },
    { value: 'YC 21039 C4 - 15.50 €', label: 'YC 21039 C4 - 15.50 €' },
    { value: 'YC 21105 C2 - 15.50 €', label: 'YC 21105 C2 - 15.50 €' },
    { value: 'YC 21105 C3 - 15.50 €', label: 'YC 21105 C3 - 15.50 €' },
    { value: 'YC 21122 C4 - 15.50 €', label: 'YC 21122 C4 - 15.50 €' },
    { value: 'YC 21131 C3 - 15.50 €', label: 'YC 21131 C3 - 15.50 €' },
    { value: 'YC 21144 C3 - 15.50 €', label: 'YC 21144 C3 - 15.50 €' },
    { value: 'YC 21144 C4 - 15.50 €', label: 'YC 21144 C4 - 15.50 €' },
    { value: 'YC 21145 C3 - 15.50 €', label: 'YC 21145 C3 - 15.50 €' },
    { value: 'YC 21145 C4 - 15.50 €', label: 'YC 21145 C4 - 15.50 €' },
    { value: 'YC 21146 C1 - 15.50 €', label: 'YC 21146 C1 - 15.50 €' },
    { value: 'YC 21147 C1 - 15.50 €', label: 'YC 21147 C1 - 15.50 €' },
    { value: 'YC 21148 C3 - 15.50 €', label: 'YC 21148 C3 - 15.50 €' },
    { value: 'YC 21148 C4 - 15.50 €', label: 'YC 21148 C4 - 15.50 €' },
    { value: 'YC 21149 C1 - 15.50 €', label: 'YC 21149 C1 - 15.50 €' },
    { value: 'YC 21151 C4 - 15.50 €', label: 'YC 21151 C4 - 15.50 €' },
    { value: 'YC 21155 C3 - 15.50 €', label: 'YC 21155 C3 - 15.50 €' },
    { value: 'YC 21156 C2 - 15.50 €', label: 'YC 21156 C2 - 15.50 €' },
    { value: 'YC 21158 C1 - 15.50 €', label: 'YC 21158 C1 - 15.50 €' },
    { value: 'YC 21158 C4 - 15.50 €', label: 'YC 21158 C4 - 15.50 €' },
    { value: 'YC 21159 C4 - 15.50 €', label: 'YC 21159 C4 - 15.50 €' },
    { value: 'YC 21163 C2 - 15.50 €', label: 'YC 21163 C2 - 15.50 €' },
    { value: 'YC 21163 C3 - 15.50 €', label: 'YC 21163 C3 - 15.50 €' },
    { value: 'YC 21166 C2 - 15.50 €', label: 'YC 21166 C2 - 15.50 €' },
    { value: 'YC 21184 C4 - 15.50 €', label: 'YC 21184 C4 - 15.50 €' },
    { value: 'YC 2171 C1 - 15.50 €', label: 'YC 2171 C1 - 15.50 €' },
    { value: 'YC 2171 C4 - 15.50 €', label: 'YC 2171 C4 - 15.50 €' },
    { value: 'YC 22034 C3 - 15.50 €', label: 'YC 22034 C3 - 15.50 €' },
    { value: 'YC 22036 C4 - 15.50 €', label: 'YC 22036 C4 - 15.50 €' },
    { value: 'YC 22043 C3 - 15.50 €', label: 'YC 22043 C3 - 15.50 €' },
    { value: 'YC 22050 C4 - 15.50 €', label: 'YC 22050 C4 - 15.50 €' },
    { value: 'YC 22057 C1 - 15.50 €', label: 'YC 22057 C1 - 15.50 €' },
    { value: 'YC 22057 C4 - 15.50 €', label: 'YC 22057 C4 - 15.50 €' },
    { value: 'YC 22082 C3 - 15.50 €', label: 'YC 22082 C3 - 15.50 €' },
    { value: 'YC 22095 C2 - 15.50 €', label: 'YC 22095 C2 - 15.50 €' },
    { value: 'YC 22101 C1 - 15.50 €', label: 'YC 22101 C1 - 15.50 €' },
    { value: 'YC 23043 C2 - 15.50 €', label: 'YC 23043 C2 - 15.50 €' },
    { value: 'YC 23055 C2 - 15.50 €', label: 'YC 23055 C2 - 15.50 €' },
    { value: 'YC 23076 C3 - 15.50 €', label: 'YC 23076 C3 - 15.50 €' },
    { value: 'YC 23139 C4 - 15.50 €', label: 'YC 23139 C4 - 15.50 €' },
    { value: 'YC 23153 C3 - 15.50 €', label: 'YC 23153 C3 - 15.50 €' },
    { value: 'YC 23168 C1 - 15.50 €', label: 'YC 23168 C1 - 15.50 €' },
    { value: 'YC 23168 C2 - 15.50 €', label: 'YC 23168 C2 - 15.50 €' },
    { value: 'YC 23168 C3 - 15.50 €', label: 'YC 23168 C3 - 15.50 €' },
    { value: 'YC 25025 C2 - 15.50 €', label: 'YC 25025 C2 - 15.50 €' },
    { value: 'YC 26008 C2 - 15.50 €', label: 'YC 26008 C2 - 15.50 €' },
    { value: 'YC 26032 C1 - 15.50 €', label: 'YC 26032 C1 - 15.50 €' },
    { value: 'YC 26049 C4 - 15.50 €', label: 'YC 26049 C4 - 15.50 €' },
    { value: 'YC 28004 C1 - 15.50 €', label: 'YC 28004 C1 - 15.50 €' },
    { value: 'YC 28027 C2 - 15.50 €', label: 'YC 28027 C2 - 15.50 €' },
    { value: 'YC 28032 C3 - 15.50 €', label: 'YC 28032 C3 - 15.50 €' },
    { value: 'YC 28052 C2 - 15.50 €', label: 'YC 28052 C2 - 15.50 €' },
    { value: 'YC 28055 C3 - 15.50 €', label: 'YC 28055 C3 - 15.50 €' },
    { value: 'YC 30057 C2 - 15.50 €', label: 'YC 30057 C2 - 15.50 €' },
    { value: 'YC 313 C4 - 15.50 €', label: 'YC 313 C4 - 15.50 €' },
    { value: 'YC 34009 C3 - 15.50 €', label: 'YC 34009 C3 - 15.50 €' },
    { value: 'YC 60019 C4 - 15.50 €', label: 'YC 60019 C4 - 15.50 €' },
    { value: 'YC 60023 C8 - 15.50 €', label: 'YC 60023 C8 - 15.50 €' },
    { value: 'YC 60026 C4 - 15.50 €', label: 'YC 60026 C4 - 15.50 €' },
    { value: 'YC 60037 C4 - 15.50 €', label: 'YC 60037 C4 - 15.50 €' },
    { value: 'YC 63006 C5 - 15.50 €', label: 'YC 63006 C5 - 15.50 €' },
    { value: 'YC 63006 C6 - 15.50 €', label: 'YC 63006 C6 - 15.50 €' },
    { value: 'YC 8087 C1 - 15.50 €', label: 'YC 8087 C1 - 15.50 €' },
    { value: 'YC 9609 C1 - 15.50 €', label: 'YC 9609 C1 - 15.50 €' },
    { value: 'GC 001 C2 - 15.50 €', label: 'GC 001 C2 - 15.50 €' },
    { value: 'GC 001 C3 - 15.50 €', label: 'GC 001 C3 - 15.50 €' },
    { value: 'GC 002 C2 - 15.50 €', label: 'GC 002 C2 - 15.50 €' },
    { value: 'GC 002 C3 - 15.50 €', label: 'GC 002 C3 - 15.50 €' },
    { value: 'GC 003 C2 - 15.50 €', label: 'GC 003 C2 - 15.50 €' },
    { value: 'GC 003 C3 - 15.50 €', label: 'GC 003 C3 - 15.50 €' },
    { value: 'GC 004 C1 - 15.50 €', label: 'GC 004 C1 - 15.50 €' },
    { value: 'GC 004 C2 - 15.50 €', label: 'GC 004 C2 - 15.50 €' },
    { value: 'GC 004 C3 - 15.50 €', label: 'GC 004 C3 - 15.50 €' },
    { value: 'GC 005 C3 - 15.50 €', label: 'GC 005 C3 - 15.50 €' },
    { value: 'GC 006 C1 - 15.50 €', label: 'GC 006 C1 - 15.50 €' },
    { value: 'GC 006 C3 - 15.50 €', label: 'GC 006 C3 - 15.50 €' },
    { value: 'GC 007 C3 - 15.50 €', label: 'GC 007 C3 - 15.50 €' },
    { value: 'SYM OU 1166 C4 - 15.50 €', label: 'SYM OU 1166 C4 - 15.50 €' },
    { value: 'YC 29005 C2 - 15.50 €', label: 'YC 29005 C2 - 15.50 €' },
    { value: 'YC 29006 C2 - 15.50 €', label: 'YC 29006 C2 - 15.50 €' },
    { value: 'YC 29009 C4 - 15.50 €', label: 'YC 29009 C4 - 15.50 €' },
    { value: 'YC 29011 C1 - 15.50 €', label: 'YC 29011 C1 - 15.50 €' },
    { value: 'YC 29011 C4 - 15.50 €', label: 'YC 29011 C4 - 15.50 €' },
    { value: 'YC 29047 C3 - 15.50 €', label: 'YC 29047 C3 - 15.50 €' },
    { value: 'YC 29048 C1 - 15.50 €', label: 'YC 29048 C1 - 15.50 €' },
    { value: 'YC 29065 C1 - 15.50 €', label: 'YC 29065 C1 - 15.50 €' },
    { value: 'YC 29065 C2 - 15.50 €', label: 'YC 29065 C2 - 15.50 €' },
    { value: 'YC 30017 C1 - 15.50 €', label: 'YC 30017 C1 - 15.50 €' },
    { value: 'YC 30017 C2 - 15.50 €', label: 'YC 30017 C2 - 15.50 €' },
    { value: 'YC 31078 C1 - 15.50 €', label: 'YC 31078 C1 - 15.50 €' },
    { value: 'YC 39027 C1 - 15.50 €', label: 'YC 39027 C1 - 15.50 €' },
    { value: 'YC 39028 C2 - 15.50 €', label: 'YC 39028 C2 - 15.50 €' },
    { value: 'M 3003 C1 - 15.50 €', label: 'M 3003 C1 - 15.50 €' },
    { value: 'M 3003 C2 - 15.50 €', label: 'M 3003 C2 - 15.50 €' },
    { value: 'M 3003 C3 - 15.50 €', label: 'M 3003 C3 - 15.50 €' },
    { value: 'M 3003 C5 - 15.50 €', label: 'M 3003 C5 - 15.50 €' },
    { value: 'M 3007 C1 - 15.50 €', label: 'M 3007 C1 - 15.50 €' },
    { value: 'M 3007 C2 - 15.50 €', label: 'M 3007 C2 - 15.50 €' },
    { value: 'M 3009 C2 - 15.50 €', label: 'M 3009 C2 - 15.50 €' },
    { value: 'M 3009 C3 - 15.50 €', label: 'M 3009 C3 - 15.50 €' },
    { value: 'M 3009 C5 - 15.50 €', label: 'M 3009 C5 - 15.50 €' },
    { value: 'M 3009 C6 - 15.50 €', label: 'M 3009 C6 - 15.50 €' },
    { value: 'OU 4020 C1 - 15.50 €', label: 'OU 4020 C1 - 15.50 €' },
    { value: 'OU 4020 C3 - 15.50 €', label: 'OU 4020 C3 - 15.50 €' },
    { value: 'OU 4051 C1 - 15.50 €', label: 'OU 4051 C1 - 15.50 €' },
    { value: 'OU 4051 C3 - 15.50 €', label: 'OU 4051 C3 - 15.50 €' },
    { value: 'OU 4051 C4 - 15.50 €', label: 'OU 4051 C4 - 15.50 €' },
    { value: 'OU 4090 C1 - 15.50 €', label: 'OU 4090 C1 - 15.50 €' },
    { value: 'OU 4090 C2 - 15.50 €', label: 'OU 4090 C2 - 15.50 €' },
    { value: 'OU 4090 C3 - 15.50 €', label: 'OU 4090 C3 - 15.50 €' },
    { value: 'OU 4090 C4 - 15.50 €', label: 'OU 4090 C4 - 15.50 €' },
    { value: 'OU 4401 C1 - 15.50 €', label: 'OU 4401 C1 - 15.50 €' },
    { value: 'OU 4401 C2 - 15.50 €', label: 'OU 4401 C2 - 15.50 €' },
    { value: 'OU 4401 C3 - 15.50 €', label: 'OU 4401 C3 - 15.50 €' },
    { value: 'OU 4401 C4 - 15.50 €', label: 'OU 4401 C4 - 15.50 €' },
    { value: 'OU 4152 C1 - 15.50 €', label: 'OU 4152 C1 - 15.50 €' },
    { value: 'OU 4152 C2 - 15.50 €', label: 'OU 4152 C2 - 15.50 €' },
    { value: 'OU 4235 C1 - 15.50 €', label: 'OU 4235 C1 - 15.50 €' },
    { value: 'OU 4235 C2 - 15.50 €', label: 'OU 4235 C2 - 15.50 €' },
    { value: 'OU 4244 C4 - 15.50 €', label: 'OU 4244 C4 - 15.50 €' },
    { value: 'OU 4247 C2 - 15.50 €', label: 'OU 4247 C2 - 15.50 €' },
    { value: 'OU 4247 C3 - 15.50 €', label: 'OU 4247 C3 - 15.50 €' },
    { value: 'OU 4247 C4 - 15.50 €', label: 'OU 4247 C4 - 15.50 €' },
    { value: 'OU 4357 C1 - 15.50 €', label: 'OU 4357 C1 - 15.50 €' },
    { value: 'OU 4393 C1 - 15.50 €', label: 'OU 4393 C1 - 15.50 €' },
    { value: 'OU 4393 C3 - 15.50 €', label: 'OU 4393 C3 - 15.50 €' },
    { value: 'OU 4368 C1 - 15.50 €', label: 'OU 4368 C1 - 15.50 €' },
    { value: 'OU 4368 C2 - 15.50 €', label: 'OU 4368 C2 - 15.50 €' },
    { value: 'OU 4368 C3 - 15.50 €', label: 'OU 4368 C3 - 15.50 €' },
    { value: 'OU 4368 C4 - 15.50 €', label: 'OU 4368 C4 - 15.50 €' },
    { value: 'A 4515 C1 - 15.50 €', label: 'A 4515 C1 - 15.50 €' },
    { value: 'A 4515 C3 - 15.50 €', label: 'A 4515 C3 - 15.50 €' },
    { value: 'A 4515 C4 - 15.50 €', label: 'A 4515 C4 - 15.50 €' },
    { value: 'OU 4600 C1 - 15.50 €', label: 'OU 4600 C1 - 15.50 €' },
    { value: 'OU 4600 C4 - 15.50 €', label: 'OU 4600 C4 - 15.50 €' },
    { value: 'OU 4668 C2 - 15.50 €', label: 'OU 4668 C2 - 15.50 €' },
    { value: 'OU 4668 C3 - 15.50 €', label: 'OU 4668 C3 - 15.50 €' },
    { value: 'OU 4668 C4 - 15.50 €', label: 'OU 4668 C4 - 15.50 €' },
    { value: 'TL 2001 C4 - 15.50 €', label: 'TL 2001 C4 - 15.50 €' },
    { value: 'TL 2011 C3 - 15.50 €', label: 'TL 2011 C3 - 15.50 €' },
    { value: 'M 3010 C2 - 15.50 €', label: 'M 3010 C2 - 15.50 €' },
    { value: 'M 3010 C3 - 15.50 €', label: 'M 3010 C3 - 15.50 €' },
    { value: 'M 3010 C5 - 15.50 €', label: 'M 3010 C5 - 15.50 €' },
    { value: 'M 3010 C6 - 15.50 €', label: 'M 3010 C6 - 15.50 €' },
    { value: 'M 3012 C2 - 15.50 €', label: 'M 3012 C2 - 15.50 €' },
    { value: 'M 3012 C3 - 15.50 €', label: 'M 3012 C3 - 15.50 €' },
    { value: 'M 3012 C6 - 15.50 €', label: 'M 3012 C6 - 15.50 €' },
    { value: 'M 3013 C1 - 15.50 €', label: 'M 3013 C1 - 15.50 €' },
    { value: 'M 3013 C6 - 15.50 €', label: 'M 3013 C6 - 15.50 €' },
    { value: 'M 3018 C1 - 15.50 €', label: 'M 3018 C1 - 15.50 €' },
    { value: 'M 3018 C2 - 15.50 €', label: 'M 3018 C2 - 15.50 €' },
    { value: 'M 3018 C3 - 15.50 €', label: 'M 3018 C3 - 15.50 €' },
    { value: 'M 3020 C1 - 15.50 €', label: 'M 3020 C1 - 15.50 €' },
    { value: 'M 3020 C3 - 15.50 €', label: 'M 3020 C3 - 15.50 €' },
    { value: 'M 3020 C5 - 15.50 €', label: 'M 3020 C5 - 15.50 €' },
    { value: 'M 3021 C1 - 15.50 €', label: 'M 3021 C1 - 15.50 €' },
    { value: 'M 3021 C2 - 15.50 €', label: 'M 3021 C2 - 15.50 €' },
    { value: 'M 3021 C3 - 15.50 €', label: 'M 3021 C3 - 15.50 €' },
    { value: 'M 3021 C5 - 15.50 €', label: 'M 3021 C5 - 15.50 €' },
    { value: 'M 3025 C1 - 15.50 €', label: 'M 3025 C1 - 15.50 €' },
    { value: 'M 3025 C2 - 15.50 €', label: 'M 3025 C2 - 15.50 €' },
    { value: 'M 3025 C6 - 15.50 €', label: 'M 3025 C6 - 15.50 €' },
    { value: 'M 3027 C2 - 15.50 €', label: 'M 3027 C2 - 15.50 €' },
    { value: 'M 3027 C3 - 15.50 €', label: 'M 3027 C3 - 15.50 €' },
    { value: 'M 3027 C5 - 15.50 €', label: 'M 3027 C5 - 15.50 €' },
    { value: 'M 3027 C6 - 15.50 €', label: 'M 3027 C6 - 15.50 €' },
    { value: 'M 3037 C1 - 15.50 €', label: 'M 3037 C1 - 15.50 €' },
    { value: 'M 3037 C6 - 15.50 €', label: 'M 3037 C6 - 15.50 €' },
    { value: 'M 3060 C2 - 15.50 €', label: 'M 3060 C2 - 15.50 €' },
    { value: 'M 3060 C3 - 15.50 €', label: 'M 3060 C3 - 15.50 €' },
    { value: 'M 3061 C3 - 15.50 €', label: 'M 3061 C3 - 15.50 €' },
    { value: 'M 3061 C6 - 15.50 €', label: 'M 3061 C6 - 15.50 €' },
    { value: 'OU 4059 C1 - 15.50 €', label: 'OU 4059 C1 - 15.50 €' },
    { value: 'OU 4152 C3 - 15.50 €', label: 'OU 4152 C3 - 15.50 €' },
    { value: '0U 4160 C1 - 15.50 €', label: '0U 4160 C1 - 15.50 €' },
    { value: 'OU 4160 C2 - 15.50 €', label: 'OU 4160 C2 - 15.50 €' },
    { value: 'OU 4160 C3 - 15.50 €', label: 'OU 4160 C3 - 15.50 €' },
    { value: 'OU 4160 C4 - 15.50 €', label: 'OU 4160 C4 - 15.50 €' },
    { value: 'OU 4235 C3 - 15.50 €', label: 'OU 4235 C3 - 15.50 €' },
    { value: 'OU 4235 C4 - 15.50 €', label: 'OU 4235 C4 - 15.50 €' },
    { value: 'OU 4316 C1 - 15.50 €', label: 'OU 4316 C1 - 15.50 €' },
    { value: 'OU 4316 C2 - 15.50 €', label: 'OU 4316 C2 - 15.50 €' },
    { value: 'OU 4316 C3 - 15.50 €', label: 'OU 4316 C3 - 15.50 €' },
    { value: 'OU 4316 C4 - 15.50 €', label: 'OU 4316 C4 - 15.50 €' },
    { value: 'OU 4333 C1 - 15.50 €', label: 'OU 4333 C1 - 15.50 €' },
    { value: 'OU 4333 C2 - 15.50 €', label: 'OU 4333 C2 - 15.50 €' },
    { value: 'OU 4333 C3 - 15.50 €', label: 'OU 4333 C3 - 15.50 €' },
    { value: 'OU 4333 C4 - 15.50 €', label: 'OU 4333 C4 - 15.50 €' },
    { value: 'OU 4339 C1 - 15.50 €', label: 'OU 4339 C1 - 15.50 €' },
    { value: 'OU 4339 C4 - 15.50 €', label: 'OU 4339 C4 - 15.50 €' },
    { value: 'OU 4340 C1 - 15.50 €', label: 'OU 4340 C1 - 15.50 €' },
    { value: 'OU 4340 C2 - 15.50 €', label: 'OU 4340 C2 - 15.50 €' },
    { value: 'OU 4340 C4 - 15.50 €', label: 'OU 4340 C4 - 15.50 €' },
    { value: 'OU 4393 C2 - 15.50 €', label: 'OU 4393 C2 - 15.50 €' },
    { value: 'OU 4393 C4 - 15.50 €', label: 'OU 4393 C4 - 15.50 €' },
    { value: 'OU 4770 C1 - 15.50 €', label: 'OU 4770 C1 - 15.50 €' },
    { value: 'OU 4770 C2 - 15.50 €', label: 'OU 4770 C2 - 15.50 €' },
    { value: 'OU 4770 C3 - 15.50 €', label: 'OU 4770 C3 - 15.50 €' },
    { value: 'OU 4770 C4 - 15.50 €', label: 'OU 4770 C4 - 15.50 €' },
    { value: 'OU 4402 C1 - 15.50 €', label: 'OU 4402 C1 - 15.50 €' },
    { value: 'OU 4402 C3 - 15.50 €', label: 'OU 4402 C3 - 15.50 €' },
    { value: 'OU 4402 C4 - 15.50 €', label: 'OU 4402 C4 - 15.50 €' },
    { value: 'OU 4059 C3 - 15.50 €', label: 'OU 4059 C3 - 15.50 €' },
    { value: 'OU 4152 C1 - 15.50 €', label: 'OU 4152 C1 - 15.50 €' },
    { value: 'OU 4152 C3 - 15.50 €', label: 'OU 4152 C3 - 15.50 €' },
    { value: 'OU 4770 C4 - 15.50 €', label: 'OU 4770 C4 - 15.50 €' },
    { value: 'OU 4402 C1 - 15.50 €', label: 'OU 4402 C1 - 15.50 €' },
    { value: 'OU 4402 C3 - 15.50 €', label: 'OU 4402 C3 - 15.50 €' },
    { value: 'OU 4402 C4 - 15.50 €', label: 'OU 4402 C4 - 15.50 €' },
    { value: 'OU 4412 C1 - 15.50 €', label: 'OU 4412 C1 - 15.50 €' },
    { value: 'OU 4412 C4 - 15.50 €', label: 'OU 4412 C4 - 15.50 €' },
    { value: 'OU 4442 C2 - 15.50 €', label: 'OU 4442 C2 - 15.50 €' },
    { value: 'OU 4442 C4 - 15.50 €', label: 'OU 4442 C4 - 15.50 €' },
    { value: 'OU 4453 C1 - 15.50 €', label: 'OU 4453 C1 - 15.50 €' },
    { value: 'OU 4453 C2 - 15.50 €', label: 'OU 4453 C2 - 15.50 €' },
    { value: 'OU 4453 C3 - 15.50 €', label: 'OU 4453 C3 - 15.50 €' },
    { value: 'OU 4453 C4 - 15.50 €', label: 'OU 4453 C4 - 15.50 €' },
    { value: 'OU 4469 C1 - 15.50 €', label: 'OU 4469 C1 - 15.50 €' },
    { value: 'OU 4469 C2 - 15.50 €', label: 'OU 4469 C2 - 15.50 €' },
    { value: 'OU 4469 C4 - 15.50 €', label: 'OU 4469 C4 - 15.50 €' },
    { value: 'OU 4537 C2 - 15.50 €', label: 'OU 4537 C2 - 15.50 €' },
    { value: 'OU 4537 C3 - 15.50 €', label: 'OU 4537 C3 - 15.50 €' },
    { value: 'OU 4537 C4 - 15.50 €', label: 'OU 4537 C4 - 15.50 €' },
    { value: 'OU 4600 C1 - 15.50 €', label: 'OU 4600 C1 - 15.50 €' },
    { value: 'OU 4600 C2 - 15.50 €', label: 'OU 4600 C2 - 15.50 €' },
    { value: 'OU 4600 C3 - 15.50 €', label: 'OU 4600 C3 - 15.50 €' },
    { value: 'OU 4600 C4 - 15.50 €', label: 'OU 4600 C4 - 15.50 €' },
    { value: 'OU 4667 C2 - 15.50 €', label: 'OU 4667 C2 - 15.50 €' },
    { value: 'OU 4667 C3 - 15.50 €', label: 'OU 4667 C3 - 15.50 €' },
    { value: 'OU 4667 C4 - 15.50 €', label: 'OU 4667 C4 - 15.50 €' },
    { value: 'OU 1102 C1 - 15.50 €', label: 'OU 1102 C1 - 15.50 €' },
    { value: 'OU 1102 C2 - 15.50 €', label: 'OU 1102 C2 - 15.50 €' },
    { value: 'OU 1462 C1 - 15.50 €', label: 'OU 1462 C1 - 15.50 €' },
    { value: 'OU 1462 C3 - 15.50 €', label: 'OU 1462 C3 - 15.50 €' },
    { value: 'OU 1462 C4 - 15.50 €', label: 'OU 1462 C4 - 15.50 €' },
    { value: 'OU A4513 C1 - 15.50 €', label: 'OU A4513 C1 - 15.50 €' },
    { value: 'OU A4513 C2 - 15.50 €', label: 'OU A4513 C2 - 15.50 €' },
    { value: 'OU A4515 C2 - 15.50 €', label: 'OU A4515 C2 - 15.50 €' },
    { value: 'OU A4515 C3 - 15.50 €', label: 'OU A4515 C3 - 15.50 €' },
    { value: 'OU A4514 C2 - 15.50 €', label: 'OU A4514 C2 - 15.50 €' },
    { value: 'OU 4402 C1 - 15.50 €', label: 'OU 4402 C1 - 15.50 €' },
    { value: 'OU 4402 C3 - 15.50 €', label: 'OU 4402 C3 - 15.50 €' },
    { value: 'OU 4402 C4 - 15.50 €', label: 'OU 4402 C4 - 15.50 €' },
    { value: 'OU 4412 C1 - 15.50 €', label: 'OU 4412 C1 - 15.50 €' },
    { value: ' OU 2726 C1 - 15.50 €', label: ' OU 2726 C1 - 15.50 €' },
    { value: ' OU 2726 C2 - 15.50 €', label: ' OU 2726 C2 - 15.50 €' },
    { value: ' OU 2726 C3 - 15.50 €', label: ' OU 2726 C3 - 15.50 €' },
    { value: 'OU 2504 C1 - 15.50 €', label: 'OU 2504 C1 - 15.50 €' },
    { value: 'OU 2504 C2 - 15.50 €', label: 'OU 2504 C2 - 15.50 €' },
    { value: 'OU 2307 C3 - 15.50 €', label: 'OU 2307 C3 - 15.50 €' },
    { value: 'OU 2307 C8 - 15.50 €', label: 'OU 2307 C8 - 15.50 €' },
    { value: 'OU 2307 C5 - 15.50 €', label: 'OU 2307 C5 - 15.50 €' },
    { value: 'OU 2156 C1 - 15.50 €', label: 'OU 2156 C1 - 15.50 €' },
    { value: 'OU 2156 C2 - 15.50 €', label: 'OU 2156 C2 - 15.50 €' },
    { value: 'OU 2156 C3 - 15.50 €', label: 'OU 2156 C3 - 15.50 €' },
    { value: 'OU 2156 C4 - 15.50 €', label: 'OU 2156 C4 - 15.50 €' },
    { value: 'OU 2073 C1 - 15.50 €', label: 'OU 2073 C1 - 15.50 €' },
    { value: 'OU 2073 C2 - 15.50 €', label: 'OU 2073 C2 - 15.50 €' },
    { value: 'OU 2073 C3 - 15.50 €', label: 'OU 2073 C3 - 15.50 €' },
    { value: 'OU 2058 C2 - 15.50 €', label: 'OU 2058 C2 - 15.50 €' },
    { value: 'OU 2058 C3 - 15.50 €', label: 'OU 2058 C3 - 15.50 €' },
    { value: 'OU 2058 C4 - 15.50 €', label: 'OU 2058 C4 - 15.50 €' },
    { value: 'OU 1330 C1 - 15.50 €', label: 'OU 1330 C1 - 15.50 €' },
    { value: 'OU 1330 C2 - 15.50 €', label: 'OU 1330 C2 - 15.50 €' },
    { value: 'OU 1330 C4 - 15.50 €', label: 'OU 1330 C4 - 15.50 €' },
    { value: 'OU 1414 C1 - 15.50 €', label: 'OU 1414 C1 - 15.50 €' },
    { value: 'OU 1414 C2 - 15.50 €', label: 'OU 1414 C2 - 15.50 €' },
    { value: 'OU 1414 C3 - 15.50 €', label: 'OU 1414 C3 - 15.50 €' },
    { value: 'OU 1414 C4 - 15.50 €', label: 'OU 1414 C4 - 15.50 €' },
    { value: 'OU 1714 C4 - 15.50 €', label: 'OU 1714 C4 - 15.50 €' },
    { value: 'OU 1991 C3 - 15.50 €', label: 'OU 1991 C3 - 15.50 €' },
    { value: 'OU 1991 C4 - 15.50 €', label: 'OU 1991 C4 - 15.50 €' },
    { value: 'OU 4247 C1  - 15.50 €', label: 'OU 4247 C1  - 15.50 €' },
    { value: 'OU 4247 C2 - 15.50 €', label: 'OU 4247 C2 - 15.50 €' },
    { value: 'OU 4247 C3 - 15.50 €', label: 'OU 4247 C3 - 15.50 €' },
    { value: 'OU 4308 C1 - 15.50 €', label: 'OU 4308 C1 - 15.50 €' },
    { value: 'OU 4308 C2 - 15.50 €', label: 'OU 4308 C2 - 15.50 €' },
    { value: 'OU 4308 C3 - 15.50 €', label: 'OU 4308 C3 - 15.50 €' },
    { value: 'OU 4457 C2  - 15.50 €', label: 'OU 4457 C2  - 15.50 €' },
    { value: 'OU 4466 C1  - 15.50 €', label: 'OU 4466 C1  - 15.50 €' },
    { value: 'OU 4539 C3  - 15.50 €', label: 'OU 4539 C3  - 15.50 €' },
    { value: 'OU 4539 C4 - 15.50 €', label: 'OU 4539 C4 - 15.50 €' },
    { value: 'OU 4544 C2  - 15.50 €', label: 'OU 4544 C2  - 15.50 €' },
    { value: 'OU 4544 C4 - 15.50 €', label: 'OU 4544 C4 - 15.50 €' },
    { value: 'OU 4550 C1 - 15.50 €', label: 'OU 4550 C1 - 15.50 €' },
    { value: 'OU 4550 C2 - 15.50 €', label: 'OU 4550 C2 - 15.50 €' },
    { value: 'OU 4550 C3 - 15.50 €', label: 'OU 4550 C3 - 15.50 €' },
    { value: 'OU 4550 C4 - 15.50 €', label: 'OU 4550 C4 - 15.50 €' },
    { value: 'OU 4553 C1 - 15.50 €', label: 'OU 4553 C1 - 15.50 €' },
    { value: 'OU 4553 C2 - 15.50 €', label: 'OU 4553 C2 - 15.50 €' },
    { value: 'OU 4553 C3 - 15.50 €', label: 'OU 4553 C3 - 15.50 €' },
    { value: 'OU 4553 C4 - 15.50 €', label: 'OU 4553 C4 - 15.50 €' },
    { value: 'OU 4667 C1  - 15.50 €', label: 'OU 4667 C1  - 15.50 €' },
    { value: 'OU 4667 C4 - 15.50 €', label: 'OU 4667 C4 - 15.50 €' },
    { value: 'OU 4667 C3 - 15.50 €', label: 'OU 4667 C3 - 15.50 €' },
    { value: 'OU 4668 C1  - 15.50 €', label: 'OU 4668 C1  - 15.50 €' },
    { value: 'OU 4668 C2 - 15.50 €', label: 'OU 4668 C2 - 15.50 €' },
    { value: 'OU 4668 C3 - 15.50 €', label: 'OU 4668 C3 - 15.50 €' },
    { value: 'OU 4668 C4 - 15.50 €', label: 'OU 4668 C4 - 15.50 €' },
    { value: 'OU 4662H C1 - 15.50 €', label: 'OU 4662H C1 - 15.50 €' },
    { value: 'OU 4662H C2 - 15.50 €', label: 'OU 4662H C2 - 15.50 €' },
    { value: 'OU 4662H C3 - 15.50 €', label: 'OU 4662H C3 - 15.50 €' },
    { value: 'OU 4662H C4 - 15.50 €', label: 'OU 4662H C4 - 15.50 €' },
    { value: 'OU 4707 C2  - 15.50 €', label: 'OU 4707 C2  - 15.50 €' },
    { value: 'OU 4707 C3 - 15.50 €', label: 'OU 4707 C3 - 15.50 €' },
    { value: 'OU 4059 C1 - 15.50 €', label: 'OU 4059 C1 - 15.50 €' },
    { value: 'OU 4059 C4 - 15.50 €', label: 'OU 4059 C4 - 15.50 €' },
    { value: 'OU 4059 C3 - 15.50 €', label: 'OU 4059 C3 - 15.50 €' },
    { value: 'OU 4060 C1 - 15.50 €', label: 'OU 4060 C1 - 15.50 €' },
    { value: 'OU 4060 C2 - 15.50 €', label: 'OU 4060 C2 - 15.50 €' },
    { value: 'OU 4060 C3 - 15.50 €', label: 'OU 4060 C3 - 15.50 €' },
    { value: 'OU 4060 C4 - 15.50 €', label: 'OU 4060 C4 - 15.50 €' },
    { value: 'OU 4307 C1 - 15.50 €', label: 'OU 4307 C1 - 15.50 €' },
    { value: 'OU 4307 C2 - 15.50 €', label: 'OU 4307 C2 - 15.50 €' },
    { value: 'OU 4307 C3 - 15.50 €', label: 'OU 4307 C3 - 15.50 €' },
    { value: 'OU 4307 C4 - 15.50 €', label: 'OU 4307 C4 - 15.50 €' },
    { value: 'OU 4308 C4  - 15.50 €', label: 'OU 4308 C4  - 15.50 €' },
    { value: 'OU 4561 C1  - 15.50 €', label: 'OU 4561 C1  - 15.50 €' },
    { value: 'OU 4561 C2 - 15.50 €', label: 'OU 4561 C2 - 15.50 €' },
    { value: 'OU 4561 C3 - 15.50 €', label: 'OU 4561 C3 - 15.50 €' },
    { value: 'OU 4619 C1 - 15.50 €', label: 'OU 4619 C1 - 15.50 €' },
    { value: 'OU 4619 C2 - 15.50 €', label: 'OU 4619 C2 - 15.50 €' },
    { value: 'OU 4619 C3 - 15.50 €', label: 'OU 4619 C3 - 15.50 €' },
    { value: 'OU 4619 C4 - 15.50 €', label: 'OU 4619 C4 - 15.50 €' },
    { value: 'OU 2073 C4 - 15.50 €', label: 'OU 2073 C4 - 15.50 €' },
    { value: 'OU 2108 C3 - 15.50 €', label: 'OU 2108 C3 - 15.50 €' },
    { value: 'OU 2108 C4 - 15.50 €', label: 'OU 2108 C4 - 15.50 €' },
    { value: 'OU 2308 C1 - 15.50 €', label: 'OU 2308 C1 - 15.50 €' },
    { value: 'OU 2308 C2 - 15.50 €', label: 'OU 2308 C2 - 15.50 €' },
    { value: 'OU 2308 C3 - 15.50 €', label: 'OU 2308 C3 - 15.50 €' },
    { value: 'OU 2308 C7 - 15.50 €', label: 'OU 2308 C7 - 15.50 €' },
    { value: 'OU 2308 C5 - 15.50 €', label: 'OU 2308 C5 - 15.50 €' },
    { value: 'OU 2385 C1  - 15.50 €', label: 'OU 2385 C1  - 15.50 €' },
    { value: 'OU 2385 C4 - 15.50 €', label: 'OU 2385 C4 - 15.50 €' },
    { value: 'OU 2747 C1  - 15.50 €', label: 'OU 2747 C1  - 15.50 €' },
    { value: 'OU 2747 C2 - 15.50 €', label: 'OU 2747 C2 - 15.50 €' },
    { value: 'OU 2747 C3 - 15.50 €', label: 'OU 2747 C3 - 15.50 €' },
    { value: 'OU 2747 C4 - 15.50 €', label: 'OU 2747 C4 - 15.50 €' },
    // --- Nouvelles montures Sym ajoutées le 2026-09-17 ---
    { value: 'F-3301 - 15.50 €', label: 'F-3301 - 15.50 €' },
    { value: 'F-3306 - 15.50 €', label: 'F-3306 - 15.50 €' },
    { value: 'F-3363 - 15.50 €', label: 'F-3363 - 15.50 €' },
    { value: 'FP-2206 - 15.50 €', label: 'FP-2206 - 15.50 €' },
    { value: 'M-3001 - 15.50 €', label: 'M-3001 - 15.50 €' },
    { value: 'M-3003 - 15.50 €', label: 'M-3003 - 15.50 €' },
    { value: 'M-3005 - 15.50 €', label: 'M-3005 - 15.50 €' },
    { value: 'M-3018 - 15.50 €', label: 'M-3018 - 15.50 €' },
    { value: 'M-3020 - 15.50 €', label: 'M-3020 - 15.50 €' },
    { value: 'M-3021 - 15.50 €', label: 'M-3021 - 15.50 €' },
    { value: 'M-3022 - 15.50 €', label: 'M-3022 - 15.50 €' },
    { value: 'M-3061 - 15.50 €', label: 'M-3061 - 15.50 €' },
    { value: 'OU-1801 - 15.50 €', label: 'OU-1801 - 15.50 €' },
    { value: 'OU-25040 - 15.50 €', label: 'OU-25040 - 15.50 €' },
    { value: 'OU-4060 - 15.50 €', label: 'OU-4060 - 15.50 €' },
    { value: 'OU-4410 - 15.50 €', label: 'OU-4410 - 15.50 €' },
    { value: 'OU-4451 - 15.50 €', label: 'OU-4451 - 15.50 €' },
    { value: 'OU-4454 - 15.50 €', label: 'OU-4454 - 15.50 €' },
    { value: 'OU-4455 - 15.50 €', label: 'OU-4455 - 15.50 €' },
    { value: 'OU-4542 - 15.50 €', label: 'OU-4542 - 15.50 €' },
    { value: 'OU-4543 - 15.50 €', label: 'OU-4543 - 15.50 €' },
    { value: 'OU-4550 - 15.50 €', label: 'OU-4550 - 15.50 €' },
    { value: 'OU-4565 - 15.50 €', label: 'OU-4565 - 15.50 €' },
    { value: 'OU-4666H - 15.50 €', label: 'OU-4666H - 15.50 €' },
    { value: 'OU-4668 - 15.50 €', label: 'OU-4668 - 15.50 €' },
    { value: 'OU-4696 - 15.50 €', label: 'OU-4696 - 15.50 €' },
    { value: 'OU-4708 - 15.50 €', label: 'OU-4708 - 15.50 €' },
    { value: 'OU-4725 - 15.50 €', label: 'OU-4725 - 15.50 €' },
    { value: 'OU-4759 - 15.50 €', label: 'OU-4759 - 15.50 €' },
    { value: 'OU-4764H - 15.50 €', label: 'OU-4764H - 15.50 €' },
    { value: 'OU-7680 - 15.50 €', label: 'OU-7680 - 15.50 €' },
    { value: 'OU-S0003 - 15.50 €', label: 'OU-S0003 - 15.50 €' },
    { value: 'TR-99012 - 15.50 €', label: 'TR-99012 - 15.50 €' },
    { value: 'TR-99066 - 15.50 €', label: 'TR-99066 - 15.50 €' },
    { value: 'XB-2163 - 15.50 €', label: 'XB-2163 - 15.50 €' },
    { value: 'XB-2171 - 15.50 €', label: 'XB-2171 - 15.50 €' },
    { value: 'XB-2174 - 15.50 €', label: 'XB-2174 - 15.50 €' },
    { value: 'XB-2181 - 15.50 €', label: 'XB-2181 - 15.50 €' },
    { value: 'XB-2185 - 15.50 €', label: 'XB-2185 - 15.50 €' },
];
///////////////////////////////////////////

///////////////Type de Monture//////////////////////
export const frameTypeA1 = [
    { value: '', label: '' },
    { value: 'Metal - 0.00 €', label: 'Metal - 0.00 €' },
    { value: 'Nylor - 0.00 €', label: 'Nylor - 0.00 €' },
    { value: 'Plastic - 0.00 €', label: 'Plastic - 0.00 €' },
];
////////////////////////////////////////

export const Supplier = [
    { value: '', label: '' },
    { value: 'Conant', label: 'Conant' },
    { value: 'VRX', label: 'VRX' },
    { value: 'Koptical', label: 'Koptical' },
    // { value: 'Shamir', label: 'Shamir' },
    // { value: 'Inconnu', label: 'Inconnu' },
];
export const Nooption = [];
